let AdobeAn;
let exportRoot;
import createjs from 'createjs';
/* eslint-disable */
(function(cjs, an) {
    let p; // shortcut to reference prototypes
    let lib={};let ss={};let img={};
    let rect; // used to reference frame bounds
    lib.ssMetadata = [];

    // symbols:

    (lib.map11 = function() {
        this.initialize(img.map11);
    }).prototype = p = new cjs.Bitmap();
    p.nominalBounds = new cjs.Rectangle(0, 0, 4000, 2394); // helper functions:

    function mc_symbol_clone() {
        let clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop));
        clone.gotoAndStop(this.currentFrame);
        clone.paused = this.paused;
        clone.framerate = this.framerate;
        return clone;
    }

    function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
        let prototype = cjs.extend(symbol, cjs.MovieClip);
        prototype.clone = mc_symbol_clone;
        prototype.nominalBounds = nominalBounds;
        prototype.frameBounds = frameBounds;
        return prototype;
    }

    (lib.Symbol54 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .lf(['#B29F9B', '#A29390'], [0, 1], -0.2, -0.5, 0.2, 0.4)
            .s()
            .p('Ag1AaIBrg+IAAAMIgEACIAAgHIhjA5IAAAHIgEACg');
        this.shape.setTransform(-0.7, -7.6);

        this.shape_1 = new cjs.Shape();
        this.shape_1.graphics
            .f('#DACBBF')
            .s()
            .p('AgBAFIAAgLIADADIAAAKg');
        this.shape_1.setTransform(-6.3, -4.6);

        this.shape_2 = new cjs.Shape();
        this.shape_2.graphics
            .f('#F1ECE6')
            .s()
            .p('Ag3AeIBrg9IAEACIhrA9g');
        this.shape_2.setTransform(-0.9, -8.3);

        this.shape_3 = new cjs.Shape();
        this.shape_3.graphics
            .f('#DACBBF')
            .s()
            .p('AgBACIAAgFIADAHg');
        this.shape_3.setTransform(4.1, -10.4);

        this.shape_4 = new cjs.Shape();
        this.shape_4.graphics
            .lf(['#807877', '#B29F9B'], [0, 1], -0.2, -0.3, 0.2, 0.4)
            .s()
            .p('AgBACIAAgFIADACIAAAGg');
        this.shape_4.setTransform(4.1, -10.3);

        this.shape_5 = new cjs.Shape();
        this.shape_5.graphics
            .f('#B29F9B')
            .s()
            .p('Ag5AgIgEgCIAEgCIAHAAIBjg5IgHAAIAEgDIAMAAIAEADIhrA9g');
        this.shape_5.setTransform(-0.3, -7.1);

        this.shape_6 = new cjs.Shape();
        this.shape_6.graphics
            .lf(['#B29F9B', '#A29390'], [0, 1], -0.2, -0.5, 0.2, 0.3)
            .s()
            .p('Ag1AaIBrg+IAAALIgEADIAAgGIhjA4IAAAHIgEACg');
        this.shape_6.setTransform(-8.7, -12.2);

        this.shape_7 = new cjs.Shape();
        this.shape_7.graphics
            .f('#DACBBF')
            .s()
            .p('AgBAFIAAgLIADADIAAAKg');
        this.shape_7.setTransform(-14.3, -9.2);

        this.shape_8 = new cjs.Shape();
        this.shape_8.graphics
            .f('#F1ECE6')
            .s()
            .p('Ag3AeIBrg9IAEACIhrA+g');
        this.shape_8.setTransform(-8.9, -12.9);

        this.shape_9 = new cjs.Shape();
        this.shape_9.graphics
            .f('#DACBBF')
            .s()
            .p('AgBACIAAgFIADAHg');
        this.shape_9.setTransform(-4, -15);

        this.shape_10 = new cjs.Shape();
        this.shape_10.graphics
            .lf(['#807877', '#B29F9B'], [0, 1], -0.2, -0.3, 0.2, 0.4)
            .s()
            .p('AgBACIAAgGIADADIAAAGg');
        this.shape_10.setTransform(-4, -15);

        this.shape_11 = new cjs.Shape();
        this.shape_11.graphics
            .f('#B29F9B')
            .s()
            .p('Ag5AhIgEgDIAEgDIAHAAIBig4IgGAAIAEgDIALAAIAFADIhrA+g');
        this.shape_11.setTransform(-8.4, -11.8);

        this.shape_12 = new cjs.Shape();
        this.shape_12.graphics
            .lf(['#998B87', '#807877'], [0, 1], 0.3, 0, -0.4, 0)
            .s()
            .p('AAAADIAAgHIACACIAAAGg');
        this.shape_12.setTransform(2.9, 3.9);

        this.shape_13 = new cjs.Shape();
        this.shape_13.graphics
            .f('#B4A39F')
            .s()
            .p('AgIAEIAOgIIADACIgOAHg');
        this.shape_13.setTransform(3.7, 3);

        this.shape_14 = new cjs.Shape();
        this.shape_14.graphics
            .lf(['#B29F9B', '#998B87'], [0, 1], 26.3, 17.1, -96, -62.3)
            .s()
            .p('AgGAAIAOgHIAAAEIgMAFIAAAFIgCABg');
        this.shape_14.setTransform(3.8, 3.5);

        this.shape_15 = new cjs.Shape();
        this.shape_15.graphics
            .lf(['#998B87', '#807877'], [0, 1], 0.3, 0, -0.4, 0)
            .s()
            .p('AAAADIAAgHIABACIAAAHg');
        this.shape_15.setTransform(-3.6, 7.6);

        this.shape_16 = new cjs.Shape();
        this.shape_16.graphics
            .f('#B4A39F')
            .s()
            .p('AgIADIAOgHIADABIgOAIg');
        this.shape_16.setTransform(-2.9, 6.8);

        this.shape_17 = new cjs.Shape();
        this.shape_17.graphics
            .lf(['#B29F9B', '#998B87'], [0, 1], 26.3, 17.1, -96, -62.3)
            .s()
            .p('AgHABIAPgIIAAAEIgMAGIAAAEIgDABg');
        this.shape_17.setTransform(-2.7, 7.3);

        this.shape_18 = new cjs.Shape();
        this.shape_18.graphics
            .f('#6C5D4E')
            .s()
            .p('AiCAqIDVh7IAwgHIAAAbIgLAGIAAgFQAAgMgHgEQgIgFgKAHQgLAGgHANQgIAMAAANIAAAEIiOBSIAAgFQAAgMgIgEQgHgFgLAHQgKAGgIANQgHAMAAANIAAAEIgGAEg');
        this.shape_18.setTransform(4.1, 5.4);

        this.shape_19 = new cjs.Shape();
        this.shape_19.graphics
            .f('#F1ECE6')
            .s()
            .p('Ah7AJICKhQIBtA/IiKBQg');
        this.shape_19.setTransform(-4.9, -9.5);

        this.shape_20 = new cjs.Shape();
        this.shape_20.graphics
            .lf(['#B29F9B', '#998B87'], [0, 1], 1.6, 1, -1.9, -1)
            .s()
            .p('AgEADQAAgFAEgDQAAAAABAAQAAgBABAAQAAAAABAAQAAABABAAQAAAAAAAAQAAABABAAQAAABAAAAQAAABAAAAQAAAFgFADIgCABQAAAAgBgBQAAAAAAAAQgBgBAAgBQAAAAAAgBg');
        this.shape_20.setTransform(-5.8, 12.2);

        this.shape_21 = new cjs.Shape();
        this.shape_21.graphics
            .lf(['#615E61', '#998B87'], [0, 1], 2.7, -4.3, -1.3, 2.1)
            .s()
            .p('AgEAJQgCgBAAgEQAAgDACgDQACgEACgBQADgCACABQABABAAAAQABAAAAABQAAAAAAABQAAABAAABQAAAIgHADIgCABIgCAAg');
        this.shape_21.setTransform(-5.9, 12.2);

        this.shape_22 = new cjs.Shape();
        this.shape_22.graphics
            .lf(['#B29F9B', '#998B87'], [0, 1], 3.6, 2.1, -4, -2.2)
            .s()
            .p('AgFALQgDgBgBgFQAAgJAJgGQAEgCACACQADABABAFQAAAJgKAGIgDABIgCgBg');
        this.shape_22.setTransform(-5.8, 12.2);

        this.shape_23 = new cjs.Shape();
        this.shape_23.graphics
            .lf(['#B29F9B', '#998B87'], [0, 1], -0.8, -0.4, -4.5, -2.5)
            .s()
            .p('AgEADQAAgFAEgCQAFgEAAAGQAAAGgFACIgCABQAAAAgBAAQAAgBAAAAQgBgBAAAAQAAgBAAgBg');
        this.shape_23.setTransform(13.6, 0.8);

        this.shape_24 = new cjs.Shape();
        this.shape_24.graphics
            .lf(['#615E61', '#998B87'], [0, 1], 0.1, 0, -4, 6.5)
            .s()
            .p('AgEAJQgBAAAAgBQAAAAgBgBQAAAAAAgBQAAgBAAgBQAAgIAGgDQADgCACABQABAAAAABQABAAAAABQAAAAAAABQAAABAAABQAAAHgHAEIgCABIgCAAg');
        this.shape_24.setTransform(13.6, 0.8);

        this.shape_25 = new cjs.Shape();
        this.shape_25.graphics
            .lf(['#B29F9B', '#998B87'], [0, 1], 1.1, 0.7, -6.6, -3.7)
            .s()
            .p('AgGALQgDgBAAgFQAAgJAJgGQAEgCADACQACABAAAEQAAAFgCAEQgDAEgEADIgDABIgDgBg');
        this.shape_25.setTransform(13.6, 0.8);

        this.shape_26 = new cjs.Shape();
        this.shape_26.graphics
            .f('#F1ECE6')
            .s()
            .p('AgUgJIAEgCIAlAVIgDACg');
        this.shape_26.setTransform(-16.1, 8.8);

        this.shape_27 = new cjs.Shape();
        this.shape_27.graphics
            .lf(['#867C7C', '#998B87'], [0, 1], 0.7, 0, -0.6, 0)
            .s()
            .p('AgBgFIADgCIAAAMIgDADg');
        this.shape_27.setTransform(-14.2, 10.6);

        this.shape_28 = new cjs.Shape();
        this.shape_28.graphics
            .f('#DACBBF')
            .s()
            .p('AgSgEIAAgNIAlAVIAAAOg');
        this.shape_28.setTransform(-16.3, 9.6);

        this.shape_29 = new cjs.Shape();
        this.shape_29.graphics
            .f('#807877')
            .s()
            .p('AATAdIgqg7IACgBIAtA/g');
        this.shape_29.setTransform(9.3, -6.1);

        this.shape_30 = new cjs.Shape();
        this.shape_30.graphics
            .f('#B4A39F')
            .s()
            .p('AhaAwICxhlIABABIAEACIi3Bpg');
        this.shape_30.setTransform(2.5, 2.2);

        this.shape_31 = new cjs.Shape();
        this.shape_31.graphics
            .f('#6D5B60')
            .s()
            .p('AhHANIAthcIBiA5IgcBmg');
        this.shape_31.setTransform(-14.3, 0.3);

        this.shape_32 = new cjs.Shape();
        this.shape_32.graphics
            .f('#E7DCD1')
            .s()
            .p('AhPAQIAyhpIBtA/IgfBzg');
        this.shape_32.setTransform(-14.4, 0.4);

        this.shape_33 = new cjs.Shape();
        this.shape_33.graphics
            .f('#423538')
            .s()
            .p('AhMgMIB6hIIAuBAIi3Bpg');
        this.shape_33.setTransform(2.5, -0.8);

        this.shape_34 = new cjs.Shape();
        this.shape_34.graphics
            .f('#B29F9B')
            .s()
            .p('AhOgRICKhQIAyBFIjbB+g');
        this.shape_34.setTransform(1.5, -0.5);

        this.shape_35 = new cjs.Shape();
        this.shape_35.graphics
            .f('#837C7C')
            .s()
            .p('AikAgIDbh+IBuA/IjbB+g');
        this.shape_35.setTransform(-4.9, -0.7);

        this.shape_36 = new cjs.Shape();
        this.shape_36.graphics
            .f('#998B87')
            .s()
            .p('AitAbIDbh+ICABKIjbB9g');
        this.shape_36.setTransform(-4.9, -0.7);

        this.shape_37 = new cjs.Shape();
        this.shape_37.graphics
            .f('#B2E0EC')
            .s()
            .p('AimAfIDbh+IByBCIjbB9g');
        this.shape_37.setTransform(-4.2, -0.3);

        this.shape_38 = new cjs.Shape();
        this.shape_38.graphics
            .lf(['#B29F9B', '#998B87'], [0, 1], -3.7, -6.7, 0.8, 1.4)
            .s()
            .p('AiHApIDbh+IA0gIIAAAgIgVALIAAgEQAAgLgGgDQgGgDgIAEQgJAGgGAKQgGAKAAAKIAAAFIiYBXIAAgFQAAgKgGgDQgGgDgIAFQgJAEgGALQgGAKAAAKIAAAFIgQAJg');
        this.shape_38.setTransform(4.1, 5.2);

        this.shape_39 = new cjs.Shape();
        this.shape_39.graphics
            .f('#F3787F')
            .s()
            .p('AgLgEIAEgCIATAKIgDADg');
        this.shape_39.setTransform(-21.2, 4.1);

        this.shape_40 = new cjs.Shape();
        this.shape_40.graphics
            .f('#CC656E')
            .s()
            .p('AgJADIAAgRIATALIAAASg');
        this.shape_40.setTransform(-21.4, 5.2);

        this.shape_41 = new cjs.Shape();
        this.shape_41.graphics
            .f('#F3787F')
            .s()
            .p('AgLgEIAEgCIATALIgEACg');
        this.shape_41.setTransform(-11, 10);

        this.shape_42 = new cjs.Shape();
        this.shape_42.graphics
            .lf(['#632F32', '#CC656E'], [0, 1], 0.5, 0, -1, 0)
            .s()
            .p('AgBgHIADgDIAAASIgDADg');
        this.shape_42.setTransform(-20.2, 5.6);

        this.shape_43 = new cjs.Shape();
        this.shape_43.graphics
            .lf(['#632F32', '#CC656E'], [0, 1], 0.6, 0, -0.9, 0)
            .s()
            .p('AgBgHIADgCIAAARIgDACg');
        this.shape_43.setTransform(-10, 11.5);

        this.shape_44 = new cjs.Shape();
        this.shape_44.graphics
            .f('#CC656E')
            .s()
            .p('AgJAEIAAgSIATALIAAASg');
        this.shape_44.setTransform(-11.2, 11);

        this.shape_45 = new cjs.Shape();
        this.shape_45.graphics
            .lf(['#B29F9B', '#807877'], [0, 1], 0.2, 0.3, -0.1, -0.4)
            .s()
            .p('AhNArICYhXIADACIiYBXg');
        this.shape_45.setTransform(4, 7);

        this.shape_46 = new cjs.Shape();
        this.shape_46.graphics
            .f('#6D6769')
            .s()
            .p('AgBADIAAgIIADADIAAAHg');
        this.shape_46.setTransform(-3.6, 11.9);

        this.shape_47 = new cjs.Shape();
        this.shape_47.graphics
            .f('#6D6769')
            .s()
            .p('AgBAEIAAgIIADABIAAAJg');
        this.shape_47.setTransform(15.8, 0.7);

        this.shape_48 = new cjs.Shape();
        this.shape_48.graphics
            .lf(['#615E61', '#998B87'], [0, 1], 1.3, 2.3, -0.6, -1.1)
            .s()
            .p('AiLBMIAUgMIAAAJIgUAMgAhOApICYhXIAAAJIiYBWgAB0hHIAXgNIAAAIIgXAPg');
        this.shape_48.setTransform(4.5, 7.5);

        this.shape_49 = new cjs.Shape();
        this.shape_49.graphics
            .f('#DACBBF')
            .s()
            .p('AhDgiIAAgJICHBOIAAAJg');
        this.shape_49.setTransform(-16.3, 11.6);

        this.shape_50 = new cjs.Shape();
        this.shape_50.graphics
            .f('#A39290')
            .s()
            .p('AArAlIgEgJIAAgSIAUALIAEAKIAAASgAgRAPIgDgJIAAgNIAlAWIAEAJIAAANgAg6gUIgEgKIAAgSIAUALIAEAKIAAASg');
        this.shape_50.setTransform(-15.7, 8.3);

        this.shape_51 = new cjs.Shape();
        this.shape_51.graphics
            .f('#B29F9B')
            .s()
            .p('AhBgkIAEAAIB/BJIgEAAg');
        this.shape_51.setTransform(6.3, -7.1);

        this.shape_52 = new cjs.Shape();
        this.shape_52.graphics
            .f('#E7DCD1')
            .s()
            .p('AhZggIA0gIIB/BJIgzAIg');
        this.shape_52.setTransform(8.7, -7.5);

        this.shape_53 = new cjs.Shape();
        this.shape_53.graphics
            .f('#DACBBF')
            .s()
            .p('Ag/gJIAAg1IB/BIIAAA2g');
        this.shape_53.setTransform(-15.9, 8.3);

        this.shape_54 = new cjs.Shape();
        this.shape_54.graphics
            .f('#031B1B')
            .s()
            .p('AgMAWQgFgDAAgJQAAgIAFgJQAGgJAGgEQAIgFAFADQAFAEAAAIQAAAJgFAJQgFAJgIAEQgDADgEAAIgFgCg');
        this.shape_54.setTransform(13.6, 0.8);

        this.shape_55 = new cjs.Shape();
        this.shape_55.graphics
            .f('#000000')
            .s()
            .p('AgGAaIgMgHQgGgEAAgIQAAgHAGgKQAGgJAGgFQAHgEAGADIAMAHQAGADAAAJQAAAJgGAIQgFAKgHAEQgFACgDAAIgFgBg');
        this.shape_55.setTransform(12.9, 0.4);

        this.shape_56 = new cjs.Shape();
        this.shape_56.graphics
            .lf(['#B29F9B', '#807877'], [0, 1], 0.1, 0.7, -0.3, 0)
            .s()
            .p('AgJAKIAAgSIATAKIgLAIg');
        this.shape_56.setTransform(-8.5, 13.7);

        this.shape_57 = new cjs.Shape();
        this.shape_57.graphics
            .f('#F1ECE6')
            .s()
            .p('AhNgfIAZgOICCBQIgUALg');
        this.shape_57.setTransform(-15.3, 10.4);

        this.shape_58 = new cjs.Shape();
        this.shape_58.graphics
            .f('#6D6769')
            .s()
            .p('Ag4gMIAAgoIBxBBIAAAog');
        this.shape_58.setTransform(9.9, -4.3);

        this.shape_59 = new cjs.Shape();
        this.shape_59.graphics
            .f('#031B1B')
            .s()
            .p('AgMAWQgFgDAAgIQAAgJAFgIQAGgKAGgEQAIgFAFADQAFAEAAAIQAAAJgFAJQgFAJgIAEQgDADgEAAIgFgCg');
        this.shape_59.setTransform(-5.9, 12.2);

        this.shape_60 = new cjs.Shape();
        this.shape_60.graphics
            .f('#000000')
            .s()
            .p('AgFAaIgNgHQgGgDAAgJQAAgIAGgJQAGgKAHgEQAGgFAGAEIANAIQAFACAAAJQAAAIgFAJQgGAJgHAFQgEADgDAAQgDAAgCgCg');
        this.shape_60.setTransform(-6.5, 11.9);

        this.shape_61 = new cjs.Shape();
        this.shape_61.graphics
            .f('#6D6769')
            .s()
            .p('Ag/gQIAAgoIB/BJIAAAog');
        this.shape_61.setTransform(-10.2, 6.5);

        this.shape_62 = new cjs.Shape();
        this.shape_62.graphics
            .lf(['#B29F9B', '#807877'], [0, 1], 3.5, 6.3, 3.1, 5.5)
            .s()
            .p('AhPgfIAZgOICGBOIgYANg');
        this.shape_62.setTransform(10.4, -4.3);

        this.shape_63 = new cjs.Shape();
        this.shape_63.graphics
            .f('#615E61')
            .s()
            .p(
                'AhLB0IiIhPIAZgOIAEADIAEgDIB1BEIABgBQAFgDANgEQAOgEAHAAQAJAAAAADQABADgGAFQgMAGgSAEIAFACIgYAOgAgJBOIgFgCICYhYIAJAAIAEADIiYBXgAB/gPQgCgEAIgFQAUgKAUAAQAJAAAAADQABAEgIADQgHAFgMAEQgMACgIAAQgIAAgBgCgAC3ghIh5hHIATgLIAEACIAFgCIB6BHIgUALg'
            );
        this.shape_63.setTransform(-1.1, 5.1);

        this.shape_64 = new cjs.Shape();
        this.shape_64.graphics
            .f('#615E61')
            .s()
            .p('AhaBzIiAhKIAQgJIAEAAIAtgLIgDgNIgFAAIBmg6IAFAAIBegpIgDgLIgFAAIAUgMIAgAAICABKIgcAbIAjATIiLBQIh1Adg');
        this.shape_64.setTransform(1.2, 4.7);

        this.timeline.addTween(
            cjs.Tween.get({})
                .to({
                    state: [
                        {t: this.shape_64},
                        {t: this.shape_63},
                        {t: this.shape_62},
                        {t: this.shape_61},
                        {t: this.shape_60},
                        {t: this.shape_59},
                        {t: this.shape_58},
                        {t: this.shape_57},
                        {t: this.shape_56},
                        {t: this.shape_55},
                        {t: this.shape_54},
                        {t: this.shape_53},
                        {t: this.shape_52},
                        {t: this.shape_51},
                        {t: this.shape_50},
                        {t: this.shape_49},
                        {t: this.shape_48},
                        {t: this.shape_47},
                        {t: this.shape_46},
                        {t: this.shape_45},
                        {t: this.shape_44},
                        {t: this.shape_43},
                        {t: this.shape_42},
                        {t: this.shape_41},
                        {t: this.shape_40},
                        {t: this.shape_39},
                        {t: this.shape_38},
                        {t: this.shape_37},
                        {t: this.shape_36},
                        {t: this.shape_35},
                        {t: this.shape_34},
                        {t: this.shape_33},
                        {t: this.shape_32},
                        {t: this.shape_31},
                        {t: this.shape_30},
                        {t: this.shape_29},
                        {t: this.shape_28},
                        {t: this.shape_27},
                        {t: this.shape_26},
                        {t: this.shape_25},
                        {t: this.shape_24},
                        {t: this.shape_23},
                        {t: this.shape_22},
                        {t: this.shape_21},
                        {t: this.shape_20},
                        {t: this.shape_19},
                        {t: this.shape_18},
                        {t: this.shape_17},
                        {t: this.shape_16},
                        {t: this.shape_15},
                        {t: this.shape_14},
                        {t: this.shape_13},
                        {t: this.shape_12},
                        {t: this.shape_11},
                        {t: this.shape_10},
                        {t: this.shape_9},
                        {t: this.shape_8},
                        {t: this.shape_7},
                        {t: this.shape_6},
                        {t: this.shape_5},
                        {t: this.shape_4},
                        {t: this.shape_3},
                        {t: this.shape_2},
                        {t: this.shape_1},
                        {t: this.shape}
                    ]
                })
                .wait(1)
        );
    }).prototype = getMCSymbolPrototype(lib.Symbol54, (rect = new cjs.Rectangle(-23.1, -16.6, 46.3, 33.3)), [rect]);

    (lib.Symbol53 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .lf(['#E5BB76', '#907051'], [0, 1], 1.7, 1, -3.3, -1.9)
            .s()
            .p('AgIAKIABgCIAEgGIACgEIAFgKIAFADIgMAWg');
        this.shape.setTransform(-2.3, 16.2);

        this.shape_1 = new cjs.Shape();
        this.shape_1.graphics
            .lf(['#001511', '#112220'], [0, 1], -2.2, 8.2, 0.8, -2.9)
            .s()
            .p('AgrgQIAAgFIBXAyIAAAEgAgrgYIAAgCIAAgGIBXAxIAAAJg');
        this.shape_1.setTransform(-7.5, 13.8);

        this.shape_2 = new cjs.Shape();
        this.shape_2.graphics
            .lf(['#A27F5C', '#795F41'], [0, 1], 4, -6.4, -3.8, 7)
            .s()
            .p('AgwgDIAAgWIAFADIBXAxIAAABIAEACIAAAWgAgrgcIAAgCIBXAxIAAADgAgrgnIAAgMIAIAFIAEADIAUALIApAYIAOAIIAAALg');
        this.shape_2.setTransform(-7.5, 14.4);

        this.shape_3 = new cjs.Shape();
        this.shape_3.graphics
            .lf(['#E5BB76', '#907051'], [0, 1], 11.2, 6.4, 5.8, 3.3)
            .s()
            .p('AgIAKIAFgIIAAACIAAACIAAAGgAAEgLIAEADIAAAAg');
        this.shape_3.setTransform(-11.5, 10.9);

        this.shape_4 = new cjs.Shape();
        this.shape_4.graphics
            .lf(['#001511', '#112220'], [0, 1], -1.7, 6.7, 0.7, -2.4)
            .s()
            .p('AghgJIAAgMIAAgHIBDAmIAAATg');
        this.shape_4.setTransform(-7.1, 10.6);

        this.shape_5 = new cjs.Shape();
        this.shape_5.graphics
            .lf(['#001511', '#112220'], [0, 1], 0.6, -0.3, 0, -0.4)
            .s()
            .p('AAAgJIADgCIgDAVIgCACg');
        this.shape_5.setTransform(-3, 12.2);

        this.shape_6 = new cjs.Shape();
        this.shape_6.graphics
            .lf(['#A27F5C', '#8B6D4C'], [0, 1], -1, 0.5, 0.4, 0.9)
            .s()
            .p('AAAgIIADgCIAAABIgDASIgCACg');
        this.shape_6.setTransform(-2.7, 10.1);

        this.shape_7 = new cjs.Shape();
        this.shape_7.graphics
            .lf(['#8B6D4C', '#795F41'], [0, 1], 0.7, -0.3, -2, 4.6)
            .s()
            .p('AghgJIAAgTIAhATIAGAFIANAGIAGAEIAJAEIAAATg');
        this.shape_7.setTransform(-7.1, 8.7);

        this.shape_8 = new cjs.Shape();
        this.shape_8.graphics
            .lf(['#001511', '#112220'], [0, 1], 1.8, -1.5, 1.1, -0.3)
            .s()
            .p('AgNAJIgRgJIAXgNIAnAWIgBAAIgHAAIgKgGIgSALg');
        this.shape_8.setTransform(-5.9, 5.8);

        this.shape_9 = new cjs.Shape();
        this.shape_9.graphics
            .lf(['#A27F5C', '#795F41'], [0, 1], 1.2, -2.4, -2.2, 4.3)
            .s()
            .p('AgJASIACABIAGADgAAEgRIAGgEIAAAHg');
        this.shape_9.setTransform(-6.2, 6);

        this.shape_10 = new cjs.Shape();
        this.shape_10.graphics
            .lf(['#001511', '#112220'], [0, 1], 0.9, -0.5, -1.7, 9.4)
            .s()
            .p('AgRACIAAgGIAAgKIAAgGIAcARIAHADIgDAVg');
        this.shape_10.setTransform(-3.4, 4.3);

        this.shape_11 = new cjs.Shape();
        this.shape_11.graphics
            .lf(['#001511', '#112220'], [0, 1], 5.4, -5.2, 2.3, -2.2)
            .s()
            .p('AgQgGIAFgDIAaAPIACABIgFADg');
        this.shape_11.setTransform(-3.5, 2.9);

        this.shape_12 = new cjs.Shape();
        this.shape_12.graphics
            .lf(['#8B6D4C', '#795F41'], [0, 1], 1.2, -4.9, 1.7, -6.8)
            .s()
            .p('AgMA/IADgWIADgTIAAgBIACgHIAAgBIABgKIABgEIABgDIACgVIABgFIABgGIAEgcIACACIAEgDIgTCDg');
        this.shape_12.setTransform(-1.7, 6.9);

        this.shape_13 = new cjs.Shape();
        this.shape_13.graphics
            .lf(['#001511', '#112220'], [0, 1], 0, 0.1, 0.4, -0.9)
            .s()
            .p('AgDAAIAAgDIADADIABAAIADAAIAAAEg');
        this.shape_13.setTransform(-3.5, -3.5);

        this.shape_14 = new cjs.Shape();
        this.shape_14.graphics
            .lf(['#001511', '#112220'], [0, 1], 0, 0.9, 1.4, -0.8)
            .s()
            .p('AABAFIgBAAIAAAAIAAgBIgEgCIAAgEIAAgBIADgCIAAAHIAFADg');
        this.shape_14.setTransform(-3.5, -4.2);

        this.shape_15 = new cjs.Shape();
        this.shape_15.graphics
            .f('#A35D42')
            .s()
            .p('AgCAHIAAgHIAAgKIAFAEIAAAQg');
        this.shape_15.setTransform(-3.3, -4.7);

        this.shape_16 = new cjs.Shape();
        this.shape_16.graphics
            .f('#C56F47')
            .s()
            .p('AgDAJIAAgRIAHAAIAAARg');
        this.shape_16.setTransform(-2.6, -4.5);

        this.shape_17 = new cjs.Shape();
        this.shape_17.graphics
            .lf(['#001511', '#112220'], [0, 1], -0.1, 0.8, -0.1, 0.4)
            .s()
            .p('AgFACIAAgDIAKAAIAAADg');
        this.shape_17.setTransform(-2.6, -3.3);

        this.shape_18 = new cjs.Shape();
        this.shape_18.graphics
            .f('#F6854E')
            .s()
            .p('AgCgGIAFgEIAAAKIAAAHIgFADg');
        this.shape_18.setTransform(-1.9, -4.7);

        this.shape_19 = new cjs.Shape();
        this.shape_19.graphics
            .lf(['#8B6D4C', '#795F41'], [0, 1], -0.4, -6.1, 1.3, -3.7)
            .s()
            .p('AADgqIAIAFIgLBKIgKAGg');
        this.shape_19.setTransform(-8.1, 0.8);

        this.shape_20 = new cjs.Shape();
        this.shape_20.graphics
            .lf(['#A27F5C', '#795F41'], [0, 1], -1.1, 4.4, -3.2, 12.9)
            .s()
            .p('AAmAaIg8giIgIgEIgFgDIgEgCIAAgJIBOAsIAAAJg');
        this.shape_20.setTransform(-4.7, -2.2);

        this.shape_21 = new cjs.Shape();
        this.shape_21.graphics
            .lf(['#8B6D4C', '#795F41'], [0, 1], 1, -3, 1.4, -4.9)
            .s()
            .p('AAEgtIAGADIgNBVIgGADg');
        this.shape_21.setTransform(-8.8, 0.8);

        this.shape_22 = new cjs.Shape();
        this.shape_22.graphics
            .f('#F99E55')
            .s()
            .p('AgEAGIgCgCIgEgCIAAgDIAEgDIACgBIAIAAIADABIAEADIAAADIgHAEg');
        this.shape_22.setTransform(-2.6, -6);

        this.shape_23 = new cjs.Shape();
        this.shape_23.graphics
            .lf(['#A27F5C', '#795F41'], [0, 1], 0.1, 0.1, 0.1, -0.2)
            .s()
            .p('AgDACIADgDIAFADg');
        this.shape_23.setTransform(7.4, 12.7);

        this.shape_24 = new cjs.Shape();
        this.shape_24.graphics
            .lf(['#001511', '#112220'], [0, 1], 0, -0.2, 0.7, -0.2)
            .s()
            .p('AABgCIAAAEIgBABg');
        this.shape_24.setTransform(7.2, 10.9);

        this.shape_25 = new cjs.Shape();
        this.shape_25.graphics
            .lf(['#A27F5C', '#795F41'], [0, 1], 0.5, 0, -0.1, 0)
            .s()
            .p('AgBAJIAAgOIAAgFIAAAAIAAgBIAAABIADACIAAAUg');
        this.shape_25.setTransform(7.6, 11.7);

        this.shape_26 = new cjs.Shape();
        this.shape_26.graphics
            .lf(['#E5BB76', '#907051'], [0, 1], 1.7, 1, -3.3, -1.9)
            .s()
            .p('AgJANIAAAAIACgEIAHgLIADgHIADgFIAEACIgPAbg');
        this.shape_26.setTransform(8.4, 9.2);

        this.shape_27 = new cjs.Shape();
        this.shape_27.graphics
            .lf(['#A27F5C', '#795F41'], [0, 1], -0.9, 0.3, -0.3, 0.3)
            .s()
            .p('AgIAMIACgFIADgCIAAAPIgFADgAgDAAIAAAAIgBABgAgCgCIABgBIgCADgAAIgWIABAAIgEAHIAAAAg');
        this.shape_27.setTransform(7.8, 10.5);

        this.shape_28 = new cjs.Shape();
        this.shape_28.graphics
            .lf(['#001511', '#112220'], [0, 1], -0.3, 2, -0.2, -2.4)
            .s()
            .p('AgFgDIAMAGIgCAAIgLABg');
        this.shape_28.setTransform(0.3, 5.8);

        this.shape_29 = new cjs.Shape();
        this.shape_29.graphics
            .lf(['#001511', '#112220'], [0, 1], 0.5, -1.9, 0.7, -2.4)
            .s()
            .p('AgCAAIAAgCIAEACIABAAIAAADg');
        this.shape_29.setTransform(0.2, 4.1);

        this.shape_30 = new cjs.Shape();
        this.shape_30.graphics
            .lf(['#001511', '#112220'], [0, 1], -0.3, 3.8, 0, 0)
            .s()
            .p('AgBABIADgCIAAAAIAAACIAAAAIgCABg');
        this.shape_30.setTransform(0.6, 3.7);

        this.shape_31 = new cjs.Shape();
        this.shape_31.graphics
            .lf(['#001511', '#112220'], [0, 1], 0.5, 2.6, -0.9, -6.3)
            .s()
            .p('AAAALIAAgDIAAgNIABAAIAAARgAAAgKIAAgBIAAAAIAAAAIABAAIAAABg');
        this.shape_31.setTransform(0.9, 5);

        this.shape_32 = new cjs.Shape();
        this.shape_32.graphics
            .lf(['#001511', '#112220'], [0, 1], -0.1, -0.5, -0.2, -1.7)
            .s()
            .p('AACADIAAgDIAAAAIAAADgAgCgCIABABIgBAAg');
        this.shape_32.setTransform(0.7, 3.5);

        this.shape_33 = new cjs.Shape();
        this.shape_33.graphics
            .lf(['#001511', '#112220'], [0, 1], -0.8, -4, -2.8, -0.5)
            .s()
            .p('AgOATIAAgGIAHgBIgJgEIAAgUIADAAIAyAdIgGADIgsACgAgkgDIACgMIAGADIADAAIAAAOgAgbgQIACgBIAAABgAghgVIACgBIABABIgDABg');
        this.shape_33.setTransform(3.4, 5.6);

        this.shape_34 = new cjs.Shape();
        this.shape_34.graphics
            .lf(['#001511', '#112220'], [0, 1], 0.4, 2.4, -1, -6.4)
            .s()
            .p('AgBALIAAgRIADAAIAAATgAgBgLIAAgBIADAAIAAABg');
        this.shape_34.setTransform(1.2, 5.1);

        this.shape_35 = new cjs.Shape();
        this.shape_35.graphics
            .lf(['#001511', '#112220'], [0, 1], 1, -4.3, 1.4, -6.4)
            .s()
            .p('AgFABIAKgFIAAAEIgKAEg');
        this.shape_35.setTransform(2.6, 3.9);

        this.shape_36 = new cjs.Shape();
        this.shape_36.graphics
            .lf(['#001511', '#112220'], [0, 1], 0.4, -1.5, 0.4, -1.7)
            .s()
            .p('AAFABIgDAAIgDAAIgCAAIgDAAIAAgCIANAAIAAACg');
        this.shape_36.setTransform(1.3, 4.2);

        this.shape_37 = new cjs.Shape();
        this.shape_37.graphics
            .lf(['#001511', '#112220'], [0, 1], -0.2, -1.2, 0, 0.2)
            .s()
            .p('AgJADIgCAAIgEgCIAAgBIAGAAIgCAAIADACIACAAIACAAIAEAAIACAAIACAAIAHgEIAFAAIAAAAIgLAFg');
        this.shape_37.setTransform(1.5, 3.7);

        this.shape_38 = new cjs.Shape();
        this.shape_38.graphics
            .lf(['#001511', '#112220'], [0, 1], -0.1, -0.8, -0.3, -1.9)
            .s()
            .p('AACABIgDAAIgCAAIAAgBIAHAAIAAABg');
        this.shape_38.setTransform(1.3, 3.6);

        this.shape_39 = new cjs.Shape();
        this.shape_39.graphics
            .lf(['#001511', '#112220'], [0, 1], -0.3, 2.6, -0.2, -2.1)
            .s()
            .p('AAAANIAAgUIACAAIAAAUIAAABgAAAgLIAAgBIABAAIABgBIAAACg');
        this.shape_39.setTransform(1.6, 5.1);

        this.shape_40 = new cjs.Shape();
        this.shape_40.graphics
            .lf(['#001511', '#112220'], [0, 1], 0.5, 1, -0.2, -0.4)
            .s()
            .p('AgBAAIADgCIAAACIgCACIgBABg');
        this.shape_40.setTransform(1.8, 3.5);

        this.shape_41 = new cjs.Shape();
        this.shape_41.graphics
            .lf(['#001511', '#112220'], [0, 1], -0.4, 3.8, -0.1, 0)
            .s()
            .p('AgBAAIgBAAIAFgCIAAACIgEADg');
        this.shape_41.setTransform(2.3, 2.8);

        this.shape_42 = new cjs.Shape();
        this.shape_42.graphics
            .lf(['#001511', '#112220'], [0, 1], -0.3, 0.8, -0.2, -0.9)
            .s()
            .p('AgBAAIAEgCIAAACIgFADg');
        this.shape_42.setTransform(0.4, 2.4);

        this.shape_43 = new cjs.Shape();
        this.shape_43.graphics
            .lf(['#001511', '#112220'], [0, 1], 0, 1, 0.1, -0.7)
            .s()
            .p('AgFACIAAgDIALAAIAAADg');
        this.shape_43.setTransform(1.3, 2.3);

        this.shape_44 = new cjs.Shape();
        this.shape_44.graphics
            .lf(['#001511', '#112220'], [0, 1], 0.1, 0.9, 0.2, -0.8)
            .s()
            .p('AACACIAAgCIACABIAAADgAgEgDIADABIgDACg');
        this.shape_44.setTransform(2.4, 2.5);

        this.shape_45 = new cjs.Shape();
        this.shape_45.graphics
            .f('#3C4846')
            .s()
            .p(
                'AgJAIIgGAAIABgBIADgBIABgBIAAgBIAAAAIAAgEIACgBIADgBIAGAAIADgBIACgCIgCgCIgMAAIgFADIABgDIADgBIAOAAIALAGIAAAIIgFAAIACgBIAAgEIAAgCIgDgBIgFACIAAAAIAAACIAAACIgEADIgGAAIgBAAIAAgBIgFADg'
            );
        this.shape_45.setTransform(1.5, 2.9);

        this.shape_46 = new cjs.Shape();
        this.shape_46.graphics
            .lf(['#001511', '#112220'], [0, 1], 0.1, 0.7, 0.8, -0.5)
            .s()
            .p('AABAIIgCgQIADACIAAAOg');
        this.shape_46.setTransform(9, 5.1);

        this.shape_47 = new cjs.Shape();
        this.shape_47.graphics
            .lf(['#8B6D4C', '#795F41'], [0, 1], 1.9, -2.2, -5.2, 4.6)
            .s()
            .p(
                'AAhAjIgygdIALgGIAAgCIAAAAIAAgJIgLgGIgPAAIgDACIADgWIAxAcIAAAAIAPAJIAGACIAAAkgAgUACIAAgCIADgBIAAgDIAAgCIAFgDIADACIAAAEIgCABIgHAEgAgjgDIAAAAIgCgBIABgFIAFgDIANAAIgDABIgHAAIgDABIgCACIAAAEIAAABIgBABg'
            );
        this.shape_47.setTransform(3.8, 3.7);

        this.shape_48 = new cjs.Shape();
        this.shape_48.graphics
            .f('#4F5552')
            .s()
            .p(
                'AAJA1IAtgDIAFgDIgGAEIglAVgAg/BAIABAAIAFADgAhBA2IgLgGIgJgGIAJAFIATgLIALAGIAGAAIAIAEIgCAKIgCACIgMAGgAAIApIgEACIAAgBIgHgFIgNAHIAAgDIABgEIAMgBIACAAIgNgHIAAgCIALAGIAAACIADABIACACIADACIAAgCIAJAFIgGABgABMARIgBgCIALAAIgFAEIgBAAgAgiANIAFgCIADABIgBAFgAgLAJIACgBIAAAAIgCABgAAvgMIgJgFIAFADIAFADgAgrg7IgCgCIADAAIAJAAIAHgDIAAgHIACABIAAAGIgEACIgEADgAgzhAIAFACIAAABg'
            );
        this.shape_48.setTransform(1.2, 2.5);

        this.shape_49 = new cjs.Shape();
        this.shape_49.graphics
            .lf(['#001511', '#112220'], [0, 1], 0.1, -2.3, -0.5, -1.1)
            .s()
            .p('AAIAOIgBgGIALAAIAAABIAFACIgFADgAgPgGIgHgDIAIAAIACABIABACgAgUgNIABAAIABABg');
        this.shape_49.setTransform(8, 2.7);

        this.shape_50 = new cjs.Shape();
        this.shape_50.graphics
            .lf(['#001511', '#112220'], [0, 1], 0.9, -1.9, 0.2, -0.7)
            .s()
            .p('AAcAPIgLAAIgBgHIADACIAEACIAGADgAgFABIAEAAIABACgAgMgCIgDgCIAAAAIgNgIIAEgCIAGADIAJAFIABABIACABIADACg');
        this.shape_50.setTransform(6.9, 1.9);

        this.shape_51 = new cjs.Shape();
        this.shape_51.graphics
            .lf(['#001511', '#112220'], [0, 1], 4.6, 1.3, -2.3, 1.3)
            .s()
            .p('AgBALIAAgVIADgDIAAAbg');
        this.shape_51.setTransform(10.1, 5.2);

        this.shape_52 = new cjs.Shape();
        this.shape_52.graphics
            .f('#917151')
            .s()
            .p(
                'Ag9AnQAAgHAGgDQABAAAAAAQABgBAAAAQABAAAAAAQABAAAAABQABAAAAAAQAAABAAAAQABABAAAAQAAABAAAAQAAAIgGACIgDABQgBAAAAAAQgBAAAAgBQAAAAgBgBQAAgBAAgBgAg3AfQgEACAAAFQAAAFAEgDQAEgCAAgFQAAAAAAgBQAAAAAAAAQAAgBgBAAQAAAAAAAAIgBAAIgCAAgAAxgXQgDgBAAgEQAAgJAIgEQADgCACABQADACAAADQAAAKgIADIgDABIgCAAgAA2gnQgFAEAAAGQAAAAAAABQAAAAAAABQAAAAABABQAAAAAAAAQABAAAAABQABAAAAAAQABAAAAgBQABAAAAAAQAFgDAAgGQAAgBAAgBQAAgBAAAAQgBgBAAAAQgBgBAAAAIgDABg'
            );
        this.shape_52.setTransform(5.1, 13.9);

        this.shape_53 = new cjs.Shape();
        this.shape_53.graphics
            .lf(['#000000', '#031B1B'], [0, 1], -0.7, 2.1, 0, -0.8)
            .s()
            .p('AgQAWIAAgSIANgVIANgIIAHAFQgFgDgHAEIgDACIgEAEIgEAFIgCADQgGAJAAAJQAAAKAFADg');
        this.shape_53.setTransform(10.1, 10.3);

        this.shape_54 = new cjs.Shape();
        this.shape_54.graphics
            .f('#031B1B')
            .s()
            .p(
                'AhCA4IgCgCIgEgCIAAgPIAKgQIANgIIAFACIAFADIAAATIgDgCQgBAFgCAEQgEAHgGADIgBABIgCABIgEAAIgEAAgAg2AdIgBAAQgIAEAAAJQAAAIAIgEQAHgEAAgJIgBgBQAAgBAAAAQAAgBAAAAQAAgBgBAAQAAAAAAAAIgCgBIgCABgAAogHIgBAAQgFgDAAgJQAAgKAGgJIACgEIAEgFIAFgEIADgCQAHgEAFADIAAAAIABAAQAGADAAAKQAAAJgGAKQgFAJgIAFQgFACgEAAIgFgBgAA2gqQgEACgDAGQgDAFAAAEQAAAFADACQADACAEgDQAJgGAAgLQAAgFgCgBIgDgBIgEABg'
            );
        this.shape_54.setTransform(5.2, 13.7);

        this.shape_55 = new cjs.Shape();
        this.shape_55.graphics
            .lf(['#8B6D4C', '#795F41'], [0, 1], 2.2, 8.1, -1, -3.9)
            .s()
            .p('AAEAiIgDgNIAAgDIgBgDIgBgKIgFgZIgCgNIAEgDIAMBFIABABIAAADg');
        this.shape_55.setTransform(6.7, 0.2);

        this.shape_56 = new cjs.Shape();
        this.shape_56.graphics
            .f('#A27F5C')
            .s()
            .p(
                'AgXBzIgpgXIgUgMIgFgDIgIgFIAOgIIAAAMIBFAngAgKBxIADgCIAFADgAgdBFIAAAAIgNgHIgGgEIgCgBIATADIARAKIAMgHIACAAIgBAHIgEACgAhTAmIAIgEIAGgDIAKgGIAdgRIAAAKIgGADIAGAEIAgATIAAADIgHAAIgogXIgXAOIARAKIAJAFIgIAEgABdA1IAFADIgMABgAAEAQIgDgBIAGgDIgBAGgAAWANIACAAIgCABgAgNgyIgCgCIgOAAIgDgBIgDgCIAAgFIAGgEIAMAAIAAAGIAAADIAIAFgAAFg4IAEgCIgIAEgAgRg6IAFACIAAABgABShFIgKgGIAEgCIAHAAIAAACIALAGgAANhsIgEgDIAGgDIAKAGg'
            );
        this.shape_56.setTransform(-2.2, 2);

        this.shape_57 = new cjs.Shape();
        this.shape_57.graphics
            .lf(['#B29F9B', '#866849'], [0, 1], 3, -0.3, 17.3, -1.8)
            .s()
            .p('AgEADIAAgCIAAgBIAAgIIAJAGIAAALg');
        this.shape_57.setTransform(6.7, -5.9);

        this.shape_58 = new cjs.Shape();
        this.shape_58.graphics
            .lf(['#001511', '#112220'], [0, 1], -8.5, -18.5, 2.9, 6)
            .s()
            .p('AgBAkIAAhJIADACIAABJg');
        this.shape_58.setTransform(9, -0.7);

        this.shape_59 = new cjs.Shape();
        this.shape_59.graphics
            .lf(['#001511', '#112220'], [0, 1], 0.6, 0.1, 0.2, -0.8)
            .s()
            .p('AgCAAIAAgCIAGAAIAAAFg');
        this.shape_59.setTransform(7.9, -5.7);

        this.shape_60 = new cjs.Shape();
        this.shape_60.graphics
            .lf(['#001511', '#112220'], [0, 1], 0.4, 0.1, 0, -0.8)
            .s()
            .p('AgBAAIADgBIAAADg');
        this.shape_60.setTransform(9, -5.1);

        this.shape_61 = new cjs.Shape();
        this.shape_61.graphics
            .lf(['#A27F5C', '#795F41'], [0, 1], 0.3, -1.6, 1.5, -5.6)
            .s()
            .p('AgUgIIAEgCIAYANIANAIIAAAAIgHAAg');
        this.shape_61.setTransform(3.2, 0.3);

        this.shape_62 = new cjs.Shape();
        this.shape_62.graphics
            .lf(['#B29F9B', '#866849'], [0, 1], 3.1, -0.3, 17.4, -1.8)
            .s()
            .p('AgEADIAAgLIAJAGIAAALg');
        this.shape_62.setTransform(-0.2, -9.8);

        this.shape_63 = new cjs.Shape();
        this.shape_63.graphics
            .f('#FDE685')
            .s()
            .p(
                'AAGB6IAzgeIAFgCIgFADIAJAAIg8AjgAgdByIASgLIAFACIgDACIgQAJgAg4BjIAIAAIAEgCIAAAAIAJABIAQgKIAAgFIAjgVIAlgVIALgBIARgKIgCgHIABABIAGADIAFADIAFADIADABIgQAKIgFgDIAHgEIAAgEIh/BKgAg5A5IgFgEIAYADIgKAGgAgkAvIADgBIAAABgAgQAiIABgBIAMgHIAIAFIgXAOgAhTApIAHgEIALAHgAgnAfIAAAAIAIAAIgBAFgAAsgHIgBgBIgwgcIAAgCIAFgCIAiAUIAHgBIAEACIAHAEIAEADIADAMgAhihUIBKgrIAFADIALAAIAEgCIAqAZIAFACIAFADIACABIAAACIgIAAIgEACIALAGIALAAIhPAugAhFhMIAAAFIADACIAEABIANAAIADACIAEAAIALAAIAHgFIAAgDIAAgHIgCgBIAAgKIAAgFIgDgCIgEgCIgIAAIgDACIgDACIAAAFIADABIADACIgGgDIAAAKIgDABIAAABIgMAAg'
            );
        this.shape_63.setTransform(1.2, 3.6);

        this.shape_64 = new cjs.Shape();
        this.shape_64.graphics
            .f('#DACBBF')
            .s()
            .p('AAhAPIADgCIAAAEIAAACIAAAGIgDACgAgjgXIAEgDIAAAMIgEACg');
        this.shape_64.setTransform(3.9, -7.7);

        this.shape_65 = new cjs.Shape();
        this.shape_65.graphics
            .f('#F1ECE6')
            .s()
            .p('AAbASIAEgCIAAAAIAEACIAGAEIgDACgAgogVIAEgCIAKAGIgEACg');
        this.shape_65.setTransform(3.4, -8.5);

        this.shape_66 = new cjs.Shape();
        this.shape_66.graphics
            .lf(['#001511', '#112220'], [0, 1], 0.6, 0, 0.2, -0.9)
            .s()
            .p('AgCAAIAFgCIAAAEg');
        this.shape_66.setTransform(5.8, -7);

        this.shape_67 = new cjs.Shape();
        this.shape_67.graphics
            .lf(['#001511', '#112220'], [0, 1], 1.1, 0.7, -0.1, -1.8)
            .s()
            .p('AAHAGIAAgDIgGgDIAFgDIAIAEIAAAFgAgIgFIAAAAIgFACg');
        this.shape_67.setTransform(6.9, -6.6);

        this.shape_68 = new cjs.Shape();
        this.shape_68.graphics
            .lf(['#001511', '#112220'], [0, 1], -4.7, -11.7, 6.6, 12.7)
            .s()
            .p('AgBgpIADADIAABNIgDADg');
        this.shape_68.setTransform(9, -9.3);

        this.shape_69 = new cjs.Shape();
        this.shape_69.graphics
            .lf(['#001511', '#112220'], [0, 1], 8.8, 2.8, -2.5, -0.6)
            .s()
            .p('AgDAwIgBAAIAAgoIAJgYIAAA/IgFADgAgEgeIACABIgCAGgAAAguIAFgDIgCAFg');
        this.shape_69.setTransform(7, -11.7);

        this.shape_70 = new cjs.Shape();
        this.shape_70.graphics
            .lf(['#001511', '#112220'], [0, 1], -6.8, 18.1, -0.3, 1.1)
            .s()
            .p(
                'AALBkIgCgOIAAg+IgHgEIAAgGIAHAEIAAgGIAAgGIAAhHIAFAEIAABSIAFACIAAAHIgFgDIAABKgAgLBWIgBAAIgBgBIAAghIAFAaIAAAKgAgNALIAAAAIgFgDIAAgGIAFACIAAgEIAAAAIAAhNIAFACIAAAHIAAAgIAAAnIgDABIAAAIgAgSheIAAgGIAKAGIAFADIADACIABABIANAHIAFADIAAAFg'
            );
        this.shape_70.setTransform(7.4, -7.2);

        this.shape_71 = new cjs.Shape();
        this.shape_71.graphics
            .lf(['#A27F5C', '#795F41'], [0, 1], -7.1, 30.3, 1.5, -4.1)
            .s()
            .p('AgEBeIAAgpIADgBIABAMIAAAhgAgEAUIAEADIAAAAgAgEhFIAEAEIAABMIgEADgAgEhYIAAgIIAJAOg');
        this.shape_71.setTransform(6, -8.4);

        this.shape_72 = new cjs.Shape();
        this.shape_72.graphics
            .lf(['#A27F5C', '#795F41'], [0, 1], 1.6, -3.8, -7.7, 33.5)
            .s()
            .p(
                'AAXByIABAAIAAAAgAAYBygAATBvIAAhKIAAgGIAAgFIAAhOIAFADIAACjgAgXBXIAAgkIAFgDIAAApgAgXANIAAhZIAFADIAABSIAAAGgAAThBIAAgGIAAgSIAFADIAAAYgAgXhaIAAgXIAFADIAAAJIAAAIIAAAGg'
            );
        this.shape_72.setTransform(7.4, -7.9);

        this.shape_73 = new cjs.Shape();
        this.shape_73.graphics
            .lf(['#001511', '#112220'], [0, 1], 0.7, -2.5, -2.1, 8.8)
            .s()
            .p('AAYAUIgFgCIgFgDIgIgFIgHgEIgCgBIgFgDIgFgCIgFgDIgKgGIAAgOIAKAGIAFADIAlAVIAFADIAAAOg');
        this.shape_73.setTransform(6.9, -15.2);

        this.shape_74 = new cjs.Shape();
        this.shape_74.graphics
            .f('#E5BB76')
            .s()
            .p(
                'AhBCvIANgXIAQgJIACgBIACAAIBEgoIgBADIgBABIhAAmIAEACIA6giIgCAFIAAALIgzAeIAAAGIA8gjIAAgVIAQgcIARgKIAAAHIgOAIIgNAWIAAASIAAAHIhHAqIAAgTIgFgDIgFgCIgOAIIgJAQIAAAPIAAAEIgGADgAgyCzQAAgJAHgEIACAAQABAAAAgBQAAAAABAAQAAAAABAAQAAABABAAQAAAAAAAAQAAAAABABQAAAAAAABQAAAAAAABIABABQAAAJgIAEIgEACQgDAAAAgGgAgrCoQgFADgBAHQABAHAFgEQAGgCAAgIQAAAAAAgBQAAAAAAgBQgBAAAAgBQAAAAgBAAIgBgBIgDABgAguCxQAAgFADgCIADAAQAAAAABAAQAAAAAAABQAAAAAAAAQAAABAAAAQAAAFgEACIgCABQAAAAgBAAQAAAAAAgBQAAAAAAAAQAAgBAAgBgAhGCrIABAAIgBABgAhGCPICAhKIAAAEIgHAEIgDAGIgBAAIgDAHIhyBBgAgrADIgDACIAAgIIBPguIAEgCIAAAJIgBAAIgDACIADAQIAIAnIACANIABAHIABAGIABACIADAQIACAHIgRAKIAAglIAAgDIgBgBIgNhFIgEADIgDABIgFADIgiAUIgEADIgFACIgBACIgDAVIAAADIgBADIAAAGIgBABIAAABIAAABIgBABIAAABIAAADIgCALIAAACIgBAJIgBAEIAAADIgCALIAXgOIAAABIAEAHIABAEIAHATIgkAVIAAAFIgQAKgAguBkIAAASIAJgFIAAgSgAA7B2QgDgCAAgFQAAgEADgFQAEgGADgCQAFgCADACQACABAAAFQAAALgKAGIgEACIgDgBgABCBhQgHAEgBAJQAAAEADABQACABADgCQAIgDAAgKQAAgDgCgCIgCAAIgEABgAhLBiIAJgGIAEgCIgDACIgDAUIgHAEgAA/BwQgBAAAAAAQAAgBgBAAQAAgBAAAAQAAgBAAAAQAAgGAFgEQAGgCAAAGQAAAGgGADIgCABIgBgBgABABCIAAgcIgFgDIAAAAIAAijIAKgFIAADKgAA7ilIgFgDIAIgCIAHAAIAAAXIgKAGgAAQi0IAAgJIgFgDIAPgDIAAAdg'
            );
        this.shape_74.setTransform(3.9, 0);

        this.shape_75 = new cjs.Shape();
        this.shape_75.graphics
            .f('#273433')
            .s()
            .p(
                'AhFCkIAFgCIgEAGIgBABgAhFCZIByhCIAAAAIgHANIgBAAIhEAoIgCgBIgCABIACgBIgEgCIgTAKIgFAKIgIAFgAgdCNIBAglIABgBIAAABIgDAGIg6AigAhKByIAHgEIgDAVIAAAAIgEACgAgtBiIAJgGIAAATIgJAFgAgVBCIAEgBIAAACIAAAGgAgqBBIAAACIAAABgAA2A5IAAgPIABAAIAFgEIAAAXgAAbAOIAAgKIACALgAAigqIADgCIAAASgAg6gkIAIgFIAAAEIgIAEgAAbiOIACgGIAIAFIAAAIIgKAZgAA8iPIAKgGIAFgDIAAANIgFAEIgKAFgAAjijIACgFIAAAGg'
            );
        this.shape_75.setTransform(3.8, 0.2);

        this.timeline.addTween(
            cjs.Tween.get({})
                .to({
                    state: [
                        {t: this.shape_75},
                        {t: this.shape_74},
                        {t: this.shape_73},
                        {t: this.shape_72},
                        {t: this.shape_71},
                        {t: this.shape_70},
                        {t: this.shape_69},
                        {t: this.shape_68},
                        {t: this.shape_67},
                        {t: this.shape_66},
                        {t: this.shape_65},
                        {t: this.shape_64},
                        {t: this.shape_63},
                        {t: this.shape_62},
                        {t: this.shape_61},
                        {t: this.shape_60},
                        {t: this.shape_59},
                        {t: this.shape_58},
                        {t: this.shape_57},
                        {t: this.shape_56},
                        {t: this.shape_55},
                        {t: this.shape_54},
                        {t: this.shape_53},
                        {t: this.shape_52},
                        {t: this.shape_51},
                        {t: this.shape_50},
                        {t: this.shape_49},
                        {t: this.shape_48},
                        {t: this.shape_47},
                        {t: this.shape_46},
                        {t: this.shape_45},
                        {t: this.shape_44},
                        {t: this.shape_43},
                        {t: this.shape_42},
                        {t: this.shape_41},
                        {t: this.shape_40},
                        {t: this.shape_39},
                        {t: this.shape_38},
                        {t: this.shape_37},
                        {t: this.shape_36},
                        {t: this.shape_35},
                        {t: this.shape_34},
                        {t: this.shape_33},
                        {t: this.shape_32},
                        {t: this.shape_31},
                        {t: this.shape_30},
                        {t: this.shape_29},
                        {t: this.shape_28},
                        {t: this.shape_27},
                        {t: this.shape_26},
                        {t: this.shape_25},
                        {t: this.shape_24},
                        {t: this.shape_23},
                        {t: this.shape_22},
                        {t: this.shape_21},
                        {t: this.shape_20},
                        {t: this.shape_19},
                        {t: this.shape_18},
                        {t: this.shape_17},
                        {t: this.shape_16},
                        {t: this.shape_15},
                        {t: this.shape_14},
                        {t: this.shape_13},
                        {t: this.shape_12},
                        {t: this.shape_11},
                        {t: this.shape_10},
                        {t: this.shape_9},
                        {t: this.shape_8},
                        {t: this.shape_7},
                        {t: this.shape_6},
                        {t: this.shape_5},
                        {t: this.shape_4},
                        {t: this.shape_3},
                        {t: this.shape_2},
                        {t: this.shape_1},
                        {t: this.shape}
                    ]
                })
                .wait(1)
        );
    }).prototype = getMCSymbolPrototype(lib.Symbol53, (rect = new cjs.Rectangle(-12.4, -19.6, 24.9, 39.3)), [rect]);

    (lib.Symbol51 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .lf(['#AC9D9A', '#DACBBF'], [0, 1], 28.4, 0, -13.2, 0)
            .s()
            .p('AgeATIAAg0IA9APIAAA0g');
        this.shape.setTransform(-26.4, 52.7);

        this.shape_1 = new cjs.Shape();
        this.shape_1.graphics
            .lf(['#AC9D9A', '#A09290'], [0, 1], -4.4, 0, 41.4, 0)
            .s()
            .p('AgegSIA+gPIgPAaIAPAaIg+APg');
        this.shape_1.setTransform(-13.3, 52.7);

        this.shape_2 = new cjs.Shape();
        this.shape_2.graphics
            .lf(['#AC9D9A', '#A09290'], [0, 1], -2, -7.5, 8.6, 32)
            .s()
            .p('AgdB3IAAjtIA7AAIAADtg');
        this.shape_2.setTransform(-19.9, 37.8);

        this.shape_3 = new cjs.Shape();
        this.shape_3.graphics
            .lf(['#AC9D9A', '#A09290'], [0, 1], -13.6, 0, 34.8, 0)
            .s()
            .p('AgeANIAPgYIAugcIgGAeIAGAWIguAbg');
        this.shape_3.setTransform(-8.5, 50.6);

        this.shape_4 = new cjs.Shape();
        this.shape_4.graphics
            .lf(['#AC9D9A', '#A09290'], [0, 1], -8.4, 0, 17.8, 0)
            .s()
            .p('AgPAWIAGgeIAJgMIAAgCIAQgWIAAA0IgZAkg');
        this.shape_4.setTransform(-4.4, 47.4);

        this.shape_5 = new cjs.Shape();
        this.shape_5.graphics
            .lf(['rgba(172,157,154,0.4)', '#A09290'], [0, 1], 52.3, 6.1, 16.7, 19.7)
            .s()
            .p('AkKBcIA/gPIAvgbIAagkIAAg0IAAgnIgKgOIBcAAIE7C1IgmgJImIAAIgyALg');
        this.shape_5.setTransform(10.2, 46.9);

        this.shape_6 = new cjs.Shape();
        this.shape_6.graphics
            .lf(['#DACBBF', '#D4C4B9'], [0, 1], -18, 0, 9.1, 0)
            .s()
            .p('AgXANIASgXIgSgaIAAgDIAvAcIAAAzg');
        this.shape_6.setTransform(-31.9, 50.6);

        this.shape_7 = new cjs.Shape();
        this.shape_7.graphics
            .lf(['#AC9D9A', '#A09290'], [0, 1], 98.1, 8.1, 62.5, 21.7)
            .s()
            .p('AgHgKIAAgBIAPAVIAAACg');
        this.shape_7.setTransform(-35.6, 44.8);

        this.shape_8 = new cjs.Shape();
        this.shape_8.graphics
            .lf(['#AC9D9A', '#A09290'], [0, 1], -5.6, -14.6, 5.2, 13.5)
            .s()
            .p('AgbhfIAAggIA2gOIAAENIg2AOg');
        this.shape_8.setTransform(-14.1, 35.5);

        this.shape_9 = new cjs.Shape();
        this.shape_9.graphics
            .lf(['#AC9D9A', '#A09290'], [0, 1], -5.4, -14.2, 5.1, 13.2)
            .s()
            .p('AgUh6IApgYIAAEMIgpAZg');
        this.shape_9.setTransform(-9.3, 33.7);

        this.shape_10 = new cjs.Shape();
        this.shape_10.graphics
            .lf(['#AC9D9A', '#A09290'], [0, 1], 3.8, -3.7, 7.8, -19.8)
            .s()
            .p('AgdCbIAAk1IA7AAIAAEVIAAAgg');
        this.shape_10.setTransform(-19.9, 10.4);

        this.shape_11 = new cjs.Shape();
        this.shape_11.graphics
            .lf(['#AC9D9A', '#A09290'], [0, 1], -0.8, -11.3, -2.1, -26.2)
            .s()
            .p('AgKALIAAkRIAQgKIAFgHIAAHOIAABBIgVAgg');
        this.shape_11.setTransform(-6, 17.9);

        this.shape_12 = new cjs.Shape();
        this.shape_12.graphics
            .lf(['#AC9D9A', '#A09290'], [0, 1], -2.3, 3.6, -6.3, -12.5)
            .s()
            .p('AgbiEIAFAAIAxgMIAAEUIg2ANg');
        this.shape_12.setTransform(-14.1, 8.2);

        this.shape_13 = new cjs.Shape();
        this.shape_13.graphics
            .lf(['#AC9D9A', '#A09290'], [0, 1], -1.1, 3, -3.2, -13.9)
            .s()
            .p('AgUh/IAMgDIAdgSIAAERIgpAYg');
        this.shape_13.setTransform(-9.3, 6.5);

        this.shape_14 = new cjs.Shape();
        this.shape_14.graphics
            .lf(['#AC9D9A', '#A09290'], [0, 1], -4.4, 0, 41.4, 0)
            .s()
            .p('AgegSIA0gNIAKgCIgPAaIAPAaIgNADIgxAMg');
        this.shape_14.setTransform(-13.3, -8.5);

        this.shape_15 = new cjs.Shape();
        this.shape_15.graphics
            .lf(['#AC9D9A', '#A09290'], [0, 1], -13.6, 0, 34.8, 0)
            .s()
            .p('AgeANIAPgZIAugbIgGAeIAGAVIgRAKIgdASg');
        this.shape_15.setTransform(-8.5, -10.7);

        this.shape_16 = new cjs.Shape();
        this.shape_16.graphics
            .lf(['#AC9D9A', '#A09290'], [0, 1], -8.4, 0, 17.8, 0)
            .s()
            .p('AgPAWIAGgdIAZglIAAA0IgTAdIgGAHg');
        this.shape_16.setTransform(-4.4, -13.9);

        this.shape_17 = new cjs.Shape();
        this.shape_17.graphics
            .f('#BBAAA6')
            .s()
            .p('AhFBDIA3gNIApgYIAXgfIAAhBIAUAcIAAAmIgaAlIguAbIgKACIgEABg');
        this.shape_17.setTransform(-9.9, -18.4);

        this.shape_18 = new cjs.Shape();
        this.shape_18.graphics
            .lf(['#DACBBF', '#D4C4B9'], [0, 1], -15.8, -0.8, 8, -0.8)
            .s()
            .p('AgUEDIAAoeIAdASIAMADIAAIig');
        this.shape_18.setTransform(-30.4, 20);

        this.shape_19 = new cjs.Shape();
        this.shape_19.graphics
            .f('#B4A29F')
            .s()
            .p('AghFNIAAg1IBDAAIAAA1gAAekXIg7AAIgEAAIAAg1IBDAAIAAA1g');
        this.shape_19.setTransform(-19.9, 22.8);

        this.shape_20 = new cjs.Shape();
        this.shape_20.graphics
            .lf(['#AC9D9A', '#DACBBF'], [0, 1], 25, -0.6, -11.6, -0.6)
            .s()
            .p('AgbELIAAoiIAzAMIADAAIAAE2IAADtg');
        this.shape_20.setTransform(-25.6, 21.6);

        this.shape_21 = new cjs.Shape();
        this.shape_21.graphics
            .lf(['#AC9D9A', '#DACBBF'], [0, 1], 28.4, 0, -13.2, 0)
            .s()
            .p('AgTAWIgLgDIAAg0IA9APIAAA0g');
        this.shape_21.setTransform(-26.4, -8.5);

        this.shape_22 = new cjs.Shape();
        this.shape_22.graphics
            .lf(['#DACBBF', '#D4C4B9'], [0, 1], -18, 0, 9.1, 0)
            .s()
            .p('AgGAXIgRgLIASgWIgSgbIAAgCIAvAbIAAA0g');
        this.shape_22.setTransform(-31.9, -10.7);

        this.shape_23 = new cjs.Shape();
        this.shape_23.graphics
            .lf(['#D7C7BC', '#AC9D9A'], [0, 1], 2.8, 28, 30.7, 28)
            .s()
            .p('AgCgCIAAgCIAFAHIAAACg');
        this.shape_23.setTransform(-34.6, -15);

        this.shape_24 = new cjs.Shape();
        this.shape_24.graphics
            .lf(['#AC9D9A', '#DACBBF'], [0, 1], 25, -1.4, -11.6, -1.4)
            .s()
            .p('AgbBSIAAixIAqAjIAMADIAACZg');
        this.shape_24.setTransform(-25.6, -21.2);

        this.shape_25 = new cjs.Shape();
        this.shape_25.graphics
            .lf(['#AC9D9A', '#A09290'], [0, 1], -0.1, 0.8, 3.8, -14.7)
            .s()
            .p('AgbBiIAAiZIgEgpIA/gBIAADDg');
        this.shape_25.setTransform(-20.1, -21.4);

        this.shape_26 = new cjs.Shape();
        this.shape_26.graphics
            .lf(['#DACBBF', '#D4C4B9'], [0, 1], -15.8, -1.1, 8, -1.1)
            .s()
            .p('AgUBQIAAi3IALANIAeARIAACxg');
        this.shape_26.setTransform(-30.4, -23.4);

        this.shape_27 = new cjs.Shape();
        this.shape_27.graphics
            .f('#A99896')
            .s()
            .p('AAkAiIgqgiIgegRIgMgNIAAgGIAfARIA+AQIADAog');
        this.shape_27.setTransform(-27.7, -30.7);

        this.shape_28 = new cjs.Shape();
        this.shape_28.graphics
            .lf(['#B4A29F', '#AC9D9A'], [0, 1], -2.3, 3.1, -0.5, -3.3)
            .s()
            .p('AgCgEIAFAEIAAAFg');
        this.shape_28.setTransform(-32.9, -34.3);

        this.shape_29 = new cjs.Shape();
        this.shape_29.graphics
            .f('#DACBBF')
            .s()
            .p(
                'AgVG9IAAg1IAFAHIAQAXIAEAJIASAaIgSAYgAAAGFIAAhBIAAnPIgVgcIAAg1IAVAeIAEAJIASAaIgSAYIARAKIAAIegAAAjeIAAhCIAAhuIgVgdIAAg1IAVAfIAAAAIAEA6IALAGIAGAKIAAC4g'
            );
        this.shape_29.setTransform(-34.7, 3.8);

        this.shape_30 = new cjs.Shape();
        this.shape_30.graphics
            .lf(['#DACBBF', '#D4C4B9'], [0, 1], -17.7, 0.4, 9.4, 0.4)
            .s()
            .p('AgDAbIgHgFIgKgFIgFg6IADAGIACACIgFgIIgBgCIA1AjIAAA0g');
        this.shape_30.setTransform(-32.2, -37);

        this.shape_31 = new cjs.Shape();
        this.shape_31.graphics
            .lf(['#AC9D9A', '#A09290'], [0, 1], 0.7, 6.2, -0.6, -8.5)
            .s()
            .p('AgKhVIAQgKIAFgIIAABuIAABBIgVAgg');
        this.shape_31.setTransform(-6, -25.8);

        this.shape_32 = new cjs.Shape();
        this.shape_32.graphics
            .lf(['#AC9D9A', '#A09290'], [0, 1], 1, 7.1, -1.1, -10.2)
            .s()
            .p('AgUhWIAMgDIAdgRIAAC9IgpAYg');
        this.shape_32.setTransform(-9.3, -23.7);

        this.shape_33 = new cjs.Shape();
        this.shape_33.graphics
            .lf(['#AC9D9A', '#DACBBF'], [0, 1], 25, 0, -16.6, 0)
            .s()
            .p('AA9AhIg+ABIg/gPIAAg0ICBAPIAAA0g');
        this.shape_33.setTransform(-23, -34.5);

        this.shape_34 = new cjs.Shape();
        this.shape_34.graphics
            .lf(['#AC9D9A', '#A09290'], [0, 1], -4.4, 0, 41.4, 0)
            .s()
            .p('AgegSIA+gPIgPAaIAPAaIgNADIgxAMg');
        this.shape_34.setTransform(-13.3, -34.5);

        this.shape_35 = new cjs.Shape();
        this.shape_35.graphics
            .lf(['#AC9D9A', '#A09290'], [0, 1], 1.8, 6.5, -2, -9.1)
            .s()
            .p('AgbhbIAFABIAxgNIAADCIg2ANg');
        this.shape_35.setTransform(-14.1, -22);

        this.shape_36 = new cjs.Shape();
        this.shape_36.graphics
            .lf(['#AC9D9A', '#A09290'], [0, 1], -8.4, 0, 17.8, 0)
            .s()
            .p('AgPAVIAGgcIAJgOIAAgBIAQgVIAAAzIgTAdIgGAIg');
        this.shape_36.setTransform(-4.4, -39.8);

        this.shape_37 = new cjs.Shape();
        this.shape_37.graphics
            .lf(['#AC9D9A', '#A09290'], [0, 1], -13.6, 0, 34.8, 0)
            .s()
            .p('AgeANIAPgZIAugbIgGAeIAGAWIgRAJIgdASg');
        this.shape_37.setTransform(-8.5, -36.7);

        this.shape_38 = new cjs.Shape();
        this.shape_38.graphics
            .lf(['#B4A29F', '#AC9D9A'], [0, 1], 1.9, 0.2, -5.3, -0.2)
            .s()
            .p('AgWBDIgrgKIghgTIgRgZIAAgZIARgZIAhgTIArgKIAtAAIArAKIAhATIARAZIAAAZIgRAZIghATIgrAKg');
        this.shape_38.setTransform(-19.9, -46.3);

        this.shape_39 = new cjs.Shape();
        this.shape_39.graphics
            .f('#F1ECE6')
            .s()
            .p(
                'AghIXIg+gPIgwgcIAAADIgGgJIAAgCIgPgVIgFgHIAAgnIAUgdIAABBIAXAgIAqAZIA3ANIA7AAIA3gNIAqgZIAXggIAAhBIAKAPIAKAOIAAAnIgPAVIgCACIgJANIgvAcIg/APgAghhNIg+gPIgwgcIgGgHIgUgdIAAgnIAUgdIAABCIAXAfIAqAZIA3ANIA7AAIA1AAIAEgBIg1ANgAhflgIg2gjIABACIAFAIIgCgCIgDgGIgBAAIAAgCIgUgdIAAgnIAagkIAwgcIA+gPIBDAAIA/APIAvAcIAaAkIAAAnIgPAWIgCABIgJANIgvAcIg/APgAhBnsIghASIgRAZIAAAbIARAZIAhASIArALIAtAAIArgLIAhgSIARgZIAAgbIgRgZIghgSIgrgLIgtAAg'
            );
        this.shape_39.setTransform(-19.9, -2.6);

        this.timeline.addTween(
            cjs.Tween.get({})
                .to({
                    state: [
                        {t: this.shape_39},
                        {t: this.shape_38},
                        {t: this.shape_37},
                        {t: this.shape_36},
                        {t: this.shape_35},
                        {t: this.shape_34},
                        {t: this.shape_33},
                        {t: this.shape_32},
                        {t: this.shape_31},
                        {t: this.shape_30},
                        {t: this.shape_29},
                        {t: this.shape_28},
                        {t: this.shape_27},
                        {t: this.shape_26},
                        {t: this.shape_25},
                        {t: this.shape_24},
                        {t: this.shape_23},
                        {t: this.shape_22},
                        {t: this.shape_21},
                        {t: this.shape_20},
                        {t: this.shape_19},
                        {t: this.shape_18},
                        {t: this.shape_17},
                        {t: this.shape_16},
                        {t: this.shape_15},
                        {t: this.shape_14},
                        {t: this.shape_13},
                        {t: this.shape_12},
                        {t: this.shape_11},
                        {t: this.shape_10},
                        {t: this.shape_9},
                        {t: this.shape_8},
                        {t: this.shape_7},
                        {t: this.shape_6},
                        {t: this.shape_5},
                        {t: this.shape_4},
                        {t: this.shape_3},
                        {t: this.shape_2},
                        {t: this.shape_1},
                        {t: this.shape}
                    ]
                })
                .wait(1)
        );
    }).prototype = getMCSymbolPrototype(lib.Symbol51, (rect = new cjs.Rectangle(-36.9, -56.1, 73.8, 112.2)), [rect]);

    (lib.Symbol31 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .f('#E5BB76')
            .s()
            .p('Ah+BuIAAluID9CTIAAFtg');

        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));
    }).prototype = getMCSymbolPrototype(lib.Symbol31, (rect = new cjs.Rectangle(-12.7, -25.6, 25.4, 51.3)), [rect]);

    (lib.Symbol30 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .f('#E5BB76')
            .s()
            .p('Ah+BuIAAluID9CTIAAFtg');

        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));
    }).prototype = getMCSymbolPrototype(lib.Symbol30, (rect = new cjs.Rectangle(-12.7, -25.6, 25.4, 51.3)), [rect]);

    (lib.Symbol29 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .f('#E5BB76')
            .s()
            .p('Ah+BuIAAluID9CTIAAFtg');

        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));
    }).prototype = getMCSymbolPrototype(lib.Symbol29, (rect = new cjs.Rectangle(-12.7, -25.6, 25.4, 51.3)), [rect]);

    (lib.Symbol26 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .f('#DACBBF')
            .s()
            .p('Ah3g0IAAghIDvCKIAAAhg');
        this.shape.setTransform(-5, 13.2);

        this.shape_1 = new cjs.Shape();
        this.shape_1.graphics
            .f('#AB9996')
            .s()
            .p(
                'AA1BKIBSgwIhBAaIACABIgKAFIgJAAIAJgFIAAgFIADACIBWgiIABAAIAAAiIhjA5gAB1AWIAJgGIAAgFIAEACIALgDIAEACIgKAEIABAAIgKAGgAAkgsIgBgDIAGAAIADACIAFADgAiIg+IADgCIgBgBIClARIACAEgAiXg7IAFgCIAEACgAiOhGIAAAAIAAABgAhJhiIgFACIgKAAIAKgFIAAgFIAJAFIAAAAIAcAHIAMAGg'
            );
        this.shape_1.setTransform(1.8, 11.1);

        this.shape_2 = new cjs.Shape();
        this.shape_2.graphics
            .f('#F1ECE6')
            .s()
            .p(
                'AipgoIArgYIgGAKIgBgBIgKAGIAAAJIAKAGIAJAAIAFgDICpASIASBTIgHAEIAAAKIAJAFIAKAAIAJgFIgCgBIBBgaIhSAvgABQBIIAAgEIgJgEIgRhTIANABIA6AhIAGANIgGADIAAAKIAJAFIAKAAIAJgFIgBgBIALgDIAHAEIgBgBIhWAigACQAjIAAgEIgKgFIAAAAIgDgHIAbAPIgKAEgAA7gWIgGgBIgBgDIAKAFgAh1gpIgHgEIAAAAIAAgEIgFgDIAJgQIAygdIACABIgBAFIgBAAIgJAFIAAAJIAJAGIAKAAIAEgDIAsAKIA8AkIABAFgAgMhAgAgXhGIgcgGIAAgBIgJgFIAAgEIgGgDIACgFIA0Aeg'
            );
        this.shape_2.setTransform(0, 8.7);

        this.shape_3 = new cjs.Shape();
        this.shape_3.graphics
            .f('#000000')
            .s()
            .p(
                'ABCCyIAJgFIAAAEIAAAFIgJAFgACCCNIAJgFIAAAEIAAAFIgJAGgAiKBAIAFADIgFACgAiKA8IAJgGIAAAEIAAABIgJAFgAhLAXIAKgGIAAAFIAAAFIgKAFgAgKiuIAVgMIAAATIgIAFIgDACIgCABIgDACIgFADg'
            );
        this.shape_3.setTransform(0.5, -1.8);

        this.shape_4 = new cjs.Shape();
        this.shape_4.graphics
            .f('#131B15')
            .s()
            .p(
                'AA9C9IAAgKIAHgEIgShUIgBgEIgBgFIgwjpIACgBIAyDsIABADIABAEIARBUIAJAEIgKAFIAAAKgAB9CYIAAgKIAGgDIgGgNIh5kXIADgCIB8EdIADAHIAAAAIAKAFIgKAGIAAAJgAiBBJIgEgDIAJgFIAAAAIAHAEIACABIgEADIgFADgAiPBGIAAgJIAKgGIABABIAGgKIB0jEIgFgDIAAgUIAFgCIAAgSIADAAIAAAQIAGgEIAAgMIADAAIAAAKIAEgCIABABIAAgJIAEAAIAAALIAEACIgUAMIAAAUIAFgDIhACnIgCAFIAGADIgKAFIAAAKIgJgGIAAgJIAJgFIABAAIABgFIA/iiIgBAAIhyC+IgJAQIAFADIgJAFIAAAEIAAAGg'
            );
        this.shape_4.setTransform(0, -2.4);

        this.timeline.addTween(
            cjs.Tween.get({})
                .to({state: [{t: this.shape_4}, {t: this.shape_3}, {t: this.shape_2}, {t: this.shape_1}, {t: this.shape}]})
                .wait(1)
        );
    }).prototype = getMCSymbolPrototype(lib.Symbol26, (rect = new cjs.Rectangle(-17, -21.8, 34, 43.7)), [rect]);

    (lib.Symbol19 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .lf(['rgba(97,94,97,0.4)', 'rgba(64,61,63,0.4)'], [0, 1], 3.5, 8.5, -1.3, -3.4)
            .s()
            .p('AjJBGIADgJID0iNICPAAIANAHIj0CNIiJAAIgEANg');

        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));
    }).prototype = getMCSymbolPrototype(lib.Symbol19, (rect = new cjs.Rectangle(-20.1, -8, 40.3, 16.2)), [rect]);

    (lib.Symbol18 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .f('#F0B860')
            .s()
            .p('AhngzIAAgQIB6BGIBVgGIAAAMIhBAFIBBAmIAAAQg');
        this.shape.setTransform(4.1, 3.5);

        this.shape_1 = new cjs.Shape();
        this.shape_1.graphics
            .f('#FFD172')
            .s()
            .p('AhAghIAHgDIB6BFIgHAEg');
        this.shape_1.setTransform(0.2, 0.1);

        this.shape_2 = new cjs.Shape();
        this.shape_2.graphics
            .lf(['#AA8047', '#8C6A43'], [0, 1], -0.3, -1, 0.3, 1.4)
            .s()
            .p('AgNgCIAGgDIAWALg');
        this.shape_2.setTransform(9.4, 5.2);

        this.shape_3 = new cjs.Shape();
        this.shape_3.graphics
            .f('#FFD172')
            .s()
            .p('AgjgQIAHgEIBAAlIgHAEg');
        this.shape_3.setTransform(11.6, 6.6);

        this.shape_4 = new cjs.Shape();
        this.shape_4.graphics
            .f('#FFD172')
            .s()
            .p('AgtAFIAHgDIBUgHIgHAEIgiAHg');
        this.shape_4.setTransform(10.6, 3.3);

        this.shape_5 = new cjs.Shape();
        this.shape_5.graphics
            .lf(['#AA8047', '#8C6A43'], [0, 1], 2.6, 1.6, -1.6, -0.9)
            .s()
            .p('AgCgMIAFgEIAAAdIgFAEg');
        this.shape_5.setTransform(7.5, 4.3);

        this.shape_6 = new cjs.Shape();
        this.shape_6.graphics
            .f('#F0B860')
            .s()
            .p('AhugxIAAgdIDeCAIAAAdg');
        this.shape_6.setTransform(-4, -2);

        this.shape_7 = new cjs.Shape();
        this.shape_7.graphics
            .f('#FFD172')
            .s()
            .p('Ahyg+IAHgDIDeB/IgHAEg');
        this.shape_7.setTransform(-3.7, -3.6);

        this.timeline.addTween(
            cjs.Tween.get({})
                .to({
                    state: [
                        {t: this.shape_7},
                        {t: this.shape_6},
                        {t: this.shape_5},
                        {t: this.shape_4},
                        {t: this.shape_3},
                        {t: this.shape_2},
                        {t: this.shape_1},
                        {t: this.shape}
                    ]
                })
                .wait(1)
        );
    }).prototype = getMCSymbolPrototype(lib.Symbol18, (rect = new cjs.Rectangle(-15.1, -10.2, 30.3, 20.5)), [rect]);

    (lib.Symbol17 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .lf(['#F1ECE6', '#DACBBF'], [0, 1], -1, 3.4, 1.1, -4.9)
            .s()
            .p('AgVgSIArAYIgWANg');
        this.shape.setTransform(-10.5, 14.3);

        this.shape_1 = new cjs.Shape();
        this.shape_1.graphics
            .f('#DACBBF')
            .s()
            .p('AAAAMIgRgcIAAgGIAOAIIAUAlg');
        this.shape_1.setTransform(-12.2, 13.9);

        this.shape_2 = new cjs.Shape();
        this.shape_2.graphics
            .f('#AB9996')
            .s()
            .p('AiEA0ID0iNIAVAmIj0CNg');
        this.shape_2.setTransform(0.7, 7.2);

        this.shape_3 = new cjs.Shape();
        this.shape_3.graphics
            .lf(['#AA8047', '#8C6A43'], [0, 1], -2.5, -10, 5.3, 21.2)
            .s()
            .p('Ah5ACID0iMIAACJIj0CMg');
        this.shape_3.setTransform(-0.4, -1.5);

        this.shape_4 = new cjs.Shape();
        this.shape_4.graphics
            .f('#FFD172')
            .s()
            .p('AiABDID0iNIANAIIj0CMg');
        this.shape_4.setTransform(-1.1, -8.7);

        this.shape_5 = new cjs.Shape();
        this.shape_5.graphics
            .lf(['#AA8047', '#8C6A43'], [0, 1], -4, 14.4, 0.7, -2.3)
            .s()
            .p('AAABRIgRgdIAAiOIAOAHIAACIIAUAmg');
        this.shape_5.setTransform(12.3, -7.1);

        this.shape_6 = new cjs.Shape();
        this.shape_6.graphics
            .f('#F0B860')
            .s()
            .p('AAABRIgRgdIAAiOIAOAHIAACIIAUAmg');
        this.shape_6.setTransform(-12.2, 7.1);

        this.timeline.addTween(
            cjs.Tween.get({})
                .to({
                    state: [{t: this.shape_6}, {t: this.shape_5}, {t: this.shape_4}, {t: this.shape_3}, {t: this.shape_2}, {t: this.shape_1}, {t: this.shape}]
                })
                .wait(1)
        );
    }).prototype = getMCSymbolPrototype(lib.Symbol17, (rect = new cjs.Rectangle(-14, -16.2, 28, 32.4)), [rect]);

    (lib.Symbol15 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .lf(['#A27F5C', '#82684B'], [0, 1], 30.3, 41.4, -85, -86.6)
            .s()
            .p('AiNDCIAAmLIEbCkIAAAdIkMicIAAFug');
        this.shape.setTransform(0, -7.8);

        this.shape_1 = new cjs.Shape();
        this.shape_1.graphics
            .f('#E5BB76')
            .s()
            .p('AiNB0IAAmLIEbCkIAAGLg');

        this.timeline.addTween(
            cjs.Tween.get({})
                .to({state: [{t: this.shape_1}, {t: this.shape}]})
                .wait(1)
        );
    }).prototype = getMCSymbolPrototype(lib.Symbol15, (rect = new cjs.Rectangle(-14.1, -28, 28.4, 56)), [rect]);

    (lib.Symbol14 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .f('rgba(97,94,97,0.4)')
            .s()
            .p(
                'AglBtIgGgDIACgBQgPgBgLgIQgGgDABgCQAAgDAHAAIABAAIgDgBIgIAAIhJgqIADgBIgMgDQgMgDgIgFQgIgFABgDQABgDAJAAQAWAAATALQAIAFgBADIAAABIAEAAIAAgBIABgDIgOgIIAFgDIAHAAIAIAFIAFAAIAegRIgYAAIgHAEIgLAAIgFgDIACgBIgHAAIgHAEIgYAAIgkgUICLhDIgHgoIBMAAIBbA0IggATIAaAAIAEgDIAOAAIAEADIAIAAIAKAGIgFADIgHAAIgCABIAEACIgFADIgIAAIgNAIIADACIgFADIgHAAIgCABIAEACIgCABIAQABIADgBIAUAAIAEACIgFADIBJAqIhOAuIgJAAIgEgCIgiAEIgPAIIgcAAIgPAJIgcAAIgEACgAguBGIABAAIgRgKgAAMACIApAYIAogXIgmgCIgDgBIgggCgAAkgSIAZAAIAHgEIgZAAg'
            );

        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));
    }).prototype = getMCSymbolPrototype(lib.Symbol14, (rect = new cjs.Rectangle(-20, -10.9, 40.1, 21.9)), [rect]);

    (lib.Symbol11 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .f('#4F5552')
            .s()
            .p('AgqAmIBwhBIAPAJIhxBAgAhUATIBxhBIAOAJIhwBBg');
        this.shape.setTransform(0, -0.2);

        this.shape_1 = new cjs.Shape();
        this.shape_1.graphics
            .f('#273433')
            .s()
            .p('AgjAoIBxhAIAAAEIhxBAgAhNAWIBxhBIAAAEIhxBBg');
        this.shape_1.setTransform(0.7, 0.4);

        this.timeline.addTween(
            cjs.Tween.get({})
                .to({state: [{t: this.shape_1}, {t: this.shape}]})
                .wait(1)
        );
    }).prototype = getMCSymbolPrototype(lib.Symbol11, (rect = new cjs.Rectangle(-8.5, -4.8, 17, 9.7)), [rect]);

    (lib.Symbol9 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .f('#273433')
            .s()
            .p('AhcgJIAAgEIBwBBIAAAEgAgTgzIAAgEIBwBBIAAAEg');
        this.shape.setTransform(-0.7, 0.4);

        this.shape_1 = new cjs.Shape();
        this.shape_1.graphics
            .f('#4F5552')
            .s()
            .p('AhjgHIAOgIIBxBBIgPAIgAgbgwIAPgJIBwBBIgOAIg');
        this.shape_1.setTransform(0, -0.2);

        this.timeline.addTween(
            cjs.Tween.get({})
                .to({state: [{t: this.shape_1}, {t: this.shape}]})
                .wait(1)
        );
    }).prototype = getMCSymbolPrototype(lib.Symbol9, (rect = new cjs.Rectangle(-10, -6, 20.1, 12)), [rect]);

    (lib.Symbol8 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .f('#273433')
            .s()
            .p('AgCAPIAAgLIAFADIAAALgAgCgGIAAgLIAFADIAAALg');
        this.shape.setTransform(-5.4, 3.2);

        this.shape_1 = new cjs.Shape();
        this.shape_1.graphics
            .f('#4F5552')
            .s()
            .p('AgFAKIACAAIAAAAIAJAAIgGADgAgFgLIACgBIAAAAIAJAAIgGAEg');
        this.shape_1.setTransform(-5.1, 2.6);

        this.shape_2 = new cjs.Shape();
        this.shape_2.graphics
            .lf(['#091B19', '#FFFFFF'], [0, 1], 0.6, 0.9, 3.1, 5.1)
            .s()
            .p('AgBAAIACgBIAAADg');
        this.shape_2.setTransform(-4.2, 4.5);

        this.shape_3 = new cjs.Shape();
        this.shape_3.graphics
            .lf(['#001511', '#112220'], [0, 1], -2, -3.1, -0.1, 0.2)
            .s()
            .p('Ag3AfIBpg9IAGADIhmA6g');
        this.shape_3.setTransform(0.1, 0.4);

        this.shape_4 = new cjs.Shape();
        this.shape_4.graphics
            .lf(['#001511', '#112220'], [0, 1], -2, -3.3, -0.1, 0)
            .s()
            .p('AguAdIgJAAIBpg9IAGADIhrA+g');
        this.shape_4.setTransform(0.1, -1.6);

        this.shape_5 = new cjs.Shape();
        this.shape_5.graphics
            .f('#091B19')
            .s()
            .p('Ag1AlIAGgDIBlg7IAAALIhSAwIAAADIgPAIIAAgDIgDACIgHAEgAg1APIBrg+IAAAKIhrA/gAAdAAIAOgIIAAAFIgOAHg');
        this.shape_5.setTransform(0.3, 0.2);

        this.timeline.addTween(
            cjs.Tween.get({})
                .to({state: [{t: this.shape_5}, {t: this.shape_4}, {t: this.shape_3}, {t: this.shape_2}, {t: this.shape_1}, {t: this.shape}]})
                .wait(1)
        );
    }).prototype = getMCSymbolPrototype(lib.Symbol8, (rect = new cjs.Rectangle(-5.7, -4.9, 11.4, 9.9)), [rect]);

    (lib.Symbol6 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .lf(['#FF5300', 'rgba(255,83,0,0)'], [0.157, 1], 8.2, 0, -6.2, 0)
            .s()
            .p('Ag+hUIB9BJIAAAVIh9BLg');
        this.shape.setTransform(-6.2, 0.1);

        this.shape_1 = new cjs.Shape();
        this.shape_1.graphics
            .lf(['#FF5300', 'rgba(255,83,0,0)'], [0.157, 1], -8.1, 0, 6.3, 0)
            .s()
            .p('Ag+AMIAAgVIB9hLIAACpg');
        this.shape_1.setTransform(6.3, -0.1);

        this.timeline.addTween(
            cjs.Tween.get({})
                .to({state: [{t: this.shape_1}, {t: this.shape}]})
                .wait(1)
        );
    }).prototype = getMCSymbolPrototype(lib.Symbol6, (rect = new cjs.Rectangle(-12.5, -8.6, 25, 17.3)), [rect]);

    (lib.Symbol3 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .lf(['#B29F9B', '#867C7C'], [0, 1], -2.8, -4.9, 10.3, 17.9)
            .s()
            .p('Ag9gWIB7hHIAAB0Ih7BHg');
        this.shape.setTransform(4.5, 2.6);

        this.shape_1 = new cjs.Shape();
        this.shape_1.graphics
            .f('#DACBBF')
            .s()
            .p('AgsAgIAAh0IBaA1IAAB0g');
        this.shape_1.setTransform(-6.2, 3.6);

        this.shape_2 = new cjs.Shape();
        this.shape_2.graphics
            .f('#F1ECE6')
            .s()
            .p('AhqAKIB7hHIBaA0Ih6BHg');
        this.shape_2.setTransform(0, -5.8);

        this.timeline.addTween(
            cjs.Tween.get({})
                .to({state: [{t: this.shape_2}, {t: this.shape_1}, {t: this.shape}]})
                .wait(1)
        );
    }).prototype = getMCSymbolPrototype(lib.Symbol3, (rect = new cjs.Rectangle(-10.7, -12, 21.5, 24.1)), [rect]);

    (lib.Symbol2 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .lf(['#B1906B', '#8F724F'], [0, 1], -1.1, 2, -0.2, 0.5)
            .s()
            .p('AgEgFIAJAFIgJAGg');
        this.shape.setTransform(-10.6, 2.1);

        this.shape_1 = new cjs.Shape();
        this.shape_1.graphics
            .lf(['#B1906B', '#8F724F'], [0, 1], -1.1, 2, -0.2, 0.5)
            .s()
            .p('AgEgFIAJAFIgJAGg');
        this.shape_1.setTransform(-6.5, 4.5);

        this.shape_2 = new cjs.Shape();
        this.shape_2.graphics
            .lf(['#B1906B', '#8F724F'], [0, 1], -1.1, 3.5, 1.3, -0.7)
            .s()
            .p('AAUAKIgMAAIAKgFIAQAIIAAAGgAghgMIAAgBIAPAJgAgVgMIgMgBIALgFIAPAJIAAAFg');
        this.shape_2.setTransform(-7.8, 4);

        this.shape_3 = new cjs.Shape();
        this.shape_3.graphics
            .lf(['#B1906B', '#8F724F'], [0, 1], 0.9, 2.5, -1.1, -1.2)
            .s()
            .p('AAXAWIAPgIIACABIgMAGIAAABIgBAAgAACAKIAPgIIACABIgMAGIAAABIgBAAgAgSgBIAQgIIABABIgMAGIAAABIgBAAgAgngNIAQgIIACABIgMAGIAAABIgCAAg');
        this.shape_3.setTransform(-7.2, 2.4);

        this.shape_4 = new cjs.Shape();
        this.shape_4.graphics
            .f('#F0BD92')
            .s()
            .p(
                'AgNAjIgFgDIgqgYIAAgXIAPAIIAAAFIAGACIAAgDIAAAAIAAAAIAPAIIAAAEIAFACIAAgDIAAAAIAQAJIAAADIAEAEIAAgEIAAgBIABABIAPAIIAAAFIAFACIAAgDIAAAAIAAAAIAPAJIAAAXgAgDAkIAZAQIAAgHIAAgGIgQgIIgJgGgAgtAMIAAABIAPAIIAKAGIABABIAAgHIAAgFIgPgJIgLgHgAgCgbIAEgDIABACIgFADgAA3g8IAFgDIABABIgGAEg'
            );
        this.shape_4.setTransform(-6.6, 1.4);

        this.shape_5 = new cjs.Shape();
        this.shape_5.graphics
            .lf(['#B1906B', '#8F724F'], [0, 1], -1.1, 1.2, 1.3, -3)
            .s()
            .p('AANAPIAKgHIACABIgLAHgAAcAHIgBAAIACAAgAgcgJIAKgFIACABIgKAFg');
        this.shape_5.setTransform(-1.8, 0.7);

        this.shape_6 = new cjs.Shape();
        this.shape_6.graphics
            .lf(['#B1906B', '#8F724F'], [0, 1], 1.8, 7.6, 0.5, 2.2)
            .s()
            .p(
                'AAeAYIARgKIAAAUgAAJAMIADgBIABABIgCABgAAWAEIAEgBIACAAIgEACgAgMAAIARgJIACACIgRAJgAgggLIADgCIACABIgDADgAgTgSIAEgDIACABIgDADgAgugbIALgGIAAAAIABABIgKAHg'
            );
        this.shape_6.setTransform(-1.7, 1.1);

        this.shape_7 = new cjs.Shape();
        this.shape_7.graphics
            .f('rgba(97,94,97,0.4)')
            .s()
            .p('AhNAtIAQgJIAAgUIAZgPIARAKIAQgIIAAgTIAYgPIAJAFIggATIACACIAhgTIAFADIAPgJIAAgOIAEACIgCACIADABIAEAAIAQAJIiDBLgAg8AZIADACIAhgTIgDgBg');
        this.shape_7.setTransform(4.9, 3.4);

        this.shape_8 = new cjs.Shape();
        this.shape_8.graphics
            .lf(['#B1906B', '#8F724F'], [0, 1], -1.5, -2.8, 2.9, 5.1)
            .s()
            .p('AhBAaICDhLIAAAKIAAAOIgQAJIAAgUIgRAKIgZAPIAAATIgOAIIAAgTIgRAJIgaAPIAAAUIgQAJg');
        this.shape_8.setTransform(3.7, 2.9);

        this.shape_9 = new cjs.Shape();
        this.shape_9.graphics
            .lf(['#B1906B', '#8F724F'], [0, 1], -0.1, -0.2, 1, 1.7)
            .s()
            .p('AhAAkICBhLIAAAEIgPAJIgDACIgKAGIgEACIgZAPIgPAIIgDACIgLAGIgDACIgZAOIgPAJg');
        this.shape_9.setTransform(1.7, 0.7);

        this.shape_10 = new cjs.Shape();
        this.shape_10.graphics
            .lf(['#B1906B', '#8F724F'], [0, 1], -3.3, 7.1, 0, 0.5)
            .s()
            .p('AAXAWIAPgJIACABIgPAJgAACAJIAPgIIACABIgPAJgAgSgBIAQgJIABABIgPAJgAgngNIAAgBIAQgIIACABIgQAJg');
        this.shape_10.setTransform(-1.4, -0.8);

        this.shape_11 = new cjs.Shape();
        this.shape_11.graphics
            .f('#615E61')
            .s()
            .p(
                'Ag+AmIABAAIAFAEgAhJAcIAFACIAFADgAgKAeIAZgOIABABIgYAOgAgfASIAZgPIACACIgZAOgAgzAGIAZgNIACABIgaANgAAvgCIAZgPIACABIgZAPgAAagOIAZgPIACABIgZAPgAAGgaIAZgPIABABIgZAPg'
            );
        this.shape_11.setTransform(-2.3, 0.8);

        this.shape_12 = new cjs.Shape();
        this.shape_12.graphics
            .lf(['#B1906B', '#8F724F'], [0, 1], -0.1, -0.2, 1, 1.7)
            .s()
            .p('AhBAkICDhLIAAAEIgPAJIgBAAIgRAKIgZAPIgOAHIgSAKIgZAPIgQAJg');
        this.shape_12.setTransform(-0.4, -0.5);

        this.shape_13 = new cjs.Shape();
        this.shape_13.graphics
            .lf(['#B1906B', '#8F724F'], [0, 1], 1.8, 7.5, 0.4, 2.1)
            .s()
            .p(
                'AApAfIgDgCIgJgFIARgKIAAAUgAAIAMIAEgCIACABIgEACgAAXAEIADgCIABABIgDACgAgLAAIAQgJIACABIgQAJgAgggLIAEgCIABABIgDACgAgSgTIADgCIACABIgEACgAgtgbIAJgGIACABIgLAGg'
            );
        this.shape_13.setTransform(4.1, -2.2);

        this.shape_14 = new cjs.Shape();
        this.shape_14.graphics
            .lf(['#B1906B', '#8F724F'], [0, 1], -0.3, 1.8, 2.1, -2.4)
            .s()
            .p('AANAQIAKgHIACABIgKAHgAAcAJIgBgBIACABgAAHgCIgBgCIAAAAIACACgAgcgIIALgGIABABIgKAGgAgMgPIgCgBIACABg');
        this.shape_14.setTransform(4, -2.7);

        this.shape_15 = new cjs.Shape();
        this.shape_15.graphics
            .lf(['#B1906B', '#8F724F'], [0, 1], -0.1, -0.2, 1, 1.7)
            .s()
            .p('AhBAkICChLIAAAEIgPAJIgDACIgKAGIgEACIgZAPIgPAIIgEACIgKAGIgDACIgZAOIgQAJg');
        this.shape_15.setTransform(-2.5, -1.7);

        this.shape_16 = new cjs.Shape();
        this.shape_16.graphics
            .lf(['#B1906B', '#8F724F'], [0, 1], -5.9, 12.1, -2.6, 5.6)
            .s()
            .p('AAXAWIAPgJIACABIgPAJgAACAKIAPgJIACABIgPAJgAgSgBIAPgJIACABIgPAJgAgngNIAQgJIACABIgLAGIAAAAIgFADg');
        this.shape_16.setTransform(4.4, -4.2);

        this.shape_17 = new cjs.Shape();
        this.shape_17.graphics
            .lf(['#B1906B', '#8F724F'], [0, 1], -0.1, -0.2, 1, 1.7)
            .s()
            .p('AhBAkIBIgpIAKgGIAwgcIABAEIgQAJIgKAGIgFADIgbAQIgPAHIgKAGIgFADIgbAQIgQAJg');
        this.shape_17.setTransform(-4.6, -2.9);

        this.shape_18 = new cjs.Shape();
        this.shape_18.graphics
            .f('#FFDBB4')
            .s()
            .p(
                'Ag5A5IAMAAIAOAIIAAAHgAgeA0IgBAAIAMgHIAZgOIADgCIALgGIADgCIAAAAIAPgJIAagOIADgCIAKgGIAEgCIAAAAIAPgJIAEgCIAPAJIiCBLgAgkA1IAEAAIABgBIAAAEgAgzAoIAAAAIAMgHIAZgOIAQgKIAQgJIAZgOIARgKIAAAAIAPgJIAEgCIAPAJIiCBLgAhKAvIgFgDIgFgCIgOgJIAMAAIAOAIIAAAHgAg5ApIAEAAIACgBIAAAEgAhIAcIAMgHIAZgOIADgCIALgFIADgCIAQgJIAYgPIADgCIALgGIADgCIABAAIAPgJIADgCIAPAJIiCBLgAhNAdIAEAAIABgBIAAAEgAhcAQIgBAAIAMgHIAZgOIAHgDIAKgGIAQgJIAYgPIAHgDIAKgHIAFgDIABAAIAKgGIADgCIAOAIIACABIiCBLgAhiARIAEAAIABgBIAAAEgAhyAEICDhLIAPAJIgvAcIAAAAIgLAGIhIApg'
            );
        this.shape_18.setTransform(-1.2, -0.6);

        this.timeline.addTween(
            cjs.Tween.get({})
                .to({
                    state: [
                        {t: this.shape_18},
                        {t: this.shape_17},
                        {t: this.shape_16},
                        {t: this.shape_15},
                        {t: this.shape_14},
                        {t: this.shape_13},
                        {t: this.shape_12},
                        {t: this.shape_11},
                        {t: this.shape_10},
                        {t: this.shape_9},
                        {t: this.shape_8},
                        {t: this.shape_7},
                        {t: this.shape_6},
                        {t: this.shape_5},
                        {t: this.shape_4},
                        {t: this.shape_3},
                        {t: this.shape_2},
                        {t: this.shape_1},
                        {t: this.shape}
                    ]
                })
                .wait(1)
        );
    }).prototype = getMCSymbolPrototype(lib.Symbol2, (rect = new cjs.Rectangle(-12.7, -7.8, 25.4, 15.7)), [rect]);

    (lib.steam = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .lf(['#AEA5A3', '#6796AF'], [0, 1], -8.2, -2.7, 142.3, 46.2)
            .s()
            .p('Ag2gfIBtg/IAAB+IhtA/g');
        this.shape.setTransform(5.5, 3.1);

        this.shape_1 = new cjs.Shape();
        this.shape_1.graphics
            .f('#F1ECE6')
            .s()
            .p('AhrABIBsg/IBrA+IhsA+g');
        this.shape_1.setTransform(0.1, -6.3);

        this.shape_2 = new cjs.Shape();
        this.shape_2.graphics
            .f('#D7D4CE')
            .s()
            .p('Ag2AgIAAh+IBtA/IAAB+g');
        this.shape_2.setTransform(-5.4, 3.1);

        this.timeline.addTween(
            cjs.Tween.get({})
                .to({state: [{t: this.shape_2}, {t: this.shape_1}, {t: this.shape}]})
                .wait(1)
        );
    }).prototype = getMCSymbolPrototype(lib.steam, (rect = new cjs.Rectangle(-10.9, -12.6, 21.9, 25.2)), [rect]);

    (lib.tractor = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Symbol 17
        this.instance = new lib.Symbol17();
        this.instance.parent = this;
        this.instance.setTransform(-5.1, 19.9, 1, 1, 0, 0, 0, -13.5, 7.2);

        this.timeline.addTween(
            cjs.Tween.get(this.instance)
                .to({x: -2.4, y: 9.3}, 14, cjs.Ease.quadInOut)
                .to({x: -5.1, y: 19.9}, 15, cjs.Ease.cubicInOut)
                .wait(1)
        );

        // Symbol 18
        this.instance_1 = new lib.Symbol18();
        this.instance_1.parent = this;
        this.instance_1.setTransform(-31, 4.7, 1, 1, 0, 0, 0, -13.3, -7);

        this.timeline.addTween(
            cjs.Tween.get(this.instance_1)
                .to({regX: -13.4, rotation: -21.2, x: -31.1}, 14, cjs.Ease.quadInOut)
                .to({regX: -13.3, rotation: 0, x: -31}, 15, cjs.Ease.cubicInOut)
                .wait(1)
        );

        // Symbol 19
        this.instance_2 = new lib.Symbol19();
        this.instance_2.parent = this;
        this.instance_2.setTransform(16.2, 21);

        this.timeline.addTween(
            cjs.Tween.get(this.instance_2)
                .to({x: 20.2, y: 22.6}, 14, cjs.Ease.quadInOut)
                .to({x: 16.2, y: 21}, 15, cjs.Ease.cubicInOut)
                .wait(1)
        );

        // Layer_2
        this.shape = new cjs.Shape();
        this.shape.graphics
            .lf(['#302D23', '#1B1B0C'], [0, 1], 4.5, 0, 1.5, 0)
            .s()
            .p('AgDAWIAAgrIAHAAIAAArg');
        this.shape.setTransform(-3.8, -8);

        this.shape_1 = new cjs.Shape();
        this.shape_1.graphics
            .lf(['#302D23', '#1B1B0C'], [0, 1], 3.1, -2.2, 8.1, -6.9)
            .s()
            .p('AgDAFIgFgDIAAgDIACgBIADgCIAGAAIADACIADABIAAADIgGADg');
        this.shape_1.setTransform(-3.7, -10.7);

        this.shape_2 = new cjs.Shape();
        this.shape_2.graphics
            .lf(['#302D23', '#1B1B0C'], [0, 1], 6.2, 0, 2.1, 0)
            .s()
            .p('AgEAVIAAgpIAJAAIAAApg');
        this.shape_2.setTransform(-3.8, -3.5);

        this.shape_3 = new cjs.Shape();
        this.shape_3.graphics
            .lf(['#302D23', '#1B1B0C'], [0, 1], 0.2, 2.5, 0.5, 6.7)
            .s()
            .p('AgFAGIgHgEIAAgFIAEgCIAAAGIAFADIAGAAIAGAAIADgCIgHAEg');
        this.shape_3.setTransform(-3.7, -6.2);

        this.shape_4 = new cjs.Shape();
        this.shape_4.graphics
            .f('#A2835A')
            .s()
            .p(
                'AAmAkIgEgCIgDgCIgGgHIgCgGIAAgCIAAgIIACgFIAEAAIACAAIAHAEIAFAHIAEAIIAAAHIgCACIgBABIgBACIgCAAIgDABgAgegDIgCgBIgBgBIgBAAIgDgCIgFgHIgCgEIgCgEIAAgCIAAgGIAEgEIADAAIACgBIAHAEIAGAHIADAIIAAAGIAAACIgDAEIgEABg'
            );
        this.shape_4.setTransform(-21.7, 11.8);

        this.shape_5 = new cjs.Shape();
        this.shape_5.graphics
            .lf(['#AA8047', '#8C6A43'], [0, 1], 2.9, 1.1, -1.2, 0)
            .s()
            .p('AgrAHIAHgEIAAgJIAiAAIADACIAmAAIAFADIAAABIgEACIgFADIgBAAIghAAIgDACg');
        this.shape_5.setTransform(1.2, -2.2);

        this.shape_6 = new cjs.Shape();
        this.shape_6.graphics
            .f('#6D5B60')
            .s()
            .p('AgaAYIAAhOIA0AfIAABOg');
        this.shape_6.setTransform(-24.6, -14);

        this.shape_7 = new cjs.Shape();
        this.shape_7.graphics
            .f('#615054')
            .s()
            .p('AgMBKIgWgGIAAhMIAAhPIA1ALIAQBXIAABNg');
        this.shape_7.setTransform(-18.5, -7.7);

        this.shape_8 = new cjs.Shape();
        this.shape_8.graphics
            .lf(['#AA8047', '#8C6A43'], [0, 1], -5.4, -11.1, -1.8, -3.8)
            .s()
            .p('AgogqIA2ggIABAAIAFgDIAVgMIAACDIhRAwgAgfgkIAABuIA/glIAAhug');
        this.shape_8.setTransform(3.2, 5.8);

        this.shape_9 = new cjs.Shape();
        this.shape_9.graphics
            .lf(['#020900', '#1B1B0C'], [0, 1], 3.6, 6.3, -6.8, -11.7)
            .s()
            .p('AgfgkIA/glIAABuIg/Alg');
        this.shape_9.setTransform(3.2, 5.8);

        this.shape_10 = new cjs.Shape();
        this.shape_10.graphics
            .lf(['#020900', '#1B1B0C'], [0, 1], 1.9, 3.2, -2.6, -4.6)
            .s()
            .p('AgbAAIAtgZIAIAVIACAEIgtAag');
        this.shape_10.setTransform(-5.2, 14.4);

        this.shape_11 = new cjs.Shape();
        this.shape_11.graphics
            .lf(['#AA8047', '#8C6A43'], [0, 1], -1.1, -2.1, 2.5, 4.3)
            .s()
            .p('AgaAMIA1geIAAAHIgSAKIgjAUg');
        this.shape_11.setTransform(-17.6, 3.1);

        this.shape_12 = new cjs.Shape();
        this.shape_12.graphics
            .lf(['#AA8047', '#8C6A43'], [0, 1], 0.9, 1.7, -3.6, -8.4)
            .s()
            .p('AAegXIAWANIAAALIgYAOIhPAJg');
        this.shape_12.setTransform(-9.8, -8.9);

        this.shape_13 = new cjs.Shape();
        this.shape_13.graphics
            .lf(['#AA8047', '#8C6A43'], [0, 1], -1.6, -2.8, 6.7, 11.5)
            .s()
            .p('AgoAQIBSgvIAAARIhSAug');
        this.shape_13.setTransform(-12.4, -18.5);

        this.shape_14 = new cjs.Shape();
        this.shape_14.graphics
            .f('#423538')
            .s()
            .p('AggBEIgQhXIBSgwIAPBXIhRAwg');
        this.shape_14.setTransform(-11.7, -13.3);

        this.shape_15 = new cjs.Shape();
        this.shape_15.graphics
            .lf(['#AA8047', '#8C6A43'], [0, 1], -14.7, -6.5, 13.5, 4.9)
            .s()
            .p('AgGACIAGgDIACABIAFACg');
        this.shape_15.setTransform(-24.1, -1.9);

        this.shape_16 = new cjs.Shape();
        this.shape_16.graphics
            .lf(['#AA8047', '#8C6A43'], [0, 1], -3, -1.2, -0.8, -0.3)
            .s()
            .p('AgCgSIAFgDIAAAnIgFAEg');
        this.shape_16.setTransform(-24.4, -3.9);

        this.shape_17 = new cjs.Shape();
        this.shape_17.graphics
            .lf(['#AA8047', '#8C6A43'], [0, 1], 5.8, -2.1, -4.5, 1.8)
            .s()
            .p('AgBATIgCgBIAAgnIAGARIAAAag');
        this.shape_17.setTransform(-23.7, -3.9);

        this.shape_18 = new cjs.Shape();
        this.shape_18.graphics
            .lf(['#020900', '#1B1B0C'], [0, 1], 1.2, -2.3, -4.4, 4.4)
            .s()
            .p('AAwAqIgxgdIgBgBIhYgyIAEgCIB6BGIAkgVIABABIAFADIANAHIAAABIgkAVg');
        this.shape_18.setTransform(-23.9, 2);

        this.shape_19 = new cjs.Shape();
        this.shape_19.graphics
            .f('#1B1B0C')
            .s()
            .p(
                'AiIATIgSgUIgKgbIAAgYIAKgOIASgCIDuCKIAtgbIAKAMIAIAKIguAaIAKAbIAAAXIgKAOIgRACgAiVg4IgHALIAAATIABAEIAHARIAOARIBSAvIABABIABABIBCAnIAEABIAAAAIBQAuIAIAAIAGgBIADgFIACgCIADgEIAAgQIAAgDIgIgWIgOgSIgDgBIgSgKIghgTIgEgCIgYgPIgogXIgEgCIgYgNIgbgPIgKgHIgRgJIgRgKIgNgIIgGABIgIAAIAAAAgAB5ANIAAg6IAHADIAAA7gABrAFIAAg6IAHADIAAA7gABdgCIAAg7IAHADIAAA7gABPgKIAAg8IAHAEIAAA8gACVhGIAAgqIAHAFIAAApgACZhxIAAgHIAAgUIAAgMIAAgEIAFADIAAAsg'
            );
        this.shape_19.setTransform(-19.9, 5.3);

        this.shape_20 = new cjs.Shape();
        this.shape_20.graphics
            .lf(['#F0B860', '#AA8047'], [0, 1], -1.6, -5.9, 2.5, 9.4)
            .s()
            .p('AgaACIAAgPIA1AMIAAAOg');
        this.shape_20.setTransform(-19.3, -16.7);

        this.shape_21 = new cjs.Shape();
        this.shape_21.graphics
            .f('#FFD172')
            .s()
            .p(
                'AjYBLIAkgWIAAABIAFACIAAAIIBIAqIAOAAIAOAJIAWAGIAwANIABABIg2AfgAgFA6IAAAAIBPgJIAXgOIAAAUIgDACIAAAGIAAApIAHAFIALAAIApAAIAEgCIAhAAIg4AggADIBlIAAgCIgFgDIgmAAIgEgCIgiAAIAAgfIAAgGIgEgCIAAgWIBmA6IgWANgAivAXIAHgDIBIAqIgHADgAiSgPIAAANIgiAGgAhLg4IhHgqIB1hDIBHApIATAfIhSAwg'
            );
        this.shape_21.setTransform(-14.4, -12.3);

        this.shape_22 = new cjs.Shape();
        this.shape_22.graphics
            .f('#6B4832')
            .s()
            .p(
                'ABsBaIgPgSIgFgPIgDgGIAAgMIAAgHIAGgHIASAKIgHAAIgCAEIgDAEIAAALIAFANIAJALIAKAFIAJAAIADgEIAAAPIgDAFIgGAAgAAmAHIgGgHIgDgIIAAgCIAZANIAAACIgDADIgBACIgCAAIgDAAgAhtgjIgBAAIgIgLIgBAAIgEgHIgJgVIAAgTIADgEIAGgBIAOAIIgCAAIgEAAIgFAIIAAALIAFANIAJALIAKAFIAJAAIAEgIIAAgLIgEgNIgGgHIARAKIAGANIAAATIgGAIIgCADIgBABIgOABgAgXgcIgDgCIgEgCIgFgHIgCgEIgCgFIAAgCIAZAOIAAACIgDAFIgEABg'
            );
        this.shape_22.setTransform(-21, 9.3);

        this.shape_23 = new cjs.Shape();
        this.shape_23.graphics
            .f('#46321D')
            .s()
            .p('AA9AnIACgDIAAgCIAEACIAAABIgHAEgAgFgDIAAgCIAEACIAAABIgHADgAg9gIIAAgTIgFgNIALAGIABAEIAAAPIAAADIgIAMIgEAAg');
        this.shape_23.setTransform(-22, 6.2);

        this.shape_24 = new cjs.Shape();
        this.shape_24.graphics
            .lf(['#302D23', '#1B1B0C'], [0, 1], 1.4, 1.1, -0.7, -2.1)
            .s()
            .p('AgNgGIAIgEIAKADIAJAKIAAAAIgOAIg');
        this.shape_24.setTransform(-33.5, 5.3);

        this.shape_25 = new cjs.Shape();
        this.shape_25.graphics
            .f('#242217')
            .s()
            .p('AgBAAIADgCIAHAAIgEAEIgFABIgBgBIgHABg');
        this.shape_25.setTransform(-9.1, 19.7);

        this.shape_26 = new cjs.Shape();
        this.shape_26.graphics
            .lf(['#302D23', '#1B1B0C'], [0, 1], 3.4, 5, -1.2, -1.3)
            .s()
            .p('AgGgHIANALIgHAFg');
        this.shape_26.setTransform(-34.8, 3.8);

        this.shape_27 = new cjs.Shape();
        this.shape_27.graphics
            .f('#302D23')
            .s()
            .p(
                'ABuBwIABAAIgIABgAAYBDIADAAIACAAIABgDIABgBIBPAuIgHAEgAguAaIACABIACAAIAEgBIADgEIAAgCIAeASIgDACIARALIACAFIAGAHIADACgAhEgWIgSAAIACgDIAEAAIAJgMIAAgDICVBVIAAAMIACAGgAiFhmIgRACIAVgMIAHAEIgEACIBYA0IABAAIAxAdIAGAAIAlgVIANAIIBTAuIgtAbgAiDgVIAOgIIARAJIgEACIAsAZIAAABIACAFIACADIAFAIIADABg'
            );
        this.shape_27.setTransform(-20.3, 8.7);

        this.shape_28 = new cjs.Shape();
        this.shape_28.graphics
            .f('#020900')
            .s()
            .p(
                'AB4COIAAgYIAugaIAAAXIgKAPIguAagAATBiIABgBIAAgIIgDgIIgGgHIgHgEIgCABIgCAAIgDAFIAAAHIABADIgTgLIAEgCIgfgRIAAgGIgDgIIgGgHIgGgEIgDAAIgDAAIgDAFIAAAGIgsgaIADgCIAOgBIABgBIASAAICUBWIAFAPIAPASIAQAJIAGAAIgBABIgIABIgDACgABbB3IgJgLIgFgNIAAgLIADgEIACgEIAHAAIACABIAOASIAIAVIAAAEIgDAEIgJABgAh+gGIgJgLIgFgNIAAgLIAFgIIAEAAIACAAIAQAJIAGAHIAEANIAAAMIgEAHIgJABgAiVgJIgOgMIgCgEIAAgTIAIgMIAAAAIAIAAIgDAEIAAATIAJAVIAEAHIABAAgACehrIAHgEIAAAfIAAAKIgHAFgACchtIAAgrIAGgDIAAAOIAAAWIADACIAAAGIgDACg'
            );
        this.shape_28.setTransform(-19, 5.2);

        this.shape_29 = new cjs.Shape();
        this.shape_29.graphics
            .lf(['#AA8047', '#8C6A43'], [0, 1], 1, 1.4, -0.5, 0.6)
            .s()
            .p('AADAKIAAAAIgMgIIgFgCIgBAAIARgKIAAgHIAOAjg');
        this.shape_29.setTransform(-15.1, 3);

        this.shape_30 = new cjs.Shape();
        this.shape_30.graphics
            .lf(['#AA8047', '#8C6A43'], [0, 1], -7.1, -4.1, -11.7, -6.7)
            .s()
            .p('AACAMIgHgUIgIgKIAGADIAQAVIAFANg');
        this.shape_30.setTransform(-2.8, 12.7);

        this.shape_31 = new cjs.Shape();
        this.shape_31.graphics
            .f('#F0B860')
            .s()
            .p(
                'ACrC3IgFgOIgRgVIgGgEIgKgMIhTgvIgOgkIgBgBIAAhMICNBQIAACFgABrBmIAHAEIAAg7IgHgEgABdBeIAHAEIAAg7IgHgEgABPBWIAHAEIAAg7IgHgEgABBBOIAHAEIAAg7IgHgEgAiMAPIgHgEIgcgPIAAgHICeBbIAAAGgAghAcIgPgIIgFgDIAFADIAAgbIgHgRIhIgqIgHAEIBJAqIAAAoIhJgpIAAgIIgEgDIAAAAIAAgyIAhgHIAAgMIAAhTIBIApIAAAQIg1geIAABPIA1AeIAABMIAVAGg'
            );
        this.shape_31.setTransform(-18.5, -3.7);

        this.shape_32 = new cjs.Shape();
        this.shape_32.graphics
            .f('#000000')
            .s()
            .p('AhMghIAAgPIgCgEIAbAQIAAACIACAEIACAEIAFAHIADACIAEACIACAAIADgBIAHgEIAAAAIAoAWIAAACIADAJIAGAHIAGAEIADgBIADAAIAHgEIAAAAIAhATIgFAHIAAAIg');
        this.shape_32.setTransform(-19.8, 8);

        this.timeline.addTween(
            cjs.Tween.get({})
                .to({
                    state: [
                        {t: this.shape_32},
                        {t: this.shape_31},
                        {t: this.shape_30},
                        {t: this.shape_29},
                        {t: this.shape_28},
                        {t: this.shape_27},
                        {t: this.shape_26},
                        {t: this.shape_25},
                        {t: this.shape_24},
                        {t: this.shape_23},
                        {t: this.shape_22},
                        {t: this.shape_21},
                        {t: this.shape_20},
                        {t: this.shape_19},
                        {t: this.shape_18},
                        {t: this.shape_17},
                        {t: this.shape_16},
                        {t: this.shape_15},
                        {t: this.shape_14},
                        {t: this.shape_13},
                        {t: this.shape_12},
                        {t: this.shape_11},
                        {t: this.shape_10},
                        {t: this.shape_9},
                        {t: this.shape_8},
                        {t: this.shape_7},
                        {t: this.shape_6},
                        {t: this.shape_5},
                        {t: this.shape_4},
                        {t: this.shape_3},
                        {t: this.shape_2},
                        {t: this.shape_1},
                        {t: this.shape}
                    ]
                })
                .wait(30)
        );

        // Layer_3
        this.shape_33 = new cjs.Shape();
        this.shape_33.graphics
            .f('#615E61')
            .s()
            .p('AAFB3IgdgGIgdgKIjviJIgGgKIA4ggIAXAAIAEAAIAEABIAEABIADABIADAAIBpAAIAxANIBjg6IBfAAIBIAqIATAfIgwAbIBtA+IhTAvIiFAAIgDgCIgzAeg');
        this.shape_33.setTransform(-4.3, 10.7);

        this.timeline.addTween(cjs.Tween.get(this.shape_33).wait(30));
    }).prototype = p = new cjs.MovieClip();
    p.nominalBounds = rect = new cjs.Rectangle(-36.4, -28.9, 72.8, 58);
    p.frameBounds = [
        rect,
        rect,
        new cjs.Rectangle(-36.4, -28.9, 72.9, 58.1),
        new cjs.Rectangle(-36.4, -28.9, 73.1, 58.2),
        new cjs.Rectangle(-36.4, -28.9, 73.4, 58.3),
        new cjs.Rectangle(-36.4, -28.9, 73.8, 58.4),
        new cjs.Rectangle(-36.4, -28.9, 74.2, 58.6),
        new cjs.Rectangle(-36.4, -28.9, 74.8, 58.8),
        new cjs.Rectangle(-36.4, -28.9, 75.3, 59.1),
        new cjs.Rectangle(-36.4, -28.9, 75.8, 59.3),
        new cjs.Rectangle(-36.4, -28.9, 76.1, 59.4),
        new cjs.Rectangle(-36.4, -28.9, 76.4, 59.5),
        new cjs.Rectangle(-36.4, -28.9, 76.6, 59.6),
        new cjs.Rectangle(-36.4, -28.9, 76.7, 59.7),
        (rect = new cjs.Rectangle(-36.4, -28.9, 76.8, 59.7)),
        rect,
        new cjs.Rectangle(-36.4, -28.9, 76.7, 59.7),
        new cjs.Rectangle(-36.4, -28.9, 76.6, 59.6),
        new cjs.Rectangle(-36.4, -28.9, 76.4, 59.6),
        new cjs.Rectangle(-36.4, -28.9, 76.2, 59.4),
        new cjs.Rectangle(-36.4, -28.9, 75.8, 59.3),
        new cjs.Rectangle(-36.4, -28.9, 75.1, 59),
        new cjs.Rectangle(-36.4, -28.9, 74.4, 58.7),
        new cjs.Rectangle(-36.4, -28.9, 73.8, 58.4),
        new cjs.Rectangle(-36.4, -28.9, 73.4, 58.3),
        new cjs.Rectangle(-36.4, -28.9, 73.1, 58.2),
        new cjs.Rectangle(-36.4, -28.9, 72.9, 58.1),
        (rect = new cjs.Rectangle(-36.4, -28.9, 72.8, 58)),
        rect,
        rect
    ];

    (lib.Symbol49 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.instance = new lib.Symbol54();
        this.instance.parent = this;

        this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));
    }).prototype = getMCSymbolPrototype(lib.Symbol49, (rect = new cjs.Rectangle(-23.1, -16.6, 46.3, 33.3)), [rect]);

    (lib.Symbol28 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_3 (mask)
        let mask = new cjs.Shape();
        mask._off = true;
        var mask_graphics_0 = new cjs.Graphics().p('AwXENIWSr5IABl/IEGCSIGWDyIAAGfIzQO1g');
        var mask_graphics_62 = new cjs.Graphics().p('AtHFcIRw0WIECCJIEdCnIAAGKIsyS7g');

        this.timeline.addTween(
            cjs.Tween.get(mask)
                .to({graphics: mask_graphics_0, x: -50.7, y: 61.4})
                .wait(62)
                .to({graphics: mask_graphics_62, x: -71.4, y: 53.5})
                .wait(61)
        );

        // Layer_2
        this.instance = new lib.Symbol49();
        this.instance.parent = this;
        this.instance.setTransform(80.4, 5.1);

        var maskedShapeInstanceList = [this.instance];

        for (var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
            maskedShapeInstanceList[shapedInstanceItr].mask = mask;
        }

        this.timeline.addTween(
            cjs.Tween.get(this.instance)
                .wait(15)
                .to({x: 80.1, y: 5.2}, 0)
                .wait(1)
                .to({x: 79, y: 5.8}, 0)
                .wait(1)
                .to({x: 77.3, y: 6.7}, 0)
                .wait(1)
                .to({x: 74.7, y: 8.1}, 0)
                .wait(1)
                .to({x: 71.4, y: 9.9}, 0)
                .wait(1)
                .to({x: 67.1, y: 12.2}, 0)
                .wait(1)
                .to({x: 62, y: 14.9}, 0)
                .wait(1)
                .to({x: 56, y: 18.1}, 0)
                .wait(1)
                .to({x: 49.1, y: 21.8}, 0)
                .wait(1)
                .to({x: 41.3, y: 26}, 0)
                .wait(1)
                .to({x: 32.8, y: 30.6}, 0)
                .wait(1)
                .to({x: 23.6, y: 35.5}, 0)
                .wait(1)
                .to({x: 13.8, y: 40.7}, 0)
                .wait(1)
                .to({x: 3.8, y: 46.1}, 0)
                .wait(1)
                .to({x: -6.4, y: 51.5}, 0)
                .wait(1)
                .to({x: -16.4, y: 56.9}, 0)
                .wait(1)
                .to({x: -26.2, y: 62.2}, 0)
                .wait(1)
                .to({x: -35.4, y: 67.1}, 0)
                .wait(1)
                .to({x: -44.1, y: 71.7}, 0)
                .wait(1)
                .to({x: -51.9, y: 76}, 0)
                .wait(1)
                .to({x: -59, y: 79.8}, 0)
                .wait(1)
                .to({x: -65.3, y: 83.1}, 0)
                .wait(1)
                .to({x: -70.7, y: 86}, 0)
                .wait(1)
                .to({x: -75.2, y: 88.4}, 0)
                .wait(1)
                .to({x: -79, y: 90.5}, 0)
                .wait(1)
                .to({x: -82, y: 92.1}, 0)
                .wait(1)
                .to({x: -84.2, y: 93.3}, 0)
                .wait(1)
                .to({x: -85.8, y: 94.1}, 0)
                .wait(1)
                .to({x: -86.7, y: 94.6}, 0)
                .wait(1)
                .to({x: -87, y: 94.8}, 0)
                .wait(18)
                .to({x: 39.4, y: -28.2}, 33, cjs.Ease.quadInOut)
                .wait(28)
        );

        // Layer_1 (mask)
        let mask_1 = new cjs.Shape();
        mask_1._off = true;
        mask_1.graphics.p('Ah+BoIijhSIAAgBIj+iRIAAluID+CTIAAEaIAwAMIAAAAIBzAcIAAjxID9CTIAAD6ICjBOIAAjqID+CSIAAFug');

        // Symbol 31
        this.instance_1 = new lib.Symbol31();
        this.instance_1.parent = this;
        this.instance_1.setTransform(41.7, 23.5);

        var maskedShapeInstanceList = [this.instance_1];

        for (var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
            maskedShapeInstanceList[shapedInstanceItr].mask = mask_1;
        }

        this.timeline.addTween(
            cjs.Tween.get(this.instance_1)
                .to({y: -15.2}, 14, cjs.Ease.cubicInOut)
                .wait(20)
                .to({y: 23.5}, 10, cjs.Ease.cubicInOut)
                .wait(79)
        );

        // Symbol 30
        this.instance_2 = new lib.Symbol30();
        this.instance_2.parent = this;
        this.instance_2.setTransform(0, -0.6);

        this.instance_3 = new lib.Symbol29();
        this.instance_3.parent = this;
        this.instance_3.setTransform(-41.7, -23.5);

        var maskedShapeInstanceList = [this.instance_2, this.instance_3];

        for (var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
            maskedShapeInstanceList[shapedInstanceItr].mask = mask_1;
        }

        this.timeline.addTween(
            cjs.Tween.get({})
                .to({state: [{t: this.instance_3}, {t: this.instance_2}]})
                .to({state: [{t: this.instance_2}]}, 62)
                .to({state: [{t: this.instance_2}]}, 14)
                .to({state: [{t: this.instance_2}]}, 20)
                .to({state: [{t: this.instance_2}]}, 10)
                .wait(17)
        );
        this.timeline.addTween(
            cjs.Tween.get(this.instance_2)
                .wait(62)
                .to({y: -39.3}, 14, cjs.Ease.cubicInOut)
                .wait(20)
                .to({y: -0.6}, 10, cjs.Ease.cubicInOut)
                .wait(17)
        );

        // Symbol 29
        this.instance_4 = new lib.Symbol29();
        this.instance_4.parent = this;
        this.instance_4.setTransform(-41.7, -23.5);

        var maskedShapeInstanceList = [this.instance_4];

        for (var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
            maskedShapeInstanceList[shapedInstanceItr].mask = mask_1;
        }

        this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(123));
    }).prototype = p = new cjs.MovieClip();
    p.nominalBounds = rect = new cjs.Rectangle(-54.4, -49.1, 108.8, 98.3);
    p.frameBounds = [
        rect,
        new cjs.Rectangle(-54.4, -49.1, 108.8, 98.2),
        new cjs.Rectangle(-54.4, -49.1, 108.8, 97.8),
        new cjs.Rectangle(-54.4, -49.1, 108.8, 96.8),
        new cjs.Rectangle(-54.4, -49.1, 108.8, 94.7),
        new cjs.Rectangle(-54.4, -49.1, 108.8, 91.2),
        new cjs.Rectangle(-54.4, -49.1, 108.8, 86.1),
        new cjs.Rectangle(-54.4, -49.1, 108.8, 79),
        (rect = new cjs.Rectangle(-54.4, -49.1, 108.8, 74.2)),
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        new cjs.Rectangle(-54.4, -49.1, 108.8, 75.8),
        new cjs.Rectangle(-54.4, -49.1, 108.8, 78),
        new cjs.Rectangle(-54.4, -49.1, 108.8, 80.8),
        new cjs.Rectangle(-54.4, -49.1, 108.8, 83.9),
        new cjs.Rectangle(-54.4, -49.1, 108.8, 87.7),
        new cjs.Rectangle(-54.4, -49.1, 108.8, 91.9),
        new cjs.Rectangle(-54.4, -49.1, 108.8, 96.4),
        new cjs.Rectangle(-54.4, -49.1, 108.8, 101.4),
        new cjs.Rectangle(-54.4, -49.1, 108.8, 106.6),
        new cjs.Rectangle(-54.4, -49.1, 108.8, 112),
        new cjs.Rectangle(-54.4, -49.1, 108.8, 117.4),
        new cjs.Rectangle(-54.4, -49.1, 108.8, 122.8),
        new cjs.Rectangle(-54.4, -49.1, 108.8, 128),
        new cjs.Rectangle(-58.5, -49.1, 113, 133),
        new cjs.Rectangle(-67.1, -49.1, 121.6, 137.6),
        new cjs.Rectangle(-75, -49.1, 129.5, 141.8),
        new cjs.Rectangle(-82.1, -49.1, 136.5, 145.6),
        new cjs.Rectangle(-88.3, -49.1, 142.8, 149),
        new cjs.Rectangle(-93.7, -49.1, 148.2, 151.9),
        new cjs.Rectangle(-98.3, -49.1, 152.8, 154.3),
        new cjs.Rectangle(-102.1, -49.1, 156.5, 156.3),
        new cjs.Rectangle(-105.1, -49.1, 159.5, 157.9),
        new cjs.Rectangle(-107.3, -49.1, 161.8, 159.1),
        new cjs.Rectangle(-108.9, -49.1, 163.3, 160),
        new cjs.Rectangle(-109.8, -49.1, 164.2, 160.5),
        (rect = new cjs.Rectangle(-110.1, -49.1, 164.5, 160.6)),
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        new cjs.Rectangle(-109.8, -49.1, 164.3, 160.4),
        new cjs.Rectangle(-109.1, -49.1, 163.6, 159.7),
        new cjs.Rectangle(-108, -49.1, 162.4, 158.6),
        new cjs.Rectangle(-106.4, -49.1, 160.8, 157),
        new cjs.Rectangle(-104.3, -49.1, 158.7, 155),
        new cjs.Rectangle(-101.7, -49.1, 156.2, 152.5),
        new cjs.Rectangle(-98.7, -49.1, 153.2, 149.6),
        new cjs.Rectangle(-95.2, -49.1, 149.7, 146.2),
        new cjs.Rectangle(-91.3, -49.1, 145.7, 142.3),
        new cjs.Rectangle(-86.9, -49.1, 141.3, 138),
        new cjs.Rectangle(-82, -49.1, 136.4, 133.3),
        new cjs.Rectangle(-76.6, -49.1, 131.1, 128.1),
        new cjs.Rectangle(-70.8, -49.1, 125.3, 122.5),
        new cjs.Rectangle(-64.6, -49.1, 119, 116.4),
        new cjs.Rectangle(-57.8, -49.1, 112.3, 109.8),
        new cjs.Rectangle(-54.4, -49.1, 108.8, 102.8),
        (rect = new cjs.Rectangle(-54.4, -49.1, 108.8, 98.3)),
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect
    ];

    (lib.Symbol25 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .f('#000000')
            .s()
            .p('AhDgNIA1gfIBRAvIAAAJIg4Ahg');
        this.shape.setTransform(0.7, -27.2);

        this.timeline.addTween(cjs.Tween.get(this.shape).wait(70));

        // Layer_3 (mask)
        let mask = new cjs.Shape();
        mask._off = true;
        var mask_graphics_0 = new cjs.Graphics().p('AjrMpIAA5RIHXAAIAAZRg');
        var mask_graphics_1 = new cjs.Graphics().p('AjrMpIAA5RIHXAAIAAZRg');
        var mask_graphics_2 = new cjs.Graphics().p('AjrMpIAA5RIHXAAIAAZRg');
        var mask_graphics_3 = new cjs.Graphics().p('AjrMpIAA5RIHXAAIAAZRg');
        var mask_graphics_4 = new cjs.Graphics().p('AjrMpIAA5RIHXAAIAAZRg');
        var mask_graphics_5 = new cjs.Graphics().p('AjrMoIAA5PIHXAAIAAZPg');
        var mask_graphics_6 = new cjs.Graphics().p('AjrMoIAA5PIHXAAIAAZPg');
        var mask_graphics_7 = new cjs.Graphics().p('AjrMpIAA5RIHXAAIAAZRg');
        var mask_graphics_8 = new cjs.Graphics().p('AjrMpIAA5RIHXAAIAAZRg');
        var mask_graphics_9 = new cjs.Graphics().p('AjrMoIAA5PIHXAAIAAZPg');
        var mask_graphics_10 = new cjs.Graphics().p('AjrMpIAA5RIHXAAIAAZRg');
        var mask_graphics_11 = new cjs.Graphics().p('AjrMpIAA5RIHXAAIAAZRg');
        var mask_graphics_12 = new cjs.Graphics().p('AjrMpIAA5RIHXAAIAAZRg');
        var mask_graphics_13 = new cjs.Graphics().p('AjrMpIAA5RIHXAAIAAZRg');
        var mask_graphics_14 = new cjs.Graphics().p('AjrMpIAA5RIHXAAIAAZRg');
        var mask_graphics_15 = new cjs.Graphics().p('AjrMpIAA5RIHXAAIAAZRg');
        var mask_graphics_16 = new cjs.Graphics().p('AjrMoIAA5PIHXAAIAAZPg');
        var mask_graphics_17 = new cjs.Graphics().p('AjrMpIAA5RIHXAAIAAZRg');
        var mask_graphics_18 = new cjs.Graphics().p('AjrMpIAA5RIHXAAIAAZRg');
        var mask_graphics_19 = new cjs.Graphics().p('AjrMpIAA5RIHXAAIAAZRg');
        var mask_graphics_20 = new cjs.Graphics().p('AjrMoIAA5PIHXAAIAAZPg');
        var mask_graphics_21 = new cjs.Graphics().p('AjrMpIAA5RIHXAAIAAZRg');
        var mask_graphics_22 = new cjs.Graphics().p('AjrMpIAA5RIHXAAIAAZRg');
        var mask_graphics_23 = new cjs.Graphics().p('AjrMpIAA5RIHXAAIAAZRg');
        var mask_graphics_24 = new cjs.Graphics().p('AjrMpIAA5RIHXAAIAAZRg');
        var mask_graphics_25 = new cjs.Graphics().p('AjrMoIAA5PIHXAAIAAZPg');
        var mask_graphics_26 = new cjs.Graphics().p('AjrMoIAA5PIHXAAIAAZPg');
        var mask_graphics_27 = new cjs.Graphics().p('AjrMpIAA5RIHXAAIAAZRg');
        var mask_graphics_28 = new cjs.Graphics().p('AjrMpIAA5RIHXAAIAAZRg');
        var mask_graphics_29 = new cjs.Graphics().p('AjrMpIAA5RIHXAAIAAZRg');
        var mask_graphics_30 = new cjs.Graphics().p('AjrMpIAA5RIHXAAIAAZRg');
        var mask_graphics_31 = new cjs.Graphics().p('AjrMoIAA5PIHXAAIAAZPg');
        var mask_graphics_32 = new cjs.Graphics().p('AjrMoIAA5PIHXAAIAAZPg');
        var mask_graphics_33 = new cjs.Graphics().p('AjrMpIAA5RIHXAAIAAZRg');
        var mask_graphics_34 = new cjs.Graphics().p('AjrMpIAA5RIHXAAIAAZRg');
        var mask_graphics_35 = new cjs.Graphics().p('AjrMpIAA5RIHXAAIAAZRg');
        var mask_graphics_36 = new cjs.Graphics().p('AjrMoIAA5PIHXAAIAAZPg');
        var mask_graphics_37 = new cjs.Graphics().p('AjrMpIAA5RIHXAAIAAZRg');
        var mask_graphics_38 = new cjs.Graphics().p('AjrMpIAA5RIHXAAIAAZRg');
        var mask_graphics_39 = new cjs.Graphics().p('AjrMpIAA5RIHXAAIAAZRg');
        var mask_graphics_40 = new cjs.Graphics().p('AjrMoIAA5PIHXAAIAAZPg');
        var mask_graphics_41 = new cjs.Graphics().p('AjrMoIAA5PIHXAAIAAZPg');
        var mask_graphics_42 = new cjs.Graphics().p('AjrMoIAA5PIHXAAIAAZPg');
        var mask_graphics_43 = new cjs.Graphics().p('AjrMpIAA5RIHXAAIAAZRg');
        var mask_graphics_44 = new cjs.Graphics().p('AjrMpIAA5RIHXAAIAAZRg');
        var mask_graphics_45 = new cjs.Graphics().p('AjrMoIAA5PIHXAAIAAZPg');
        var mask_graphics_46 = new cjs.Graphics().p('AjrMpIAA5RIHXAAIAAZRg');
        var mask_graphics_47 = new cjs.Graphics().p('AjrMpIAA5RIHXAAIAAZRg');
        var mask_graphics_48 = new cjs.Graphics().p('AjrMpIAA5RIHXAAIAAZRg');
        var mask_graphics_49 = new cjs.Graphics().p('AjrMoIAA5PIHXAAIAAZPg');
        var mask_graphics_50 = new cjs.Graphics().p('AjrMpIAA5RIHXAAIAAZRg');
        var mask_graphics_51 = new cjs.Graphics().p('AjrMoIAA5PIHXAAIAAZPg');
        var mask_graphics_52 = new cjs.Graphics().p('AjrMpIAA5RIHXAAIAAZRg');
        var mask_graphics_53 = new cjs.Graphics().p('AjrMpIAA5RIHXAAIAAZRg');
        var mask_graphics_54 = new cjs.Graphics().p('AjrMpIAA5RIHXAAIAAZRg');
        var mask_graphics_55 = new cjs.Graphics().p('AjrMpIAA5RIHXAAIAAZRg');
        var mask_graphics_56 = new cjs.Graphics().p('AjrMpIAA5RIHXAAIAAZRg');
        var mask_graphics_57 = new cjs.Graphics().p('AjrMoIAA5PIHXAAIAAZPg');
        var mask_graphics_58 = new cjs.Graphics().p('AjrMoIAA5PIHXAAIAAZPg');
        var mask_graphics_59 = new cjs.Graphics().p('AjrMpIAA5RIHXAAIAAZRg');
        var mask_graphics_60 = new cjs.Graphics().p('AjrMpIAA5RIHXAAIAAZRg');
        var mask_graphics_61 = new cjs.Graphics().p('AjrMpIAA5RIHXAAIAAZRg');
        var mask_graphics_62 = new cjs.Graphics().p('AjrMoIAA5PIHXAAIAAZPg');
        var mask_graphics_63 = new cjs.Graphics().p('AjrMoIAA5PIHXAAIAAZPg');
        var mask_graphics_64 = new cjs.Graphics().p('AjrMpIAA5RIHXAAIAAZRg');
        var mask_graphics_65 = new cjs.Graphics().p('AjrMpIAA5RIHXAAIAAZRg');
        var mask_graphics_66 = new cjs.Graphics().p('AjrMoIAA5PIHXAAIAAZPg');
        var mask_graphics_67 = new cjs.Graphics().p('AjrMpIAA5RIHXAAIAAZRg');
        var mask_graphics_68 = new cjs.Graphics().p('AjrMpIAA5RIHXAAIAAZRg');
        var mask_graphics_69 = new cjs.Graphics().p('AjrMoIAA5PIHXAAIAAZPg');

        this.timeline.addTween(
            cjs.Tween.get(mask)
                .to({graphics: mask_graphics_0, x: -2.5, y: 16})
                .wait(1)
                .to({graphics: mask_graphics_1, x: -2.5, y: 15.7})
                .wait(1)
                .to({graphics: mask_graphics_2, x: -2.5, y: 14.7})
                .wait(1)
                .to({graphics: mask_graphics_3, x: -2.5, y: 13})
                .wait(1)
                .to({graphics: mask_graphics_4, x: -2.5, y: 10.4})
                .wait(1)
                .to({graphics: mask_graphics_5, x: -2.4, y: 6.8})
                .wait(1)
                .to({graphics: mask_graphics_6, x: -2.4, y: 2.1})
                .wait(1)
                .to({graphics: mask_graphics_7, x: -2.3, y: -3.8})
                .wait(1)
                .to({graphics: mask_graphics_8, x: -2.2, y: -10.8})
                .wait(1)
                .to({graphics: mask_graphics_9, x: -2.2, y: -18.9})
                .wait(1)
                .to({graphics: mask_graphics_10, x: -2.1, y: -27.7})
                .wait(1)
                .to({graphics: mask_graphics_11, x: -2, y: -36.8})
                .wait(1)
                .to({graphics: mask_graphics_12, x: -1.9, y: -45.6})
                .wait(1)
                .to({graphics: mask_graphics_13, x: -1.8, y: -53.8})
                .wait(1)
                .to({graphics: mask_graphics_14, x: -1.7, y: -61.2})
                .wait(1)
                .to({graphics: mask_graphics_15, x: -1.7, y: -67.5})
                .wait(1)
                .to({graphics: mask_graphics_16, x: -1.6, y: -72.8})
                .wait(1)
                .to({graphics: mask_graphics_17, x: -1.6, y: -77.3})
                .wait(1)
                .to({graphics: mask_graphics_18, x: -1.5, y: -80.9})
                .wait(1)
                .to({graphics: mask_graphics_19, x: -1.5, y: -83.7})
                .wait(1)
                .to({graphics: mask_graphics_20, x: -1.5, y: -85.9})
                .wait(1)
                .to({graphics: mask_graphics_21, x: -1.4, y: -87.5})
                .wait(1)
                .to({graphics: mask_graphics_22, x: -1.4, y: -88.6})
                .wait(1)
                .to({graphics: mask_graphics_23, x: -1.4, y: -89.2})
                .wait(1)
                .to({graphics: mask_graphics_24, x: -1.4, y: -89.4})
                .wait(1)
                .to({graphics: mask_graphics_25, x: -1.4, y: -89})
                .wait(1)
                .to({graphics: mask_graphics_26, x: -1.4, y: -87.4})
                .wait(1)
                .to({graphics: mask_graphics_27, x: -1.4, y: -84.4})
                .wait(1)
                .to({graphics: mask_graphics_28, x: -1.4, y: -79.8})
                .wait(1)
                .to({graphics: mask_graphics_29, x: -1.4, y: -74.7})
                .wait(1)
                .to({graphics: mask_graphics_30, x: -1.4, y: -70.3})
                .wait(1)
                .to({graphics: mask_graphics_31, x: -1.4, y: -67.3})
                .wait(1)
                .to({graphics: mask_graphics_32, x: -1.4, y: -65.4})
                .wait(1)
                .to({graphics: mask_graphics_33, x: -1.4, y: -64.5})
                .wait(1)
                .to({graphics: mask_graphics_34, x: -1.4, y: -64.2})
                .wait(1)
                .to({graphics: mask_graphics_35, x: -1.4, y: -64.6})
                .wait(1)
                .to({graphics: mask_graphics_36, x: -1.4, y: -66})
                .wait(1)
                .to({graphics: mask_graphics_37, x: -1.4, y: -68.6})
                .wait(1)
                .to({graphics: mask_graphics_38, x: -1.4, y: -72.6})
                .wait(1)
                .to({graphics: mask_graphics_39, x: -1.4, y: -77.1})
                .wait(1)
                .to({graphics: mask_graphics_40, x: -1.4, y: -80.9})
                .wait(1)
                .to({graphics: mask_graphics_41, x: -1.4, y: -83.5})
                .wait(1)
                .to({graphics: mask_graphics_42, x: -1.4, y: -85.2})
                .wait(1)
                .to({graphics: mask_graphics_43, x: -1.4, y: -86})
                .wait(1)
                .to({graphics: mask_graphics_44, x: -1.4, y: -86.3})
                .wait(1)
                .to({graphics: mask_graphics_45, x: -1.4, y: -86})
                .wait(1)
                .to({graphics: mask_graphics_46, x: -1.4, y: -85.1})
                .wait(1)
                .to({graphics: mask_graphics_47, x: -1.4, y: -83.6})
                .wait(1)
                .to({graphics: mask_graphics_48, x: -1.4, y: -81.4})
                .wait(1)
                .to({graphics: mask_graphics_49, x: -1.4, y: -78.3})
                .wait(1)
                .to({graphics: mask_graphics_50, x: -1.4, y: -74.2})
                .wait(1)
                .to({graphics: mask_graphics_51, x: -1.4, y: -69.1})
                .wait(1)
                .to({graphics: mask_graphics_52, x: -1.4, y: -63})
                .wait(1)
                .to({graphics: mask_graphics_53, x: -1.4, y: -55.9})
                .wait(1)
                .to({graphics: mask_graphics_54, x: -1.4, y: -48.1})
                .wait(1)
                .to({graphics: mask_graphics_55, x: -1.4, y: -39.9})
                .wait(1)
                .to({graphics: mask_graphics_56, x: -1.4, y: -31.6})
                .wait(1)
                .to({graphics: mask_graphics_57, x: -1.4, y: -23.8})
                .wait(1)
                .to({graphics: mask_graphics_58, x: -1.4, y: -16.7})
                .wait(1)
                .to({graphics: mask_graphics_59, x: -1.4, y: -10.4})
                .wait(1)
                .to({graphics: mask_graphics_60, x: -1.4, y: -5})
                .wait(1)
                .to({graphics: mask_graphics_61, x: -1.4, y: -0.4})
                .wait(1)
                .to({graphics: mask_graphics_62, x: -1.4, y: 3.4})
                .wait(1)
                .to({graphics: mask_graphics_63, x: -1.4, y: 6.6})
                .wait(1)
                .to({graphics: mask_graphics_64, x: -1.4, y: 9})
                .wait(1)
                .to({graphics: mask_graphics_65, x: -1.4, y: 10.9})
                .wait(1)
                .to({graphics: mask_graphics_66, x: -1.4, y: 12.3})
                .wait(1)
                .to({graphics: mask_graphics_67, x: -1.4, y: 13.2})
                .wait(1)
                .to({graphics: mask_graphics_68, x: -1.4, y: 13.8})
                .wait(1)
                .to({graphics: mask_graphics_69, x: -1.4, y: 13.9})
                .wait(1)
        );

        // Layer_4
        this.shape_1 = new cjs.Shape();
        this.shape_1.graphics
            .f('#131B15')
            .s()
            .p('AAIJ1IAAzpIADAAIAATpgAgBJ1IAAzpIADAAIAATpgAgKJ1IAAzpIADAAIAATpg');
        this.shape_1.setTransform(0, 35.4);

        let maskedShapeInstanceList = [this.shape_1];

        for (let shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
            maskedShapeInstanceList[shapedInstanceItr].mask = mask;
        }

        this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(70));

        // Symbol 26
        this.instance = new lib.Symbol26();
        this.instance.parent = this;
        this.instance.setTransform(0, 116.4);

        this.timeline.addTween(
            cjs.Tween.get(this.instance)
                .wait(1)
                .to({y: 116.1}, 0)
                .wait(1)
                .to({y: 115.1}, 0)
                .wait(1)
                .to({y: 113.4}, 0)
                .wait(1)
                .to({y: 110.8}, 0)
                .wait(1)
                .to({y: 107.3}, 0)
                .wait(1)
                .to({y: 102.6}, 0)
                .wait(1)
                .to({y: 96.8}, 0)
                .wait(1)
                .to({x: 0.1, y: 89.8}, 0)
                .wait(1)
                .to({y: 81.8}, 0)
                .wait(1)
                .to({y: 73}, 0)
                .wait(1)
                .to({y: 64}, 0)
                .wait(1)
                .to({y: 55.3}, 0)
                .wait(1)
                .to({y: 47.1}, 0)
                .wait(1)
                .to({y: 39.9}, 0)
                .wait(1)
                .to({x: 0.2, y: 33.6}, 0)
                .wait(1)
                .to({y: 28.3}, 0)
                .wait(1)
                .to({y: 23.9}, 0)
                .wait(1)
                .to({y: 20.3}, 0)
                .wait(1)
                .to({y: 17.5}, 0)
                .wait(1)
                .to({y: 15.3}, 0)
                .wait(1)
                .to({y: 13.7}, 0)
                .wait(1)
                .to({y: 12.6}, 0)
                .wait(1)
                .to({y: 12}, 0)
                .wait(1)
                .to({y: 11.9}, 0)
                .wait(1)
                .to({y: 12.3}, 0)
                .wait(1)
                .to({y: 13.9}, 0)
                .wait(1)
                .to({y: 16.9}, 0)
                .wait(1)
                .to({y: 21.4}, 0)
                .wait(1)
                .to({y: 26.6}, 0)
                .wait(1)
                .to({y: 30.9}, 0)
                .wait(1)
                .to({y: 34}, 0)
                .wait(1)
                .to({y: 35.8}, 0)
                .wait(1)
                .to({y: 36.8}, 0)
                .wait(1)
                .to({y: 37.1}, 0)
                .wait(1)
                .to({y: 36.7}, 0)
                .wait(1)
                .to({y: 35.3}, 0)
                .wait(1)
                .to({y: 32.6}, 0)
                .wait(1)
                .to({y: 28.7}, 0)
                .wait(1)
                .to({y: 24.2}, 0)
                .wait(1)
                .to({y: 20.4}, 0)
                .wait(1)
                .to({y: 17.7}, 0)
                .wait(1)
                .to({y: 16.1}, 0)
                .wait(1)
                .to({y: 15.2}, 0)
                .wait(1)
                .to({y: 15}, 0)
                .wait(1)
                .to({y: 15.3}, 0)
                .wait(1)
                .to({y: 16.1}, 0)
                .wait(1)
                .to({y: 17.6}, 0)
                .wait(1)
                .to({y: 19.9}, 0)
                .wait(1)
                .to({y: 23}, 0)
                .wait(1)
                .to({y: 27}, 0)
                .wait(1)
                .to({y: 32.1}, 0)
                .wait(1)
                .to({y: 38.2}, 0)
                .wait(1)
                .to({y: 45.3}, 0)
                .wait(1)
                .to({y: 53.1}, 0)
                .wait(1)
                .to({y: 61.4}, 0)
                .wait(1)
                .to({y: 69.6}, 0)
                .wait(1)
                .to({y: 77.4}, 0)
                .wait(1)
                .to({y: 84.6}, 0)
                .wait(1)
                .to({y: 90.9}, 0)
                .wait(1)
                .to({y: 96.3}, 0)
                .wait(1)
                .to({y: 100.9}, 0)
                .wait(1)
                .to({y: 104.7}, 0)
                .wait(1)
                .to({y: 107.8}, 0)
                .wait(1)
                .to({y: 110.3}, 0)
                .wait(1)
                .to({y: 112.2}, 0)
                .wait(1)
                .to({y: 113.6}, 0)
                .wait(1)
                .to({y: 114.5}, 0)
                .wait(1)
                .to({y: 115}, 0)
                .wait(1)
                .to({y: 115.2}, 0)
                .wait(1)
        );
    }).prototype = p = new cjs.MovieClip();
    p.nominalBounds = rect = new cjs.Rectangle(-17, -31.7, 34, 170);
    p.frameBounds = [
        rect,
        new cjs.Rectangle(-17, -31.7, 34, 169.6),
        new cjs.Rectangle(-17, -31.7, 34, 168.7),
        new cjs.Rectangle(-17, -31.7, 34, 167),
        new cjs.Rectangle(-17, -31.7, 34, 164.4),
        new cjs.Rectangle(-17, -31.7, 34, 160.9),
        new cjs.Rectangle(-16.9, -31.7, 34, 156.2),
        new cjs.Rectangle(-16.9, -31.7, 34, 150.4),
        new cjs.Rectangle(-16.9, -31.7, 34, 143.4),
        new cjs.Rectangle(-16.9, -31.7, 34, 135.4),
        new cjs.Rectangle(-16.9, -31.7, 34, 126.6),
        new cjs.Rectangle(-16.9, -31.7, 34, 117.6),
        new cjs.Rectangle(-16.9, -31.7, 34, 108.8),
        new cjs.Rectangle(-16.8, -31.7, 34, 100.7),
        new cjs.Rectangle(-16.8, -31.7, 34, 93.4),
        new cjs.Rectangle(-16.8, -31.7, 34, 87.2),
        new cjs.Rectangle(-16.8, -31.7, 34, 81.9),
        new cjs.Rectangle(-16.8, -31.7, 34, 77.5),
        new cjs.Rectangle(-16.8, -31.7, 34, 73.9),
        new cjs.Rectangle(-16.8, -31.7, 34, 71.1),
        new cjs.Rectangle(-16.8, -31.7, 34, 68.9),
        new cjs.Rectangle(-16.8, -31.7, 34, 67.3),
        new cjs.Rectangle(-16.8, -31.7, 34, 66.2),
        new cjs.Rectangle(-16.8, -31.7, 34, 65.6),
        new cjs.Rectangle(-16.8, -31.7, 34, 65.4),
        new cjs.Rectangle(-16.8, -31.7, 34, 65.9),
        new cjs.Rectangle(-16.8, -31.7, 34, 67.4),
        new cjs.Rectangle(-16.8, -31.7, 34, 70.5),
        new cjs.Rectangle(-16.8, -31.7, 34, 75),
        new cjs.Rectangle(-16.8, -31.7, 34, 80.2),
        new cjs.Rectangle(-16.8, -31.7, 34, 84.5),
        new cjs.Rectangle(-16.8, -31.7, 34, 87.5),
        new cjs.Rectangle(-16.8, -31.7, 34, 89.4),
        new cjs.Rectangle(-16.8, -31.7, 34, 90.3),
        new cjs.Rectangle(-16.8, -31.7, 34, 90.6),
        new cjs.Rectangle(-16.8, -31.7, 34, 90.2),
        new cjs.Rectangle(-16.8, -31.7, 34, 88.9),
        new cjs.Rectangle(-16.8, -31.7, 34, 86.2),
        new cjs.Rectangle(-16.8, -31.7, 34, 82.2),
        new cjs.Rectangle(-16.8, -31.7, 34, 77.7),
        new cjs.Rectangle(-16.8, -31.7, 34, 73.9),
        new cjs.Rectangle(-16.8, -31.7, 34, 71.3),
        new cjs.Rectangle(-16.8, -31.7, 34, 69.7),
        new cjs.Rectangle(-16.8, -31.7, 34, 68.8),
        new cjs.Rectangle(-16.8, -31.7, 34, 68.6),
        new cjs.Rectangle(-16.8, -31.7, 34, 68.8),
        new cjs.Rectangle(-16.8, -31.7, 34, 69.7),
        new cjs.Rectangle(-16.8, -31.7, 34, 71.2),
        new cjs.Rectangle(-16.8, -31.7, 34, 73.4),
        new cjs.Rectangle(-16.8, -31.7, 34, 76.6),
        new cjs.Rectangle(-16.8, -31.7, 34, 80.6),
        new cjs.Rectangle(-16.8, -31.7, 34, 85.7),
        new cjs.Rectangle(-16.8, -31.7, 34, 91.8),
        new cjs.Rectangle(-16.8, -31.7, 34, 98.9),
        new cjs.Rectangle(-16.8, -31.7, 34, 106.7),
        new cjs.Rectangle(-16.8, -31.7, 34, 115),
        new cjs.Rectangle(-16.8, -31.7, 34, 123.2),
        new cjs.Rectangle(-16.8, -31.7, 34, 131),
        new cjs.Rectangle(-16.8, -31.7, 34, 138.1),
        new cjs.Rectangle(-16.8, -31.7, 34, 144.4),
        new cjs.Rectangle(-16.8, -31.7, 34, 149.9),
        new cjs.Rectangle(-16.8, -31.7, 34, 154.5),
        new cjs.Rectangle(-16.8, -31.7, 34, 158.3),
        new cjs.Rectangle(-16.8, -31.7, 34, 161.4),
        new cjs.Rectangle(-16.8, -31.7, 34, 163.8),
        new cjs.Rectangle(-16.8, -31.7, 34, 165.7),
        new cjs.Rectangle(-16.8, -31.7, 34, 167.1),
        new cjs.Rectangle(-16.8, -31.7, 34, 168),
        new cjs.Rectangle(-16.8, -31.7, 34, 168.6),
        new cjs.Rectangle(-16.8, -31.7, 34, 168.8)
    ];

    (lib.Symbol20 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_2
        this.instance = new lib.steam();
        this.instance.parent = this;
        this.instance.setTransform(-3.8, -11.6, 0.07, 0.07);

        this.timeline.addTween(
            cjs.Tween.get(this.instance)
                .to({regX: -0.1, regY: -0.2, scaleX: 0.33, scaleY: 0.28, y: -18.1}, 10, cjs.Ease.quadInOut)
                .to({_off: true}, 1)
                .wait(19)
        );

        // Layer_1
        this.instance_1 = new lib.tractor('synched', 0);
        this.instance_1.parent = this;

        this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(30));
    }).prototype = p = new cjs.MovieClip();
    p.nominalBounds = rect = new cjs.Rectangle(-36.4, -29, 72.8, 58);
    p.frameBounds = [
        rect,
        rect,
        new cjs.Rectangle(-36.4, -29, 72.9, 58.1),
        new cjs.Rectangle(-36.4, -29, 73.1, 58.2),
        new cjs.Rectangle(-36.4, -29, 73.4, 58.3),
        new cjs.Rectangle(-36.4, -29, 73.8, 58.4),
        new cjs.Rectangle(-36.4, -29, 74.2, 58.6),
        new cjs.Rectangle(-36.4, -29, 74.8, 58.8),
        new cjs.Rectangle(-36.4, -29, 75.3, 59.1),
        new cjs.Rectangle(-36.4, -29, 75.8, 59.3),
        new cjs.Rectangle(-36.4, -29, 76.1, 59.4),
        new cjs.Rectangle(-36.4, -29, 76.4, 59.5),
        new cjs.Rectangle(-36.4, -29, 76.6, 59.6),
        new cjs.Rectangle(-36.4, -29, 76.7, 59.7),
        (rect = new cjs.Rectangle(-36.4, -29, 76.8, 59.7)),
        rect,
        new cjs.Rectangle(-36.4, -29, 76.7, 59.7),
        new cjs.Rectangle(-36.4, -29, 76.6, 59.6),
        new cjs.Rectangle(-36.4, -29, 76.4, 59.6),
        new cjs.Rectangle(-36.4, -29, 76.2, 59.4),
        new cjs.Rectangle(-36.4, -29, 75.8, 59.3),
        new cjs.Rectangle(-36.4, -29, 75.1, 59),
        new cjs.Rectangle(-36.4, -29, 74.4, 58.7),
        new cjs.Rectangle(-36.4, -29, 73.8, 58.4),
        new cjs.Rectangle(-36.4, -29, 73.4, 58.3),
        new cjs.Rectangle(-36.4, -29, 73.1, 58.2),
        new cjs.Rectangle(-36.4, -29, 72.9, 58.1),
        (rect = new cjs.Rectangle(-36.4, -29, 72.8, 58)),
        rect,
        rect
    ];

    (lib.Symbol13 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.instance = new lib.Symbol53();
        this.instance.parent = this;

        this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));
    }).prototype = getMCSymbolPrototype(lib.Symbol13, (rect = new cjs.Rectangle(-12.4, -19.6, 24.9, 39.3)), [rect]);

    (lib.Symbol5 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.instance = new lib.Symbol6();
        this.instance.parent = this;

        this.timeline.addTween(
            cjs.Tween.get(this.instance)
                .to({scaleX: 1, scaleY: 1, rotation: 160}, 8)
                .wait(1)
        );
    }).prototype = p = new cjs.MovieClip();
    p.nominalBounds = rect = new cjs.Rectangle(-12.5, -8.6, 25, 17.3);
    p.frameBounds = [
        rect,
        new cjs.Rectangle(-14.6, -12.2, 29.4, 24.4),
        new cjs.Rectangle(-15, -14.5, 30.2, 28.9),
        new cjs.Rectangle(-13.7, -15, 27.4, 30),
        new cjs.Rectangle(-10.6, -13.7, 21.3, 27.5),
        new cjs.Rectangle(-10.4, -13.7, 20.9, 27.5),
        new cjs.Rectangle(-13.4, -15, 27, 30.2),
        new cjs.Rectangle(-14.9, -14.6, 30, 29.3),
        new cjs.Rectangle(-14.6, -12.4, 29.3, 24.8)
    ];

    (lib.Symbol4 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.instance = new lib.Symbol3();
        this.instance.parent = this;
        this.instance.setTransform(-1.2, -1.4);

        this.instance_1 = new lib.Symbol2();
        this.instance_1.parent = this;
        this.instance_1.setTransform(0, 5.6);

        this.timeline.addTween(
            cjs.Tween.get({})
                .to({state: [{t: this.instance_1}, {t: this.instance}]})
                .wait(1)
        );
    }).prototype = getMCSymbolPrototype(lib.Symbol4, (rect = new cjs.Rectangle(-12.7, -13.4, 25.4, 26.9)), [rect]);

    (lib.steam_1 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // timeline functions:
        this.frame_40 = function() {
            this.stop();
            this.dx = Math.random() * (500 - 100) + 100;
            var _this = this;
            setTimeout(function() {
                _this.play();
            }, _this.dx);
        };

        // actions tween:
        this.timeline.addTween(
            cjs.Tween.get(this)
                .wait(40)
                .call(this.frame_40)
                .wait(1)
        );

        // Layer_1
        this.instance = new lib.steam();
        this.instance.parent = this;
        this.instance.setTransform(-26.8, 49.4, 0.43, 0.43);

        this.timeline.addTween(
            cjs.Tween.get(this.instance)
                .wait(1)
                .to({scaleX: 0.43, scaleY: 0.43, y: 49.2}, 0)
                .wait(1)
                .to({scaleX: 0.43, scaleY: 0.43, y: 49}, 0)
                .wait(1)
                .to({scaleX: 0.44, scaleY: 0.44, y: 48.6}, 0)
                .wait(1)
                .to({scaleX: 0.44, scaleY: 0.44, y: 48}, 0)
                .wait(1)
                .to({scaleX: 0.45, scaleY: 0.45, x: -26.7, y: 47.4}, 0)
                .wait(1)
                .to({scaleX: 0.46, scaleY: 0.46, y: 46.5}, 0)
                .wait(1)
                .to({scaleX: 0.47, scaleY: 0.47, x: -26.6, y: 45.6}, 0)
                .wait(1)
                .to({scaleX: 0.48, scaleY: 0.48, x: -26.4, y: 44.4}, 0)
                .wait(1)
                .to({scaleX: 0.5, scaleY: 0.5, x: -26.2, y: 43.1}, 0)
                .wait(1)
                .to({scaleX: 0.51, scaleY: 0.51, x: -25.8, y: 41.5}, 0)
                .wait(1)
                .to({scaleX: 0.53, scaleY: 0.53, x: -25.4, y: 39.8}, 0)
                .wait(1)
                .to({scaleX: 0.55, scaleY: 0.55, x: -24.7, y: 38}, 0)
                .wait(1)
                .to({scaleX: 0.57, scaleY: 0.57, x: -23.9, y: 36}, 0)
                .wait(1)
                .to({scaleX: 0.59, scaleY: 0.59, x: -22.7, y: 33.8}, 0)
                .wait(1)
                .to({scaleX: 0.62, scaleY: 0.62, x: -21.3, y: 31.7}, 0)
                .wait(1)
                .to({scaleX: 0.64, scaleY: 0.64, x: -19.6, y: 29.5}, 0)
                .wait(1)
                .to({scaleX: 0.67, scaleY: 0.67, x: -17.7, y: 27.5}, 0)
                .wait(1)
                .to({scaleX: 0.7, scaleY: 0.7, x: -15.6, y: 25.6}, 0)
                .wait(1)
                .to({scaleX: 0.72, scaleY: 0.72, x: -14.3, y: 23.4}, 0)
                .wait(1)
                .to({scaleX: 0.75, scaleY: 0.75, x: -12.9, y: 21.2}, 0)
                .wait(1)
                .to({scaleX: 0.77, scaleY: 0.77, x: -11.6, y: 19.1}, 0)
                .wait(1)
                .to({scaleX: 0.8, scaleY: 0.8, x: -10.4, y: 17}, 0)
                .wait(1)
                .to({scaleX: 0.82, scaleY: 0.82, x: -9.2, y: 15.1}, 0)
                .wait(1)
                .to({scaleX: 0.84, scaleY: 0.84, x: -8.1, y: 13.2}, 0)
                .wait(1)
                .to({scaleX: 0.86, scaleY: 0.86, x: -7, y: 11.5}, 0)
                .wait(1)
                .to({scaleX: 0.88, scaleY: 0.88, x: -6, y: 9.9}, 0)
                .wait(1)
                .to({scaleX: 0.9, scaleY: 0.9, x: -5.2, y: 8.4}, 0)
                .wait(1)
                .to({scaleX: 0.92, scaleY: 0.92, x: -4.3, y: 7.1}, 0)
                .wait(1)
                .to({scaleX: 0.93, scaleY: 0.93, x: -3.6, y: 5.9}, 0)
                .wait(1)
                .to({scaleX: 0.94, scaleY: 0.94, x: -3, y: 4.8}, 0)
                .wait(1)
                .to({scaleX: 0.96, scaleY: 0.96, x: -2.4, y: 3.8}, 0)
                .wait(1)
                .to({scaleX: 0.97, scaleY: 0.97, x: -1.9, y: 3}, 0)
                .wait(1)
                .to({scaleX: 0.97, scaleY: 0.97, x: -1.4, y: 2.3}, 0)
                .wait(1)
                .to({scaleX: 0.98, scaleY: 0.98, x: -1, y: 1.6}, 0)
                .wait(1)
                .to({scaleX: 0.99, scaleY: 0.99, x: -0.7, y: 1.1}, 0)
                .wait(1)
                .to({scaleX: 0.99, scaleY: 0.99, x: -0.5, y: 0.7}, 0)
                .wait(1)
                .to({scaleX: 1, scaleY: 1, x: -0.3, y: 0.4}, 0)
                .wait(1)
                .to({scaleX: 1, scaleY: 1, x: -0.1, y: 0.2}, 0)
                .wait(1)
                .to({scaleX: 1, scaleY: 1, x: 0, y: 0.1}, 0)
                .to({_off: true}, 1)
                .wait(1)
        );
    }).prototype = p = new cjs.MovieClip();
    p.nominalBounds = rect = new cjs.Rectangle(-31.5, 44, 9.4, 10.8);
    p.frameBounds = [
        rect,
        new cjs.Rectangle(-31.4, 43.9, 9.5, 10.9),
        new cjs.Rectangle(-31.5, 43.5, 9.5, 11),
        new cjs.Rectangle(-31.6, 43.1, 9.6, 11),
        new cjs.Rectangle(-31.5, 42.4, 9.7, 11.1),
        new cjs.Rectangle(-31.6, 41.6, 9.9, 11.4),
        new cjs.Rectangle(-31.6, 40.6, 10.1, 11.6),
        new cjs.Rectangle(-31.6, 39.5, 10.3, 11.8),
        new cjs.Rectangle(-31.5, 38, 10.6, 12.1),
        new cjs.Rectangle(-31.5, 36.6, 10.9, 12.5),
        new cjs.Rectangle(-31.2, 34.7, 11.2, 12.8),
        new cjs.Rectangle(-30.9, 32.8, 11.6, 13.3),
        new cjs.Rectangle(-30.5, 30.7, 12, 13.8),
        new cjs.Rectangle(-29.9, 28.4, 12.5, 14.4),
        new cjs.Rectangle(-28.9, 26.1, 13, 14.9),
        new cjs.Rectangle(-27.8, 23.7, 13.5, 15.5),
        new cjs.Rectangle(-26.5, 21.4, 14.1, 16.2),
        new cjs.Rectangle(-24.8, 19.1, 14.6, 16.8),
        new cjs.Rectangle(-23.2, 16.9, 15.2, 17.5),
        new cjs.Rectangle(-21.3, 14.9, 15.8, 18.2),
        new cjs.Rectangle(-19.4, 13.1, 16.3, 18.8),
        new cjs.Rectangle(-17.6, 11.2, 16.9, 19.5),
        new cjs.Rectangle(-16.1, 9.2, 17.4, 20),
        new cjs.Rectangle(-14.8, 7, 18, 20.7),
        new cjs.Rectangle(-13.7, 4.9, 18.4, 21.3),
        new cjs.Rectangle(-12.9, 2.9, 18.9, 21.7),
        new cjs.Rectangle(-12.1, 0.9, 19.3, 22.2),
        new cjs.Rectangle(-11.6, -1, 19.7, 22.7),
        new cjs.Rectangle(-11.3, -2.8, 20, 23.1),
        new cjs.Rectangle(-11.1, -4.4, 20.4, 23.4),
        new cjs.Rectangle(-10.9, -5.8, 20.6, 23.7),
        new cjs.Rectangle(-10.9, -7.1, 20.9, 24),
        new cjs.Rectangle(-10.7, -8.2, 21.1, 24.3),
        new cjs.Rectangle(-10.8, -9.3, 21.3, 24.5),
        new cjs.Rectangle(-10.7, -10.1, 21.4, 24.7),
        new cjs.Rectangle(-10.8, -10.8, 21.5, 24.8),
        new cjs.Rectangle(-10.8, -11.4, 21.7, 25),
        new cjs.Rectangle(-10.9, -11.8, 21.8, 25.1),
        new cjs.Rectangle(-10.8, -12.1, 21.8, 25.1),
        new cjs.Rectangle(-10.9, -12.5, 21.9, 25.2),
        null
    ];

    (lib.claud = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // timeline functions:
        this.frame_19 = function() {
            this.stop();
        };

        // actions tween:
        this.timeline.addTween(
            cjs.Tween.get(this)
                .wait(19)
                .call(this.frame_19)
                .wait(5)
        );

        // Layer_4
        this.instance = new lib.steam_1();
        this.instance.parent = this;
        this.instance.setTransform(25.6, -30.7, 1.35, 1.35);
        this.instance._off = true;

        this.timeline.addTween(
            cjs.Tween.get(this.instance)
                .wait(19)
                .to({_off: false}, 0)
                .wait(5)
        );

        // Layer_3
        this.instance_1 = new lib.steam_1();
        this.instance_1.parent = this;
        this.instance_1.setTransform(25.6, -30.7, 1.35, 1.35);
        this.instance_1._off = true;

        this.timeline.addTween(
            cjs.Tween.get(this.instance_1)
                .wait(9)
                .to({_off: false}, 0)
                .wait(15)
        );

        // Layer_1
        this.instance_2 = new lib.steam_1();
        this.instance_2.parent = this;
        this.instance_2.setTransform(25.6, -30.7, 1.35, 1.35);

        this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(24));
    }).prototype = p = new cjs.MovieClip();
    p.nominalBounds = rect = new cjs.Rectangle(-16.9, 28.6, 12.7, 14.6);
    p.frameBounds = [
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect
    ];

    (lib.truba = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_29 (mask)
        let mask = new cjs.Shape();
        mask._off = true;
        mask.graphics.p('AmEHOIgRAZIghATIgrAKIguAAIgrgKIghgTIgRgZIhThkICwttITPAAIAAQHg');
        mask.setTransform(30.6, -91.1);

        // claud
        this.instance = new lib.claud();
        this.instance.parent = this;
        this.instance.setTransform(-12.6, -67.1);

        let maskedShapeInstanceList = [this.instance];

        for (let shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
            maskedShapeInstanceList[shapedInstanceItr].mask = mask;
        }

        this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

        // Layer_1
        this.instance_1 = new lib.Symbol51();
        this.instance_1.parent = this;

        this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));
    }).prototype = getMCSymbolPrototype(lib.truba, (rect = new cjs.Rectangle(-36.9, -56.1, 73.8, 112.2)), [rect]);

    (lib.Symbol55 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.instance = new lib.Symbol25('single', 24);
        this.instance.parent = this;
        this.instance.setTransform(0.3, -204.1);

        this.timeline.addTween(
            cjs.Tween.get(this.instance)
                .wait(24)
                .to({startPosition: 24}, 0)
                .to({x: -54.5, y: -171.9}, 23, cjs.Ease.quadInOut)
                .wait(20)
                .to({startPosition: 24}, 0)
                .to({x: 0.3, y: -204.1}, 22, cjs.Ease.quadInOut)
                .wait(31)
        );
    }).prototype = p = new cjs.MovieClip();
    p.nominalBounds = rect = new cjs.Rectangle(-16.5, -235.8, 34, 65.4);
    p.frameBounds = [
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        new cjs.Rectangle(-16.7, -235.7, 34, 65.4),
        new cjs.Rectangle(-17.3, -235.3, 34, 65.4),
        new cjs.Rectangle(-18.3, -234.7, 34, 65.4),
        new cjs.Rectangle(-19.8, -233.9, 34, 65.4),
        new cjs.Rectangle(-21.7, -232.8, 34, 65.4),
        new cjs.Rectangle(-23.9, -231.4, 34, 65.4),
        new cjs.Rectangle(-26.6, -229.9, 33.9, 65.4),
        new cjs.Rectangle(-29.7, -228, 34, 65.4),
        new cjs.Rectangle(-33.3, -225.9, 33.9, 65.4),
        new cjs.Rectangle(-37.2, -223.6, 34, 65.4),
        new cjs.Rectangle(-41.6, -221.1, 34, 65.4),
        new cjs.Rectangle(-46.2, -218.3, 34, 65.4),
        new cjs.Rectangle(-50.6, -215.8, 34, 65.4),
        new cjs.Rectangle(-54.5, -213.5, 33.9, 65.4),
        new cjs.Rectangle(-58.1, -211.4, 34, 65.4),
        new cjs.Rectangle(-61.2, -209.5, 34, 65.4),
        new cjs.Rectangle(-63.9, -208, 34, 65.4),
        new cjs.Rectangle(-66.1, -206.6, 34, 65.4),
        new cjs.Rectangle(-68, -205.5, 33.9, 65.4),
        new cjs.Rectangle(-69.5, -204.7, 34, 65.4),
        new cjs.Rectangle(-70.5, -204.1, 34, 65.4),
        new cjs.Rectangle(-71.1, -203.7, 34, 65.4),
        (rect = new cjs.Rectangle(-71.3, -203.6, 33.9, 65.4)),
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        new cjs.Rectangle(-71.1, -203.7, 33.9, 65.4),
        new cjs.Rectangle(-70.4, -204.1, 34, 65.4),
        new cjs.Rectangle(-69.3, -204.8, 33.9, 65.4),
        new cjs.Rectangle(-67.7, -205.7, 34, 65.4),
        new cjs.Rectangle(-65.7, -206.9, 34, 65.4),
        new cjs.Rectangle(-63.2, -208.4, 34, 65.4),
        new cjs.Rectangle(-60.2, -210.1, 34, 65.4),
        new cjs.Rectangle(-56.8, -212.1, 34, 65.4),
        new cjs.Rectangle(-53, -214.4, 34, 65.4),
        new cjs.Rectangle(-48.7, -216.9, 34, 65.4),
        new cjs.Rectangle(-43.9, -219.7, 34, 65.4),
        new cjs.Rectangle(-39.1, -222.5, 33.9, 65.4),
        new cjs.Rectangle(-34.8, -225, 34, 65.4),
        new cjs.Rectangle(-31, -227.3, 34, 65.4),
        new cjs.Rectangle(-27.6, -229.3, 34, 65.4),
        new cjs.Rectangle(-24.6, -231, 34, 65.4),
        new cjs.Rectangle(-22.1, -232.5, 34, 65.4),
        new cjs.Rectangle(-20.1, -233.7, 34, 65.4),
        new cjs.Rectangle(-18.5, -234.6, 34, 65.4),
        new cjs.Rectangle(-17.4, -235.3, 34, 65.4),
        new cjs.Rectangle(-16.7, -235.7, 34, 65.4),
        (rect = new cjs.Rectangle(-16.5, -235.8, 34, 65.4)),
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect
    ];

    (lib.Symbol52 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.instance = new lib.Symbol5();
        this.instance.parent = this;
        this.instance.setTransform(-2.7, -5.9, 1, 1, 0, 55, 16, 0, -0.1);
        this.instance.alpha = 0.422;

        this.shape = new cjs.Shape();
        this.shape.graphics
            .f('#604931')
            .s()
            .p('AgGgGIAEgDIAEgCIAFADIgHAEIAAABIAAAAQgEACAAAGIABAFIgDACg');
        this.shape.setTransform(-5.8, 15.8);

        this.shape_1 = new cjs.Shape();
        this.shape_1.graphics
            .lf(['#000000', '#031B1B'], [0, 1], 0, -0.8, -0.4, -2.7)
            .s()
            .p('AALALQAAgHgEgGIgHgJIgDgCQgFgDgEACIAIgEIAHAFIAKAPIAAAPIgEACQACgCAAgGg');
        this.shape_1.setTransform(-4.6, 16.8);

        this.shape_2 = new cjs.Shape();
        this.shape_2.graphics
            .lf(['#E5BB76', '#907051'], [0, 1], -1.7, 1, 3.3, -1.9)
            .s()
            .p('AgIgJIAFgDIAFAKIACAEIAEAHIABABIgFADg');
        this.shape_2.setTransform(-3.1, 15.9);

        this.shape_3 = new cjs.Shape();
        this.shape_3.graphics
            .lf(['#A27F5C', '#795F41'], [0, 1], 0, 0.1, 0, -0.2)
            .s()
            .p('AgEACIAEgCIAEACg');
        this.shape_3.setTransform(-12.7, 12.4);

        this.shape_4 = new cjs.Shape();
        this.shape_4.graphics
            .lf(['#001511', '#112220'], [0, 1], 0.1, -0.2, -0.6, -0.2)
            .s()
            .p('AAAACIAAgEIABAFg');
        this.shape_4.setTransform(-12.6, 10.6);

        this.shape_5 = new cjs.Shape();
        this.shape_5.graphics
            .lf(['#A27F5C', '#795F41'], [0, 1], -0.4, 0, 0.2, 0)
            .s()
            .p('AgBgIIADgCIAAgBIAAABIAAAAIAAAFIAAAOIgDADg');
        this.shape_5.setTransform(-13, 11.3);

        this.shape_6 = new cjs.Shape();
        this.shape_6.graphics
            .lf(['#A27F5C', '#795F41'], [0, 1], 1, 0.3, 0.4, 0.3)
            .s()
            .p('AAEAUIAAgPIADACIACAFIAAALgAAEAAIAAAAIABABgAACgDIABABIABACgAgEgPIgEgHIABAAIADAHg');
        this.shape_6.setTransform(-13.2, 10.2);

        this.shape_7 = new cjs.Shape();
        this.shape_7.graphics
            .lf(['#E5BB76', '#907051'], [0, 1], -1.7, 1, 3.3, -1.9)
            .s()
            .p('AgKgMIAFgCIADAFIADAHIAHALIACAEIAAAAIgEACg');
        this.shape_7.setTransform(-13.8, 8.9);

        this.shape_8 = new cjs.Shape();
        this.shape_8.graphics
            .f('#917151')
            .s()
            .p(
                'AA4AqQgGgCAAgIQAAAAAAgBQAAAAABgBQAAAAAAgBQAAAAABAAQAAgBABAAQAAAAABAAQAAAAABABQAAAAABAAQAGADAAAHQAAABAAABQgBABAAAAQAAABgBAAQAAAAgBAAIgDgBgAA1AfQAAAAAAAAQgBAAAAABQAAAAAAAAQAAABAAAAQAAAFAEACQAEADAAgFQAAgFgEgCIgCAAIgBAAgAg1gYQgIgDAAgKQAAgDADgCQACgBADACQAIAEAAAJQAAAEgDABIgCAAIgDgBgAg6gjQAAAGAFADQAAAAABAAQAAABABAAQAAAAABAAQAAgBABAAQAAAAAAAAQABgBAAAAQAAgBAAAAQAAgBAAAAQAAgGgFgEIgDgBQAAAAgBABQAAAAgBABQAAAAAAABQAAABAAABg'
            );
        this.shape_8.setTransform(-10.5, 13.5);

        this.shape_9 = new cjs.Shape();
        this.shape_9.graphics
            .lf(['#000000', '#031B1B'], [0, 1], 0.8, 2.2, 0.1, -0.8)
            .s()
            .p('AAPAOQAAgKgGgJIgCgDIgEgFIgEgFIgDgBQgHgEgFADIAHgFIANAIIANAVIAAASIgHAEQAFgEAAgIg');
        this.shape_9.setTransform(-15.5, 10);

        this.shape_10 = new cjs.Shape();
        this.shape_10.graphics
            .f('#031B1B')
            .s()
            .p(
                'AA8A4IgCgBIgBgBQgGgDgEgHQgCgEgBgFIgBgGQAAgGAEgDIABAAIABAAQADgCAFADIADACIAIAJQAEAHAAAHQAAAGgCACIgCACIgEAAIgEAAgAA0AdQAAAAAAAAQgBAAAAABQAAAAAAABQAAAAAAABIgBABQAAAJAHAEQAIAEAAgIQAAgJgIgEIgBAAIgCgBIgCABgAg0gIQgIgFgFgJQgGgKAAgJQAAgKAGgDIABAAIAAAAQAFgDAHAEIADACIAFAEIAEAFIACAEQAGAJAAAKQAAAJgFADIgBAAIgFABQgEAAgFgCgAg7gqQgCABAAAFQAAALAJAGQAEADADgCQADgCAAgFQAAgEgDgFQgDgGgEgCIgEgBIgDABg'
            );
        this.shape_10.setTransform(-10.7, 13.3);

        this.shape_11 = new cjs.Shape();
        this.shape_11.graphics
            .lf(['#001511', '#112220'], [0, 1], -4.5, 1.3, 2.4, 1.3)
            .s()
            .p('AgBgNIADADIAAAVIgDADg');
        this.shape_11.setTransform(-15.4, 4.8);

        this.shape_12 = new cjs.Shape();
        this.shape_12.graphics
            .lf(['#001511', '#112220'], [0, 1], 0, 0.7, -0.7, -0.5)
            .s()
            .p('AgBgFIADgDIgCAQIgBAAg');
        this.shape_12.setTransform(-14.4, 4.8);

        this.shape_13 = new cjs.Shape();
        this.shape_13.graphics
            .lf(['#001511', '#112220'], [0, 1], -0.1, -2.3, 0.6, -1.1)
            .s()
            .p('AgRAOIgFgDIAFgDIAAAAIALAAIgBAGgAAMgGIABgCIACgBIAIAAIgHADgAAUgMIABgBIgCABg');
        this.shape_13.setTransform(-13.4, 2.3);

        this.shape_14 = new cjs.Shape();
        this.shape_14.graphics
            .lf(['#001511', '#112220'], [0, 1], -0.6, -0.3, 0, -0.4)
            .s()
            .p('AAAAKIgCgVIACADIADAUg');
        this.shape_14.setTransform(-2.4, 11.8);

        this.shape_15 = new cjs.Shape();
        this.shape_15.graphics
            .lf(['#A27F5C', '#8B6D4C'], [0, 1], 1.1, 0.5, -0.4, 0.9)
            .s()
            .p('AAAAJIgCgSIAAgBIACACIADATg');
        this.shape_15.setTransform(-2.7, 9.8);

        this.shape_16 = new cjs.Shape();
        this.shape_16.graphics
            .lf(['#001511', '#112220'], [0, 1], 0.4, 2, 0.3, -2.4)
            .s()
            .p('AgEADIgCAAIAMgGIABAHg');
        this.shape_16.setTransform(-5.7, 5.5);

        this.shape_17 = new cjs.Shape();
        this.shape_17.graphics
            .lf(['#001511', '#112220'], [0, 1], -0.4, 1, 0.3, -0.5)
            .s()
            .p('AABACIgCgCIAAgCIADACIAAADg');
        this.shape_17.setTransform(-7.2, 3.1);

        this.shape_18 = new cjs.Shape();
        this.shape_18.graphics
            .lf(['#001511', '#112220'], [0, 1], 0.4, 2.6, 0.3, -2.1)
            .s()
            .p('AgBANIAAgUIACAAIAAAUIgCABgAgBgLIAAgCIABABIABAAIAAABg');
        this.shape_18.setTransform(-6.9, 4.8);

        this.shape_19 = new cjs.Shape();
        this.shape_19.graphics
            .lf(['#001511', '#112220'], [0, 1], -0.4, 2.4, 1, -6.4)
            .s()
            .p('AgBgGIADAAIAAARIgDACgAgBgLIAAgBIADAAIAAABg');
        this.shape_19.setTransform(-6.6, 4.7);

        this.shape_20 = new cjs.Shape();
        this.shape_20.graphics
            .lf(['#001511', '#112220'], [0, 1], -0.3, -1.5, -0.3, -1.7)
            .s()
            .p('AAEABIgCAAIgDAAIgDAAIgCAAIAAgCIANAAIAAACg');
        this.shape_20.setTransform(-6.6, 3.9);

        this.shape_21 = new cjs.Shape();
        this.shape_21.graphics
            .lf(['#001511', '#112220'], [0, 1], -0.4, 2.6, 1, -6.3)
            .s()
            .p('AAAgFIABAAIAAAOIAAACIgBABgAAAgKIAAgBIAAAAIABAAIAAAAIAAABg');
        this.shape_21.setTransform(-6.3, 4.6);

        this.shape_22 = new cjs.Shape();
        this.shape_22.graphics
            .lf(['#001511', '#112220'], [0, 1], 0.2, -0.8, 0.4, -1.9)
            .s()
            .p('AACABIgDAAIgCAAIAAgBIAGAAIAAABg');
        this.shape_22.setTransform(-6.6, 3.3);

        this.shape_23 = new cjs.Shape();
        this.shape_23.graphics
            .lf(['#001511', '#112220'], [0, 1], 0.3, 3.8, 0, 0)
            .s()
            .p('AgBABIAAAAIAAgCIAAAAIADACIgCABg');
        this.shape_23.setTransform(-6, 3.3);

        this.shape_24 = new cjs.Shape();
        this.shape_24.graphics
            .lf(['#001511', '#112220'], [0, 1], -0.5, -1.9, -0.7, -2.4)
            .s()
            .p('AgCAAIABAAIAEgCIAAACIgFADg');
        this.shape_24.setTransform(-5.6, 3.7);

        this.shape_25 = new cjs.Shape();
        this.shape_25.graphics
            .lf(['#001511', '#112220'], [0, 1], 0.2, -1.1, 0, 0.2)
            .s()
            .p('AgEADIgLgFIAAAAIAFAAIAHAEIACAAIACAAIAEAAIACAAIACAAIADgCIgCAAIAGAAIAAABIgEACIgCAAg');
        this.shape_25.setTransform(-6.9, 3.4);

        this.shape_26 = new cjs.Shape();
        this.shape_26.graphics
            .lf(['#001511', '#112220'], [0, 1], -0.9, -4.3, -1.3, -6.4)
            .s()
            .p('AgEAAIAAgEIAKAFIAAADg');
        this.shape_26.setTransform(-7.9, 3.6);

        this.shape_27 = new cjs.Shape();
        this.shape_27.graphics
            .lf(['#001511', '#112220'], [0, 1], -0.9, -2, -0.2, -0.7)
            .s()
            .p('AgbAPIgBAAIAGgDIAEgCIADgCIgBAHgAACABIAEAAIgFACgAAEgCIADgCIACgBIABgBIAJgFIAGgDIAEACIgNAIIAAAAIgDACg');
        this.shape_27.setTransform(-12.3, 1.6);

        this.shape_28 = new cjs.Shape();
        this.shape_28.graphics
            .lf(['#001511', '#112220'], [0, 1], 0.8, -4, 2.8, -0.4)
            .s()
            .p('AgeATIgGgCIAygdIADAAIAAAUIgJAEIAHABIAAAGIgBADgAAagMIADAAIAGgDIACAMIgLAFgAAagQIAAgBIACABgAAfgVIABgBIACABIAAACg');
        this.shape_28.setTransform(-8.8, 5.3);

        this.shape_29 = new cjs.Shape();
        this.shape_29.graphics
            .lf(['#001511', '#112220'], [0, 1], 0.2, -0.5, 0.3, -1.7)
            .s()
            .p('AgCADIAAgDIABAAIAAADgAACgBIABgBIAAABg');
        this.shape_29.setTransform(-6, 3.1);

        this.shape_30 = new cjs.Shape();
        this.shape_30.graphics
            .lf(['#001511', '#112220'], [0, 1], 0.3, 0.8, 0.2, -0.9)
            .s()
            .p('AgCAAIAAgCIAEACIABADg');
        this.shape_30.setTransform(-5.7, 2.1);

        this.shape_31 = new cjs.Shape();
        this.shape_31.graphics
            .lf(['#001511', '#112220'], [0, 1], 0.1, 1, 0, -0.7)
            .s()
            .p('AgFACIAAgDIALAAIAAADg');
        this.shape_31.setTransform(-6.6, 1.9);

        this.shape_32 = new cjs.Shape();
        this.shape_32.graphics
            .lf(['#001511', '#112220'], [0, 1], 0, 0.9, -0.1, -0.8)
            .s()
            .p('AgDABIACgBIAAACIgCACgAACgCIADgBIAAADg');
        this.shape_32.setTransform(-7.7, 2.2);

        this.shape_33 = new cjs.Shape();
        this.shape_33.graphics
            .lf(['#001511', '#112220'], [0, 1], 0.4, 3.8, 0.1, 0)
            .s()
            .p('AgCAAIAAgCIAFACIgBAAIAAADg');
        this.shape_33.setTransform(-7.6, 2.4);

        this.shape_34 = new cjs.Shape();
        this.shape_34.graphics
            .f('#3C4846')
            .s()
            .p(
                'AAHAGIAAAAIgBAAIgGAAIgEgCIAAgCIAAgCIAAAAIgFgCIgDABIAAACIAAAEIACABIgFAAIAAgIIALgGIAOAAIADABIABADIgFgDIgMAAIgCACIACACIADABIAGAAIADABIACABIAAAEIAAAAIAAABIABABIADABIABABIgGAAIACABg'
            );
        this.shape_34.setTransform(-6.9, 2.5);

        this.shape_35 = new cjs.Shape();
        this.shape_35.graphics
            .lf(['#8B6D4C', '#795F41'], [0, 1], -1.8, -2.2, 5.3, 4.6)
            .s()
            .p(
                'AglACIAGgCIAPgJIAAAAIAxgcIADAWIgDgCIgPAAIgLAGIAAAJIAAAAIAAACIALAGIgyAdIgFADgAATACIgHgEIgCgBIAAgEIADgCIAFADIAAACIAAADIADABIAAACgAAigDIAAgBIAAgEIgCgCIgDgBIgHAAIgDgBIANAAIAFADIABAFIgCABIAAAAIgBABg'
            );
        this.shape_35.setTransform(-9.2, 3.4);

        this.shape_36 = new cjs.Shape();
        this.shape_36.graphics
            .lf(['#8B6D4C', '#795F41'], [0, 1], -1.1, -4.9, -1.6, -6.8)
            .s()
            .p('AgMhBIAEADIACgBIAEAbIABAGIABAFIACAVIABAEIABADIABAKIAAABIACAHIAAABIADATIADAWIgGADg');
        this.shape_36.setTransform(-3.7, 6.5);

        this.shape_37 = new cjs.Shape();
        this.shape_37.graphics
            .lf(['#001511', '#112220'], [0, 1], -0.8, -0.5, 1.8, 9.4)
            .s()
            .p('AgRAAIAHgDIAcgRIAAAGIAAAKIAAAGIggATg');
        this.shape_37.setTransform(-1.9, 3.9);

        this.shape_38 = new cjs.Shape();
        this.shape_38.graphics
            .lf(['#001511', '#112220'], [0, 1], -5.4, -5.2, -2.3, -2.2)
            .s()
            .p('AgQAHIACgBIAagPIAFADIgcAQg');
        this.shape_38.setTransform(-1.9, 2.5);

        this.shape_39 = new cjs.Shape();
        this.shape_39.graphics
            .f('#F6854E')
            .s()
            .p('AgCAHIAAgHIAAgKIAFAEIAAARg');
        this.shape_39.setTransform(-3.5, -5);

        this.shape_40 = new cjs.Shape();
        this.shape_40.graphics
            .f('#C56F47')
            .s()
            .p('AgDAJIAAgRIAHAAIAAARg');
        this.shape_40.setTransform(-2.8, -4.9);

        this.shape_41 = new cjs.Shape();
        this.shape_41.graphics
            .lf(['#001511', '#112220'], [0, 1], 0.2, 0.8, 0.1, 0.5)
            .s()
            .p('AgEACIAAgDIAJAAIAAADg');
        this.shape_41.setTransform(-2.8, -3.7);

        this.shape_42 = new cjs.Shape();
        this.shape_42.graphics
            .lf(['#001511', '#112220'], [0, 1], 0, 0.1, -0.4, -0.9)
            .s()
            .p('AgDAAIADAAIAAAAIAEgDIAAADIgHAEg');
        this.shape_42.setTransform(-1.8, -3.9);

        this.shape_43 = new cjs.Shape();
        this.shape_43.graphics
            .lf(['#001511', '#112220'], [0, 1], 0.1, 0.9, -1.4, -0.8)
            .s()
            .p('AAAAGIgDAAIAFgEIAAgHIADACIAAABIAAAEIgFACIAAABIAAABg');
        this.shape_43.setTransform(-1.9, -4.5);

        this.shape_44 = new cjs.Shape();
        this.shape_44.graphics
            .f('#A35D42')
            .s()
            .p('AgCgGIAFgEIAAAKIAAAHIgFAEg');
        this.shape_44.setTransform(-2, -5);

        this.shape_45 = new cjs.Shape();
        this.shape_45.graphics
            .lf(['#A27F5C', '#795F41'], [0, 1], -0.3, -1.6, -1.4, -5.6)
            .s()
            .p('AgUALIAAAAIAMgIIAZgNIAEACIgiATg');
        this.shape_45.setTransform(-8.6, 0);

        this.shape_46 = new cjs.Shape();
        this.shape_46.graphics
            .f('#F99E55')
            .s()
            .p('AgDAGIgHgEIAAgDIAEgDIADgBIAIAAIACABIAEADIAAADIgEACIgCACg');
        this.shape_46.setTransform(-2.8, -6.3);

        this.shape_47 = new cjs.Shape();
        this.shape_47.graphics
            .lf(['#B29F9B', '#866849'], [0, 1], -3, -0.3, -17.3, -1.8)
            .s()
            .p('AgEgCIAJgGIAAALIgJAGg');
        this.shape_47.setTransform(-5.2, -10.2);

        this.shape_48 = new cjs.Shape();
        this.shape_48.graphics
            .lf(['#001511', '#112220'], [0, 1], 8.6, -18.5, -2.8, 6)
            .s()
            .p('AgBgjIADgCIAABJIgDACg');
        this.shape_48.setTransform(-14.4, -1);

        this.shape_49 = new cjs.Shape();
        this.shape_49.graphics
            .lf(['#001511', '#112220'], [0, 1], -0.3, 0.1, 0.1, -0.8)
            .s()
            .p('AgBgBIADABIgDACg');
        this.shape_49.setTransform(-14.4, -5.4);

        this.shape_50 = new cjs.Shape();
        this.shape_50.graphics
            .lf(['#8B6D4C', '#795F41'], [0, 1], -2.1, 8.1, 1.1, -3.9)
            .s()
            .p('AgIAiIABgBIAMhFIAEADIgCANIgFAZIgCAKIAAADIAAADIgDANIgFADg');
        this.shape_50.setTransform(-12.1, -0.2);

        this.shape_51 = new cjs.Shape();
        this.shape_51.graphics
            .lf(['#B29F9B', '#866849'], [0, 1], -3, -0.3, -17.3, -1.8)
            .s()
            .p('AgEgCIAJgGIAAAIIAAABIAAACIgJAGg');
        this.shape_51.setTransform(-12.1, -6.2);

        this.shape_52 = new cjs.Shape();
        this.shape_52.graphics
            .f('#F1ECE6')
            .s()
            .p('AgoAWIAGgEIAEgCIAAAAIAEACIgLAGgAAbgRIAKgGIAEACIgKAGg');
        this.shape_52.setTransform(-8.8, -8.9);

        this.shape_53 = new cjs.Shape();
        this.shape_53.graphics
            .lf(['#001511', '#112220'], [0, 1], -0.5, 0, -0.1, -0.9)
            .s()
            .p('AgCgBIAFABIgFACg');
        this.shape_53.setTransform(-11.1, -7.3);

        this.shape_54 = new cjs.Shape();
        this.shape_54.graphics
            .f('#DACBBF')
            .s()
            .p('AgjAZIAAgGIAAgCIAAgEIADACIAAAMgAAggOIAAgMIAEADIAAALg');
        this.shape_54.setTransform(-9.3, -8);

        this.shape_55 = new cjs.Shape();
        this.shape_55.graphics
            .lf(['#001511', '#112220'], [0, 1], -0.5, 0.1, -0.1, -0.8)
            .s()
            .p('AgDgCIAGAAIAAACIgGADg');
        this.shape_55.setTransform(-13.3, -6);

        this.shape_56 = new cjs.Shape();
        this.shape_56.graphics
            .lf(['#001511', '#112220'], [0, 1], -1, 0.7, 0.1, -1.8)
            .s()
            .p('AgNAGIAAgFIAIgEIAFADIgGADIAAADgAAJgFIAAgBIAFADg');
        this.shape_56.setTransform(-12.3, -7);

        this.shape_57 = new cjs.Shape();
        this.shape_57.graphics
            .lf(['#001511', '#112220'], [0, 1], 4.8, -11.7, -6.5, 12.6)
            .s()
            .p('AgBAnIAAhNIADgDIAABTg');
        this.shape_57.setTransform(-14.4, -9.6);

        this.shape_58 = new cjs.Shape();
        this.shape_58.graphics
            .lf(['#001511', '#112220'], [0, 1], -8.7, 2.8, 2.6, -0.6)
            .s()
            .p('AgEAvIAAg/IAJAZIAAAnIgBAAIgDACgAADgdIACgBIAAAHgAgEgxIAEADIgCACg');
        this.shape_58.setTransform(-12.4, -12);

        this.shape_59 = new cjs.Shape();
        this.shape_59.graphics
            .lf(['#A27F5C', '#795F41'], [0, 1], 7.2, 30.3, -1.4, -4.1)
            .s()
            .p('AAABAIACgNIADACIAAApIgFADgAAAAXIAFgDIgFADgAAAALIAAhMIAFgDIAABSgAAFhgIAAAIIgJAGg');
        this.shape_59.setTransform(-11.4, -8.7);

        this.shape_60 = new cjs.Shape();
        this.shape_60.graphics
            .lf(['#001511', '#112220'], [0, 1], 6.9, 18.1, 0.4, 1.1)
            .s()
            .p(
                'AgNAbIgFADIAAgHIAFgCIAAhSIAFgEIAABHIAAAGIAAAGIAHgEIAAAGIgHAEIAAA+IgCAOIgDABgAAJBOIAFgaIAAAhIgBAAIgBABIgDACgAAMAEIgDgBIAAgmIAAghIAAgHIAFgCIAABNIAAAAIAAAEIAFgCIAAAGIgFADIAAAAIgCABgAgShOIAFgDIANgHIABgBIADgCIAFgDIAKgGIAAAGIglAVg'
            );
        this.shape_60.setTransform(-12.8, -7.5);

        this.shape_61 = new cjs.Shape();
        this.shape_61.graphics
            .f('#273433')
            .s()
            .p(
                'ABFCpIgEgHIAEACIAAAFgAA+CdIgFgKIgTgKIgFACIADABIgDgBIgBABIhEgoIgBAAIgHgNIAAABIBxBBIAAAJgAggBuIgDgGIAAgBIABABIBAAmIgEACgABHCDIAAAAIgDgVIAHAEIAAATgAAlBvIAAgTIAJAGIAAASgAASBDIAAgDIAEACIgEAHgAAqBDIABgDIAAAEgAg7AmIAFAEIABABIAAAOIgGAEgAgaAEIAAAKIgCABgAgkgsIADACIgDAQgAAzglIAAgEIAIAFIAAADgAgkiHIAAgIIAIgFIACAGIAAAhgAhFiHIgFgEIAAgNIAFADIAKAGIAAANgAgkioIACAFIgCABg'
            );
        this.shape_61.setTransform(-9.2, -0.1);

        this.shape_62 = new cjs.Shape();
        this.shape_62.graphics
            .f('#E5BB76')
            .s()
            .p(
                'AA8DBIAAgEIAAgPIgJgQIgJgFIgFgDIgFACIgFADIAAATIhHgqIAAgHIAAgSIgNgWIgOgIIAAgHIAQAKIARAcIAAAVIA8AjIAAgGIgzgeIAAgLIgCgFIA6AiIAEgCIhAgmIgBgBIgBgDIBEAoIABAAIADABIAQAJIANAXIAAAVgAArC3QgHgEAAgJIABgBQAAgBAAAAQAAgBAAAAQABgBAAAAQAAAAAAAAQABAAAAgBQABAAAAAAQABAAAAAAQAAABABAAIABAAQAIAEAAAJQAAAGgDAAIgFgCgAAoCoQgBAAAAAAQAAABgBAAQAAABAAAAQAAABAAAAQAAAIAFACQAGAEABgHQgBgHgGgDIgCgBIgBABgAArCzQgDgCAAgFQAAAAAAgBQAAAAAAAAQAAgBAAAAQABAAAAAAIACAAQAEACAAAFQAAABAAABQAAAAAAAAQAAABAAAAQgBAAAAAAIgDgBgABGCrIAAAAIAAABgAgrBaIgDgHIgBAAIgDgGIgHgEIAAgEIB/BKIAAAMgAAvB8IAAgFIgkgVIAHgTIABgEIAEgHIAAgBIAXAOIgCgLIAAgDIgBgEIgBgJIAAgCIgCgLIAAgDIAAgBIgBgBIAAgBIAAgBIgBgBIAAgGIgBgDIAAgDIgDgVIgBgCIgFgCIgEgDIgigUIgFgDIgDgBIgEgDIgNBFIgBABIAAADIAAAlIgRgKIACgHIADgQIABgCIABgGIABgHIACgNIAIgnIADgQIgDgCIgBAAIAAgJIAEACIBPAuIAAAIIgEgCIAUCDgAAmBxIAJAFIAAgSIgJgFgAhBB1QgKgGAAgLQAAgFACgBQADgCAFACQADACAEAGQADAFAAAEQAAAFgDACIgDABIgEgCgAhHBgQgCACAAADQAAAKAIADQADACACgBQADgBAAgEQgBgJgHgEIgEgBIgCAAgABFBwIgDgUIgDgCIAEACIAJAGIAAASgAhBBwQgGgDAAgGQAAgGAGACQAFAEAAAGQAAAAAAABQAAAAAAABQgBAAAAABQAAAAgBAAIgBABIgCgBgAhEiFIAKAFIAACjIAAAAIgFADIAAAcIgFADgAhEiTIAAgXIAHAAIAIACIgFADIAAAYgAgZjDIAPADIgFADIAAAJIgKAOg'
            );
        this.shape_62.setTransform(-9.3, -0.4);

        this.shape_63 = new cjs.Shape();
        this.shape_63.graphics
            .lf(['#A27F5C', '#795F41'], [0, 1], -1.5, -3.8, 7.8, 33.5)
            .s()
            .p(
                'AgXByIAAijIAFgDIAABOIAAAFIAAAGIAABKIgFADIABAAIgBAAgAATAwIAFADIAAAkIgFACgAATAJIAAhSIAFgDIAABZIgFACgAgXhWIAFgDIAAASIAAAGIgFADgAAThdIAAgIIAAgJIAFgDIAAAXIgFADg'
            );
        this.shape_63.setTransform(-12.8, -8.3);

        this.shape_64 = new cjs.Shape();
        this.shape_64.graphics
            .lf(['#001511', '#112220'], [0, 1], -0.6, -2.4, 2.2, 8.8)
            .s()
            .p('AgcAKIAFgDIAlgUIAFgEIAKgFIAAANIgKAGIgFADIgFACIgFADIgCABIgHAEIgIAFIgFADIgFACIgFAEg');
        this.shape_64.setTransform(-12.3, -15.6);

        this.shape_65 = new cjs.Shape();
        this.shape_65.graphics
            .lf(['#A27F5C', '#795F41'], [0, 1], -3.9, -6.4, 3.9, 7.1)
            .s()
            .p('AgwAeIAFgCIAAgBIBXgxIAFgDIAAAWIhhA3gAgrATIBXgxIAAACIhXAygAgrAAIAOgIIApgYIAUgLIAEgDIAIgFIAAAMIhXAyg');
        this.shape_65.setTransform(2.2, 14.1);

        this.shape_66 = new cjs.Shape();
        this.shape_66.graphics
            .lf(['#E5BB76', '#907051'], [0, 1], -11.1, 6.4, -5.7, 3.3)
            .s()
            .p('AAEAGIAAgCIAAgCIAFAIIgFACgAgHgIIAEgDIgEADg');
        this.shape_66.setTransform(6.2, 10.6);

        this.shape_67 = new cjs.Shape();
        this.shape_67.graphics
            .lf(['#001511', '#112220'], [0, 1], 2.2, 8.2, -0.8, -2.9)
            .s()
            .p('AgrAdIBXgyIAAAFIhXAxgAgrARIBXgxIAAAGIAAACIhXAyg');
        this.shape_67.setTransform(2.2, 13.4);

        this.shape_68 = new cjs.Shape();
        this.shape_68.graphics
            .lf(['#001511', '#112220'], [0, 1], 1.8, 6.7, -0.6, -2.4)
            .s()
            .p('AghAKIBDgmIAAAHIAAAMIhDAmg');
        this.shape_68.setTransform(1.7, 10.2);

        this.shape_69 = new cjs.Shape();
        this.shape_69.graphics
            .lf(['#8B6D4C', '#795F41'], [0, 1], -0.7, -0.3, 2, 4.6)
            .s()
            .p('AghAKIAJgEIAGgEIANgGIAGgFIAhgTIAAASIhDAng');
        this.shape_69.setTransform(1.7, 8.4);

        this.shape_70 = new cjs.Shape();
        this.shape_70.graphics
            .f('#4F5552')
            .s()
            .p(
                'Ag0AzIgGgEIAFADIAtADIgHATgAA/BAIABAAIgGADgAAlA6IgDgCIgBgKIAIgEIAGAAIALgGIATALIAJgFIgJAGIgLAGIgRAKgAAEAlIgHAFIAAABIgEgCIAAADIgGgBIAJgFIAAACIADgCIACgCIADgBIAAgCIALgGIAAACIgNAHIACAAIAMABIABAEIgBADgAhQATIgFgEIALAAIgBACIgEACgAAbAMIADgBIAFACIgHAEgAAKAIIAAAAIACABIAAAAgAgqgOIAFgDIgJAFIgBABgAAhg7IgEgDIgEgCIAAgGIACgBIAAAHIAHADIAJAAIADAAIgDACgAAvg+IAFgCIgFADg'
            );
        this.shape_70.setTransform(-6.6, 2.2);

        this.shape_71 = new cjs.Shape();
        this.shape_71.graphics
            .lf(['#A27F5C', '#795F41'], [0, 1], -1.2, -2.4, 2.2, 4.3)
            .s()
            .p('AAIATIACgBIgIAEgAgJgVIAGAEIgGADg');
        this.shape_71.setTransform(0.9, 5.6);

        this.shape_72 = new cjs.Shape();
        this.shape_72.graphics
            .lf(['#001511', '#112220'], [0, 1], -1.7, -1.4, -1, -0.3)
            .s()
            .p('AgNADIgKAGIgHAAIgBAAIAngWIAXANIgRAJIgJAFg');
        this.shape_72.setTransform(0.6, 5.5);

        this.shape_73 = new cjs.Shape();
        this.shape_73.graphics
            .lf(['#8B6D4C', '#795F41'], [0, 1], 0.4, -6.1, -1.3, -3.7)
            .s()
            .p('AABAlIgLhKIAIgFIANBVg');
        this.shape_73.setTransform(2.7, 0.4);

        this.shape_74 = new cjs.Shape();
        this.shape_74.graphics
            .lf(['#8B6D4C', '#795F41'], [0, 1], -0.9, -3, -1.4, -4.9)
            .s()
            .p('AAEArIgNhVIAGgDIANBbg');
        this.shape_74.setTransform(3.4, 0.4);

        this.shape_75 = new cjs.Shape();
        this.shape_75.graphics
            .lf(['#A27F5C', '#795F41'], [0, 1], 1.1, 4.4, 3.2, 12.9)
            .s()
            .p('AgmASIBOgsIAAAJIgEACIgFADIgIAEIg8AiIgBABg');
        this.shape_75.setTransform(-0.6, -2.6);

        this.shape_76 = new cjs.Shape();
        this.shape_76.graphics
            .f('#A27F5C')
            .s()
            .p(
                'AAPBzIBFgnIAAgMIAOAIIgIAFIgFADIgUAMIgpAXgAAIBvIADACIgIABgAACBGIgBgHIACAAIAMAHIARgKIATgDIgCABIgGAEIgNAHIAAAAIgYADgAArA1IAJgFIARgKIgXgOIgoAXIgHAAIAAgDIAggTIAGgEIgGgDIAAgKIAdARIAKAGIAGADIAIAEIghATgAhhA4IAFgDIAHAEgAgGAMIAGADIgDABIgCACgAgXANIACAAIAAABgAAKgyIAIgFIAAgDIgFADIAAgBIAFgCIAAgGIAMAAIAGAEIAAAFIgDACIgDABIgOAAIgCACgAgIg6IAEACIAEACgAhdhFIALgGIAAgCIAHAAIAEACIgKAGgAgYhsIAKgGIAGADIgEADg'
            );
        this.shape_76.setTransform(-3.2, 1.6);

        this.shape_77 = new cjs.Shape();
        this.shape_77.graphics
            .f('#FDE685')
            .s()
            .p(
                'AhBBdIAJAAIgFgDIAFACIAzAeIAAAGgAAKBrIgDgCIAFgCIASALIgEACgAhUAhIAAAEIAHAEIgFADIgQgKIADgBIAFgDIAFgDIAGgDIABgBIgCAHIARAKIALABIAlAVIAjAVIAAAFIAQAKIAJgBIAAAAIAEACIAIAAIgOAIgAAnA4IAYgDIgFAEIgJAFgAAiAvIAAgBIADABgAgEAfIAIgFIAMAHIABABIACALgABNAlIAHAEIgSADgAAgAfIAIAAIAAAAIgHAFgAg3gMIAEgDIAHgEIAEgCIAHABIAigUIAFACIAAACIgwAcIgBABIgPAHgAg7hVIALAAIALgGIgEgCIgIAAIAAgCIACgBIAFgDIAFgCIAqgZIAEACIALAAIAFgDIBKArIhPAtgAAehjIgDACIAAAFIAAAKIgCABIAAAHIAAADIAHAFIALAAIAEAAIADgCIANAAIAEgBIADgCIAAgFIgHgEIgMAAIAAgBIgDgBIAAgKIAAgFIgDgCIgDgCIgIAAgAAthbIADgBIgGADg'
            );
        this.shape_77.setTransform(-6.6, 3.2);

        this.shape_78 = new cjs.Shape();
        this.shape_78.graphics
            .f('rgba(97,94,97,0.4)')
            .s()
            .p(
                'AglBtIgGgDIACgBQgPgBgLgIQgGgDABgCQAAgDAHAAIABAAIgDgBIgIAAIhJgqIADgBIgMgDQgMgDgIgFQgIgFABgDQABgDAJAAQAWAAATALQAIAFgBADIAAABIAEAAIAAgBIABgDIgOgIIAFgDIAHAAIAIAFIAFAAIAegRIgYAAIgHAEIgLAAIgFgDIACgBIgHAAIgHAEIgYAAIgkgUICLhDIgHgoIBMAAIBbA0IggATIAaAAIAEgDIAOAAIAEADIAIAAIAKAGIgFADIgHAAIgCABIAEACIgFADIgIAAIgNAIIADACIgFADIgHAAIgCABIAEACIgCABIAQABIADgBIAUAAIAEACIgFADIBJAqIhOAuIgJAAIgEgCIgiAEIgPAIIgcAAIgPAJIgcAAIgEACgAguBGIABAAIgRgKgAAMACIApAYIAogXIgmgCIgDgBIgggCgAAkgSIAZAAIAHgEIgZAAg'
            );
        this.shape_78.setTransform(1.9, 9.1);

        this.timeline.addTween(
            cjs.Tween.get({})
                .to({
                    state: [
                        {t: this.shape_78},
                        {t: this.shape_77},
                        {t: this.shape_76},
                        {t: this.shape_75},
                        {t: this.shape_74},
                        {t: this.shape_73},
                        {t: this.shape_72},
                        {t: this.shape_71},
                        {t: this.shape_70},
                        {t: this.shape_69},
                        {t: this.shape_68},
                        {t: this.shape_67},
                        {t: this.shape_66},
                        {t: this.shape_65},
                        {t: this.shape_64},
                        {t: this.shape_63},
                        {t: this.shape_62},
                        {t: this.shape_61},
                        {t: this.shape_60},
                        {t: this.shape_59},
                        {t: this.shape_58},
                        {t: this.shape_57},
                        {t: this.shape_56},
                        {t: this.shape_55},
                        {t: this.shape_54},
                        {t: this.shape_53},
                        {t: this.shape_52},
                        {t: this.shape_51},
                        {t: this.shape_50},
                        {t: this.shape_49},
                        {t: this.shape_48},
                        {t: this.shape_47},
                        {t: this.shape_46},
                        {t: this.shape_45},
                        {t: this.shape_44},
                        {t: this.shape_43},
                        {t: this.shape_42},
                        {t: this.shape_41},
                        {t: this.shape_40},
                        {t: this.shape_39},
                        {t: this.shape_38},
                        {t: this.shape_37},
                        {t: this.shape_36},
                        {t: this.shape_35},
                        {t: this.shape_34},
                        {t: this.shape_33},
                        {t: this.shape_32},
                        {t: this.shape_31},
                        {t: this.shape_30},
                        {t: this.shape_29},
                        {t: this.shape_28},
                        {t: this.shape_27},
                        {t: this.shape_26},
                        {t: this.shape_25},
                        {t: this.shape_24},
                        {t: this.shape_23},
                        {t: this.shape_22},
                        {t: this.shape_21},
                        {t: this.shape_20},
                        {t: this.shape_19},
                        {t: this.shape_18},
                        {t: this.shape_17},
                        {t: this.shape_16},
                        {t: this.shape_15},
                        {t: this.shape_14},
                        {t: this.shape_13},
                        {t: this.shape_12},
                        {t: this.shape_11},
                        {t: this.shape_10},
                        {t: this.shape_9},
                        {t: this.shape_8},
                        {t: this.shape_7},
                        {t: this.shape_6},
                        {t: this.shape_5},
                        {t: this.shape_4},
                        {t: this.shape_3},
                        {t: this.shape_2},
                        {t: this.shape_1},
                        {t: this.shape},
                        {t: this.instance}
                    ]
                })
                .wait(1)
        );
    }).prototype = getMCSymbolPrototype(lib.Symbol52, (rect = new cjs.Rectangle(-21.8, -20, 43.8, 40.1)), [rect]);

    (lib.Symbol12 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Symbol 5
        this.instance = new lib.Symbol5();
        this.instance.parent = this;
        this.instance.setTransform(-0.3, -5.9, 1, 1, 0, -55, 164, 0, -0.1);
        this.instance.alpha = 0.422;

        this.timeline.addTween(
            cjs.Tween.get(this.instance)
                .to({x: -13.6, y: 1.6}, 14, cjs.Ease.quadInOut)
                .wait(1)
        );

        // Layer_6
        this.instance_1 = new lib.Symbol13();
        this.instance_1.parent = this;
        this.instance_1.setTransform(2.4, -0.3);

        this.timeline.addTween(
            cjs.Tween.get(this.instance_1)
                .to({x: -10.9, y: 7.2}, 14, cjs.Ease.quadInOut)
                .wait(1)
        );

        // Symbol 4
        this.instance_2 = new lib.Symbol4();
        this.instance_2.parent = this;
        this.instance_2.setTransform(21.5, -4.3);

        this.timeline.addTween(
            cjs.Tween.get(this.instance_2)
                .to({_off: true}, 14)
                .wait(1)
        );

        // Symbol 8
        this.instance_3 = new lib.Symbol8();
        this.instance_3.parent = this;
        this.instance_3.setTransform(11.1, 5, 1, 1, 0, 0, 180);

        this.timeline.addTween(
            cjs.Tween.get(this.instance_3)
                .to({x: -2.2, y: 12.6}, 14, cjs.Ease.quadInOut)
                .wait(1)
        );

        // Symbol 11
        this.instance_4 = new lib.Symbol11();
        this.instance_4.parent = this;
        this.instance_4.setTransform(16.4, 3.8);

        this.timeline.addTween(
            cjs.Tween.get(this.instance_4)
                .to({x: 3.1, y: 11.4}, 14, cjs.Ease.quadInOut)
                .wait(1)
        );

        // Layer_8
        this.instance_5 = new lib.Symbol14();
        this.instance_5.parent = this;
        this.instance_5.setTransform(10.5, 9.9);

        this.timeline.addTween(
            cjs.Tween.get(this.instance_5)
                .to({x: -2.8, y: 17.4}, 14, cjs.Ease.quadInOut)
                .wait(1)
        );
    }).prototype = p = new cjs.MovieClip();
    p.nominalBounds = rect = new cjs.Rectangle(-19.3, -20, 53.5, 40.8);
    p.frameBounds = [
        rect,
        new cjs.Rectangle(-19.5, -19.9, 53.7, 40.8),
        new cjs.Rectangle(-19.9, -19.7, 54.1, 40.8),
        new cjs.Rectangle(-20.5, -19.3, 54.8, 40.8),
        new cjs.Rectangle(-21.5, -18.7, 55.7, 40.8),
        new cjs.Rectangle(-22.7, -18, 57, 40.8),
        new cjs.Rectangle(-24.2, -17.8, 58.5, 41.4),
        new cjs.Rectangle(-26, -17.8, 60.2, 42.4),
        new cjs.Rectangle(-27.7, -17.8, 62, 43.4),
        new cjs.Rectangle(-29.2, -17.8, 63.5, 44.2),
        new cjs.Rectangle(-30.5, -17.8, 64.7, 44.9),
        new cjs.Rectangle(-31.4, -17.8, 65.7, 45.5),
        new cjs.Rectangle(-32.1, -17.8, 66.3, 45.9),
        new cjs.Rectangle(-32.5, -17.8, 66.7, 46.1),
        new cjs.Rectangle(-32.6, -12.4, 49.8, 40.8)
    ];

    (lib.Symbol7 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.instance = new lib.Symbol52();
        this.instance.parent = this;
        this.instance.setTransform(1.3, 0);

        this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));
    }).prototype = getMCSymbolPrototype(lib.Symbol7, (rect = new cjs.Rectangle(-20.6, -20, 43.8, 40.1)), [rect]);

    (lib.Symbol10 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Symbol 7
        this.instance = new lib.Symbol7();
        this.instance.parent = this;
        this.instance.setTransform(25, 15);

        this.timeline.addTween(
            cjs.Tween.get(this.instance)
                .to({x: 3.6, y: 2.3}, 24, cjs.Ease.cubicInOut)
                .wait(15)
                .to({x: 25, y: 15}, 14, cjs.Ease.quadInOut)
                .wait(1)
        );

        // Symbol 8
        this.instance_1 = new lib.Symbol8();
        this.instance_1.parent = this;
        this.instance_1.setTransform(12.2, 19.6);

        this.timeline.addTween(
            cjs.Tween.get(this.instance_1)
                .to({x: -9.2, y: 6.9}, 24, cjs.Ease.cubicInOut)
                .to({y: -4.2}, 14, cjs.Ease.cubicInOut)
                .wait(1)
                .to({y: -3.7}, 0)
                .to({x: 12.2, y: 19.6}, 14, cjs.Ease.quadInOut)
                .wait(1)
        );

        // Symbol 4
        this.instance_2 = new lib.Symbol4();
        this.instance_2.parent = this;
        this.instance_2.setTransform(-14, -1.6);

        this.timeline.addTween(
            cjs.Tween.get(this.instance_2)
                .wait(24)
                .to({y: -12.7}, 14, cjs.Ease.cubicInOut)
                .to({_off: true}, 1)
                .wait(15)
        );

        // Symbol 9
        this.instance_3 = new lib.Symbol9();
        this.instance_3.parent = this;
        this.instance_3.setTransform(6.8, 18.3);

        this.timeline.addTween(
            cjs.Tween.get(this.instance_3)
                .to({x: -14.6, y: 5.6}, 24, cjs.Ease.cubicInOut)
                .to({y: -5.5}, 14, cjs.Ease.cubicInOut)
                .wait(1)
                .to({y: -5}, 0)
                .to({x: 6.8, y: 18.3}, 14, cjs.Ease.quadInOut)
                .wait(1)
        );
    }).prototype = p = new cjs.MovieClip();
    p.nominalBounds = rect = new cjs.Rectangle(-26.7, -15, 74.8, 50.1);
    p.frameBounds = [
        rect,
        rect,
        new cjs.Rectangle(-26.7, -15, 74.8, 50),
        new cjs.Rectangle(-26.7, -15, 74.7, 50),
        new cjs.Rectangle(-26.7, -15, 74.4, 49.8),
        new cjs.Rectangle(-26.7, -15, 74.1, 49.6),
        new cjs.Rectangle(-26.7, -15, 73.5, 49.3),
        new cjs.Rectangle(-26.7, -15, 72.7, 48.8),
        new cjs.Rectangle(-26.7, -15, 71.7, 48.2),
        new cjs.Rectangle(-26.7, -15, 70.3, 47.4),
        new cjs.Rectangle(-26.7, -15, 68.6, 46.4),
        new cjs.Rectangle(-26.7, -15, 66.6, 45.2),
        new cjs.Rectangle(-26.7, -15, 64.1, 43.8),
        new cjs.Rectangle(-26.7, -15, 61.7, 42.3),
        new cjs.Rectangle(-26.7, -15, 59.6, 41.1),
        new cjs.Rectangle(-26.7, -15, 57.9, 40.1),
        new cjs.Rectangle(-26.7, -15.8, 56.6, 40.1),
        new cjs.Rectangle(-26.7, -16.4, 55.5, 40.1),
        new cjs.Rectangle(-26.7, -16.9, 54.8, 40.1),
        new cjs.Rectangle(-26.7, -17.2, 54.2, 40.1),
        new cjs.Rectangle(-26.7, -17.4, 53.8, 40.1),
        new cjs.Rectangle(-26.7, -17.6, 53.6, 40.1),
        new cjs.Rectangle(-26.7, -17.6, 53.5, 40.1),
        (rect = new cjs.Rectangle(-26.7, -17.7, 53.4, 40.1)),
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        new cjs.Rectangle(-26.7, -18.5, 53.4, 40.9),
        new cjs.Rectangle(-26.7, -20.6, 53.4, 43),
        new cjs.Rectangle(-26.7, -22.6, 53.4, 45),
        new cjs.Rectangle(-26.7, -24.1, 53.4, 46.5),
        new cjs.Rectangle(-26.7, -25.1, 53.4, 47.5),
        new cjs.Rectangle(-26.7, -25.7, 53.4, 48.1),
        new cjs.Rectangle(-26.7, -26, 53.4, 48.4),
        (rect = new cjs.Rectangle(-26.7, -26.1, 53.4, 48.5)),
        rect,
        new cjs.Rectangle(-24.7, -17.7, 51.4, 40.1),
        new cjs.Rectangle(-24.5, -17.5, 51.4, 40.1),
        new cjs.Rectangle(-23.8, -17.2, 51.4, 40.1),
        new cjs.Rectangle(-22.7, -16.5, 51.4, 40.1),
        new cjs.Rectangle(-21.2, -15.6, 51.4, 40.1),
        new cjs.Rectangle(-19.2, -14.4, 51.4, 40.1),
        new cjs.Rectangle(-16.8, -13, 51.4, 40.1),
        new cjs.Rectangle(-14, -11.3, 51.4, 40.1),
        new cjs.Rectangle(-11.1, -9.7, 51.4, 40.1),
        new cjs.Rectangle(-8.7, -8.3, 51.4, 40.1),
        new cjs.Rectangle(-6.8, -7.1, 51.4, 40.1),
        new cjs.Rectangle(-5.2, -6.2, 51.4, 40.1),
        new cjs.Rectangle(-4.1, -5.5, 51.4, 40.1),
        new cjs.Rectangle(-3.5, -5.2, 51.4, 40.1),
        new cjs.Rectangle(-3.3, -5, 51.4, 40.1)
    ];

    (lib.pogrezchik = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_113 (mask)
        let mask = new cjs.Shape();
        mask._off = true;
        mask.graphics.p('AiEBwIAAl5IEJCaIAAF5g');
        mask.setTransform(74.1, -82.6);

        // Layer_112
        this.instance = new lib.Symbol15();
        this.instance.parent = this;
        this.instance.setTransform(76.4, -82.1);

        var maskedShapeInstanceList = [this.instance];

        for (var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
            maskedShapeInstanceList[shapedInstanceItr].mask = mask;
        }

        this.timeline.addTween(
            cjs.Tween.get(this.instance)
                .to({y: -122.5}, 9, cjs.Ease.quadInOut)
                .wait(176)
                .to({y: -82.1}, 9)
                .wait(1)
        );

        // Layer_114 (mask)
        let mask_1 = new cjs.Shape();
        mask_1._off = true;
        mask_1.graphics.p('ApqKgIjCitID4lnIRXtXIEKCaIAAF6IxWNXIheAsg');
        mask_1.setTransform(6.2, -37.6);

        // Layer_110
        this.instance_1 = new lib.Symbol12('single', 0);
        this.instance_1.parent = this;
        this.instance_1.setTransform(100.9, -88.1);

        var maskedShapeInstanceList = [this.instance_1];

        for (var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
            maskedShapeInstanceList[shapedInstanceItr].mask = mask_1;
        }

        this.timeline.addTween(
            cjs.Tween.get(this.instance_1)
                .to({x: -35.6, y: 1.9}, 40)
                .wait(1)
                .to({mode: 'synched', loop: false}, 0)
                .wait(14)
                .to({mode: 'single', startPosition: 14}, 0)
                .wait(88)
                .to({startPosition: 14}, 0)
                .to({x: 115.9, y: -97.6}, 51, cjs.Ease.quadInOut)
                .wait(1)
        );

        // Layer_117 (mask)
        let mask_2 = new cjs.Shape();
        mask_2._off = true;
        mask_2.graphics.p('ApMBKIAqgYIAsAaIAIgHIAAjRIhdg5IHbj7IK9GBIiSEbImHDlg');
        mask_2.setTransform(5.2, -12.8);

        // Layer_109
        this.instance_2 = new lib.Symbol10('single', 53);
        this.instance_2.parent = this;
        this.instance_2.setTransform(-0.1, -0.8);

        var maskedShapeInstanceList = [this.instance_2];

        for (var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
            maskedShapeInstanceList[shapedInstanceItr].mask = mask_2;
        }

        this.timeline.addTween(
            cjs.Tween.get(this.instance_2)
                .wait(55)
                .to({startPosition: 0}, 0)
                .wait(4)
                .to({y: -0.9, mode: 'synched', startPosition: 1, loop: false}, 0)
                .wait(37)
                .to({mode: 'single', startPosition: 38}, 0)
                .to({x: -37.6, y: -20.8}, 14, cjs.Ease.quadInOut)
                .wait(1)
                .to({startPosition: 39}, 0)
                .wait(7)
                .to({mode: 'synched', loop: false}, 0)
                .to({x: -0.1, y: -0.8, mode: 'single', startPosition: 53}, 25, cjs.Ease.quadInOut)
                .wait(52)
        );
    }).prototype = p = new cjs.MovieClip();
    p.nominalBounds = rect = new cjs.Rectangle(-3.4, -109.2, 90.9, 141.4);
    p.frameBounds = [
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        new cjs.Rectangle(-3.7, -109.2, 91.2, 141.4),
        new cjs.Rectangle(-7.1, -109.2, 94.6, 141.4),
        new cjs.Rectangle(-10.5, -109.2, 98, 141.4),
        new cjs.Rectangle(-14, -109.2, 101.5, 141.4),
        new cjs.Rectangle(-17.4, -109.2, 104.9, 141.4),
        new cjs.Rectangle(-20.8, -109.2, 108.3, 141.4),
        new cjs.Rectangle(-24.2, -109.2, 111.7, 141.4),
        new cjs.Rectangle(-27.6, -109.2, 115.1, 141.4),
        new cjs.Rectangle(-31, -109.2, 118.5, 141.4),
        new cjs.Rectangle(-34.4, -109.2, 121.9, 141.4),
        new cjs.Rectangle(-37.9, -109.2, 125.4, 141.4),
        new cjs.Rectangle(-41.3, -109.2, 128.8, 141.4),
        new cjs.Rectangle(-44.7, -109.2, 132.2, 141.4),
        new cjs.Rectangle(-48.1, -109.2, 135.6, 141.4),
        new cjs.Rectangle(-51.5, -109.2, 139, 141.4),
        (rect = new cjs.Rectangle(-54.9, -109.2, 142.4, 141.4)),
        rect,
        new cjs.Rectangle(-55.1, -109.2, 142.6, 141.4),
        new cjs.Rectangle(-55.5, -109.2, 143, 141.4),
        new cjs.Rectangle(-56.2, -109.2, 143.7, 141.4),
        new cjs.Rectangle(-57.1, -109.2, 144.6, 141.4),
        new cjs.Rectangle(-58.4, -109.2, 145.9, 141.4),
        new cjs.Rectangle(-59.9, -109.2, 147.4, 141.4),
        new cjs.Rectangle(-61.6, -109.2, 149.1, 141.4),
        new cjs.Rectangle(-63.4, -109.2, 150.9, 141.4),
        new cjs.Rectangle(-64.9, -109.2, 152.4, 141.4),
        new cjs.Rectangle(-66.1, -109.2, 153.6, 141.4),
        new cjs.Rectangle(-67.1, -109.2, 154.6, 141.4),
        new cjs.Rectangle(-67.7, -109.2, 155.2, 141.4),
        new cjs.Rectangle(-68.1, -109.2, 155.6, 141.4),
        (rect = new cjs.Rectangle(-68.2, -109.2, 155.7, 141.4)),
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        new cjs.Rectangle(-68.2, -109.2, 155.7, 140.6),
        new cjs.Rectangle(-68.2, -109.2, 155.7, 139.6),
        (rect = new cjs.Rectangle(-68.2, -109.2, 155.7, 139.4)),
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        new cjs.Rectangle(-68.2, -109.2, 155.7, 140.2),
        new cjs.Rectangle(-68.2, -109.2, 155.7, 141.1),
        (rect = new cjs.Rectangle(-68.2, -109.2, 155.7, 141.4)),
        rect,
        rect,
        rect,
        rect,
        rect,
        new cjs.Rectangle(-68.1, -109.2, 155.6, 141.4),
        new cjs.Rectangle(-67.8, -109.2, 155.3, 141.4),
        new cjs.Rectangle(-67.2, -109.2, 154.7, 141.4),
        new cjs.Rectangle(-66.4, -109.2, 153.9, 141.4),
        new cjs.Rectangle(-65.3, -109.2, 152.8, 141.4),
        new cjs.Rectangle(-64, -109.2, 151.5, 141.4),
        new cjs.Rectangle(-62.5, -109.2, 150, 141.4),
        new cjs.Rectangle(-60.8, -109.2, 148.3, 141.4),
        new cjs.Rectangle(-58.8, -109.2, 146.3, 141.4),
        new cjs.Rectangle(-56.6, -109.2, 144.1, 141.4),
        new cjs.Rectangle(-54.1, -109.2, 141.6, 141.4),
        new cjs.Rectangle(-51.4, -109.2, 138.9, 141.4),
        new cjs.Rectangle(-48.5, -109.2, 136, 141.4),
        new cjs.Rectangle(-45.4, -109.2, 132.9, 141.4),
        new cjs.Rectangle(-42, -109.2, 129.5, 141.4),
        new cjs.Rectangle(-38.4, -109.2, 125.9, 141.4),
        new cjs.Rectangle(-34.5, -109.2, 122, 141.4),
        new cjs.Rectangle(-30.5, -109.2, 118, 141.4),
        new cjs.Rectangle(-26.2, -109.2, 113.7, 141.4),
        new cjs.Rectangle(-21.6, -109.2, 109.1, 141.4),
        new cjs.Rectangle(-16.8, -109.2, 104.3, 141.4),
        new cjs.Rectangle(-11.8, -109.2, 99.3, 141.4),
        new cjs.Rectangle(-6.6, -109.2, 94.1, 141.4),
        (rect = new cjs.Rectangle(-3.4, -109.2, 90.9, 141.4)),
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect,
        rect
    ];

    // stage content:
    (lib.main = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_3
        this.instance = new lib.Symbol20();
        this.instance.parent = this;
        this.instance.setTransform(3260.4, 1119.3, 1.601, 1.601);

        this.instance_1 = new lib.Symbol55();
        this.instance_1.parent = this;
        this.instance_1.setTransform(3345, 910.7, 1.601, 1.601);

        this.timeline.addTween(
            cjs.Tween.get({})
                .to({state: [{t: this.instance_1}, {t: this.instance}]})
                .wait(1)
        );

        // Symbol 28
        this.instance_2 = new lib.Symbol28();
        this.instance_2.parent = this;
        this.instance_2.setTransform(1570.3, 722.9, 1.601, 1.601);

        this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

        // truba
        this.instance_3 = new lib.truba();
        this.instance_3.parent = this;
        this.instance_3.setTransform(2252.9, 1555.1, 1.601, 1.601);

        this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1));

        // truba
        this.instance_4 = new lib.truba();
        this.instance_4.parent = this;
        this.instance_4.setTransform(2172.9, 1508.1, 1.601, 1.601);

        this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(1));

        // tr
        this.tr = new lib.pogrezchik();
        this.tr.name = 'tr';
        this.tr.parent = this;
        this.tr.setTransform(714.2, 1244.2, 1.601, 1.601);

        this.timeline.addTween(cjs.Tween.get(this.tr).wait(1));

        // Layer_1
        this.instance_5 = new lib.map11();
        this.instance_5.parent = this;

        this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(1));
    }).prototype = p = new cjs.MovieClip();
    p.nominalBounds = rect = new cjs.Rectangle(2000, 1197, 4000, 2394);
    p.frameBounds = [rect];
    // library properties:
    lib.properties = {
        id: 'F94D055E7C2242DB9C0B9E86AEC87EAA',
        width: 4000,
        height: 2394,
        fps: 25,
        color: '#A8EBA8',
        opacity: 1.0,
        manifest: [{src: './img/map11.png', id: 'map11'}],
        preloads: []
    };

    // bootstrap callback support:

    (lib.Stage = function(canvas) {
        createjs.Stage.call(this, canvas);
    }).prototype = p = new createjs.Stage();

    p.setAutoPlay = function(autoPlay) {
        this.tickEnabled = autoPlay;
    };
    p.play = function() {
        this.tickEnabled = true;
        this.getChildAt(0).gotoAndPlay(this.getTimelinePosition());
    };
    p.stop = function(ms) {
        if (ms) this.seek(ms);
        this.tickEnabled = false;
    };
    p.seek = function(ms) {
        this.tickEnabled = true;
        this.getChildAt(0).gotoAndStop((lib.properties.fps * ms) / 1000);
    };
    p.getDuration = function() {
        return (this.getChildAt(0).totalFrames / lib.properties.fps) * 1000;
    };

    p.getTimelinePosition = function() {
        return (this.getChildAt(0).currentFrame / lib.properties.fps) * 1000;
    };

    an.bootcompsLoaded = an.bootcompsLoaded || [];
    if (!an.bootstrapListeners) {
        an.bootstrapListeners = [];
    }

    an.bootstrapCallback = function(fnCallback) {
        an.bootstrapListeners.push(fnCallback);
        if (an.bootcompsLoaded.length > 0) {
            for (let i = 0; i < an.bootcompsLoaded.length; ++i) {
                fnCallback(an.bootcompsLoaded[i]);
            }
        }
    };

    an.compositions = an.compositions || {};
    an.compositions['F94D055E7C2242DB9C0B9E86AEC87EAA'] = {
        getStage: function() {
            return exportRoot.getStage();
        },
        getLibrary: function() {
            return lib;
        },
        getSpriteSheet: function() {
            return ss;
        },
        getImages: function() {
            return img;
        }
    };

    an.compositionLoaded = function(id) {
        an.bootcompsLoaded.push(id);
        for (let j = 0; j < an.bootstrapListeners.length; j++) {
            an.bootstrapListeners[j](id);
        }
    };

    an.getComposition = function(id) {
        return an.compositions[id];
    };
})((createjs), (AdobeAn = AdobeAn || {}));
/* eslint-enable */
const composition = AdobeAn.getComposition('F94D055E7C2242DB9C0B9E86AEC87EAA');

export {AdobeAn};
export {composition};
